var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS1P2New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.76 234.16C250.76 234.16 250.68 234.15 250.65 234.14C250.62 234.14 250.58 234.15 250.55 234.16C250.62 234.16 250.69 234.16 250.76 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.4 234.11C315.11 234.17 327.02 234.22 335.29 234.25C339.39 234.3 342.57 234.33 344.78 234.35C345.84 234.37 346.66 234.39 347.25 234.4C347.81 234.42 348.09 234.44 348.09 234.45C348.09 234.47 347.8 234.48 347.25 234.5C346.66 234.5 345.85 234.52 344.78 234.54C342.58 234.54 339.39 234.56 335.29 234.57C327.02 234.54 315.11 234.5 300.4 234.45C288.82 234.36 275.51 234.25 260.89 234.13C257.7 234.13 254.45 234.13 251.14 234.13C251.19 234.13 251.24 234.15 251.28 234.15C270.85 234.33 292.39 234.53 315 234.75C359.93 235.2 400.62 235.55 430.08 235.63C444.81 235.67 456.73 235.66 464.97 235.58C469.09 235.54 472.29 235.49 474.46 235.43C476.63 235.37 477.77 235.3 477.77 235.22C477.77 235.14 476.63 235.06 474.46 234.98C472.29 234.9 469.09 234.82 464.97 234.74C456.73 234.59 444.81 234.45 430.08 234.35C400.62 234.14 359.93 234.08 314.99 234.09C292.54 234.08 271.16 234.06 251.7 234.05C254.81 234.08 257.87 234.1 260.87 234.12C275.48 234.12 288.8 234.1 300.38 234.1L300.4 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.12 226.3C199.58 226.37 200.03 226.44 200.49 226.52C212.3 228.33 225.92 230.42 240.91 232.72C238.98 232.41 237.07 232.1 235.18 231.79C223.67 230.04 211.6 228.2 199.12 226.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.91 232.72C243.57 233.15 246.28 233.59 249.02 234.04C249.19 234.04 249.36 234.04 249.53 234.04C246.61 233.59 243.73 233.15 240.91 232.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.59 248.57C344.64 248.75 345.44 248.9 346.02 249C346.57 249.1 346.84 249.16 346.84 249.18C346.84 249.2 346.55 249.17 346 249.1C345.42 249.02 344.61 248.91 343.56 248.76C341.38 248.44 338.23 247.97 334.18 247.36C326.01 246.08 314.26 244.24 299.73 241.97C290.77 240.53 280.77 238.91 269.92 237.16C263.31 236.15 256.89 235.16 250.66 234.2C250.84 234.26 251.03 234.32 251.21 234.38C270.53 237.52 291.79 240.98 314.11 244.61C358.42 251.85 398.56 258.34 427.65 262.87C442.19 265.14 453.97 266.92 462.12 268.09C466.2 268.68 469.36 269.11 471.52 269.38C473.67 269.65 474.81 269.75 474.82 269.67C474.83 269.59 473.72 269.34 471.59 268.93C469.46 268.52 466.31 267.96 462.26 267.26C454.15 265.86 442.39 263.93 427.86 261.6C403.04 257.62 370.11 252.52 333.38 246.9C333.66 246.94 333.95 246.99 334.23 247.03C338.27 247.69 341.41 248.21 343.58 248.57H343.59Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36 248.69C281.04 243.84 266.39 239.21 252.71 234.88C254.73 235.54 256.73 236.19 258.7 236.83C272.59 241.21 285.27 245.2 296.36 248.69Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.18 233.52C248.48 233.62 248.78 233.72 249.08 233.82C249.1 233.82 249.12 233.82 249.15 233.83C248.83 233.73 248.5 233.63 248.18 233.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05 262.75C341.05 263.09 341.82 263.36 342.38 263.54C342.9 263.72 343.17 263.83 343.16 263.84C343.16 263.86 342.88 263.79 342.35 263.63C341.79 263.46 341.01 263.23 339.99 262.93C337.89 262.28 334.86 261.33 330.96 260.12C323.1 257.61 311.79 253.99 297.81 249.53C286.4 245.82 273.21 241.54 258.71 236.82C256.15 236.01 253.53 235.19 250.89 234.36C250.95 234.39 251.01 234.42 251.07 234.45C269.67 240.52 290.14 247.2 311.64 254.22C354.23 268.15 392.81 280.71 420.81 289.64C434.8 294.11 446.15 297.67 454.01 300.07C457.94 301.27 461 302.18 463.08 302.78C465.16 303.37 466.27 303.64 466.3 303.57C466.33 303.49 465.27 303.07 463.23 302.34C461.19 301.61 458.18 300.57 454.29 299.26C446.51 296.64 435.21 292.93 421.24 288.4C393.29 279.35 354.61 267.08 311.87 253.6C307.35 252.17 302.89 250.76 298.47 249.36C312.2 253.76 323.33 257.32 331.08 259.81C334.96 261.08 337.98 262.08 340.07 262.76L340.05 262.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 234.01C249.7 234.01 249.66 234 249.63 233.99C249.68 234.01 249.73 234.02 249.78 234.04C249.78 234.04 249.79 234.04 249.8 234.04C249.78 234.04 249.76 234.02 249.74 234.01H249.73Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65 234.35C253.48 235.79 256.36 237.25 259.29 238.74C272.46 245.26 284.44 251.2 294.86 256.36C307.93 262.92 318.52 268.22 325.87 271.91C329.5 273.76 332.32 275.2 334.27 276.2C335.21 276.69 335.92 277.07 336.44 277.34C336.93 277.6 337.17 277.74 337.16 277.76C337.16 277.78 336.89 277.66 336.39 277.43C335.86 277.18 335.13 276.83 334.18 276.37C332.22 275.4 329.37 274.01 325.71 272.21C318.36 268.53 307.77 263.23 294.69 256.68C286.03 252.29 276.29 247.35 265.68 241.98C278.96 248.73 293.05 255.89 307.64 263.31C347.44 283.58 383.52 301.88 409.71 314.97C422.81 321.52 433.43 326.77 440.8 330.35C444.49 332.14 447.36 333.51 449.32 334.41C451.28 335.31 452.33 335.75 452.37 335.68C452.41 335.61 451.43 335.03 449.54 334C447.65 332.97 444.84 331.48 441.2 329.59C433.94 325.81 423.38 320.42 410.31 313.82C384.17 300.61 347.96 282.57 307.94 262.72C287.74 252.68 268.52 243.13 251.05 234.44C250.89 234.39 250.73 234.34 250.57 234.28C250.59 234.3 250.62 234.31 250.64 234.33L250.65 234.35Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.02 227.97C239.3 228.61 240.59 229.25 241.9 229.9C228.45 223.06 216.22 216.85 205.62 211.46C198.21 207.74 191.6 204.42 185.93 201.57C188.14 202.69 190.37 203.82 192.61 204.96C208.48 213 223.75 220.74 238.03 227.97H238.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 233.89C249.86 233.89 249.76 233.82 249.71 233.78C249.68 233.77 249.65 233.75 249.62 233.74C249.71 233.81 249.8 233.87 249.89 233.94C249.89 233.93 249.87 233.92 249.86 233.9V233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.08 233.47C246.65 232.26 244.25 231.07 241.9 229.9C244.39 231.16 246.92 232.45 249.49 233.76C249.35 233.66 249.22 233.57 249.08 233.47Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.72 234.32C250.72 234.32 250.62 234.3 250.57 234.3C250.57 234.3 250.57 234.3 250.58 234.3C250.74 234.35 250.9 234.4 251.06 234.46C251 234.43 250.94 234.4 250.88 234.37C250.82 234.35 250.77 234.34 250.71 234.32H250.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.57 234.29C250.57 234.29 250.67 234.31 250.72 234.31C250.65 234.29 250.58 234.27 250.51 234.24C250.53 234.25 250.55 234.27 250.57 234.28V234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.62 271.16C284.36 258.23 266.97 245.91 251.16 234.72C250.98 234.63 250.8 234.54 250.63 234.46C253.11 236.25 255.64 238.08 258.2 239.93C270.24 248.43 281.21 256.18 290.73 262.9C302.59 271.36 312.19 278.21 318.85 282.97C322.13 285.35 324.69 287.2 326.45 288.48C327.29 289.11 327.94 289.59 328.41 289.94C328.85 290.27 329.07 290.45 329.06 290.46C329.05 290.47 328.81 290.32 328.35 290.02C327.87 289.69 327.2 289.23 326.33 288.64C324.55 287.39 321.96 285.57 318.64 283.24C311.97 278.49 302.37 271.64 290.5 263.19C281.56 256.76 271.34 249.4 260.14 241.34C273.34 250.87 287.48 261.07 302.2 271.7C338.25 297.77 370.94 321.32 394.71 338.24C398.61 341.01 402.26 343.61 405.65 346.01H407.72C403.99 343.31 399.9 340.37 395.49 337.2C371.8 320.18 338.93 296.87 302.59 271.17L302.62 271.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.45 226.42C240.4 227.09 241.36 227.78 242.33 228.46C230.28 219.76 219.3 211.84 209.79 204.97C203.61 200.56 198.05 196.59 193.2 193.12C194.8 194.27 196.39 195.42 198 196.58C212.5 207.02 226.42 217.04 239.45 226.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79 233.83C249.68 233.73 249.58 233.62 249.47 233.52C247.05 231.81 244.67 230.12 242.33 228.46C244.75 230.21 247.21 231.98 249.71 233.79C249.74 233.8 249.76 233.82 249.79 233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 234.27C250.56 234.32 250.66 234.38 250.77 234.43C250.73 234.4 250.69 234.37 250.65 234.35C250.61 234.33 250.56 234.3 250.52 234.28C250.5 234.28 250.47 234.28 250.45 234.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5 234.27C250.5 234.27 250.41 234.24 250.37 234.23C250.4 234.24 250.43 234.26 250.45 234.27C250.47 234.27 250.5 234.27 250.52 234.28C250.52 234.28 250.51 234.28 250.5 234.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 234.19C250.32 234.19 250.33 234.21 250.34 234.21C250.34 234.21 250.36 234.21 250.36 234.22C250.4 234.23 250.45 234.25 250.49 234.26C250.44 234.24 250.4 234.21 250.35 234.19C250.34 234.19 250.33 234.19 250.32 234.18V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.52 234.28C250.52 234.28 250.61 234.33 250.65 234.35C250.63 234.33 250.6 234.32 250.58 234.3C250.57 234.3 250.55 234.3 250.54 234.29C250.54 234.29 250.53 234.29 250.52 234.29V234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 233.89C249.86 233.89 249.82 233.85 249.79 233.82C249.76 233.81 249.74 233.79 249.71 233.78C249.76 233.82 249.81 233.85 249.86 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54 234.29C250.54 234.29 250.51 234.29 250.5 234.28C250.5 234.28 250.51 234.28 250.52 234.29C250.52 234.29 250.53 234.29 250.54 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.58 234.3C250.58 234.3 250.58 234.3 250.57 234.3C250.57 234.3 250.55 234.3 250.54 234.3C250.55 234.3 250.57 234.3 250.58 234.31V234.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 234.2C250.36 234.2 250.45 234.25 250.5 234.27C250.51 234.27 250.53 234.27 250.54 234.28C250.54 234.28 250.56 234.28 250.57 234.28C250.55 234.27 250.53 234.25 250.51 234.24C250.46 234.22 250.41 234.21 250.36 234.19V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.79 234.68C250.79 234.68 250.78 234.68 250.77 234.67C252.91 236.79 255.02 238.87 257.09 240.92C267.67 251.19 277.31 260.54 285.66 268.65C296.02 278.8 304.41 287.02 310.23 292.73C313.09 295.58 315.32 297.79 316.86 299.32C317.59 300.07 318.16 300.64 318.56 301.05C318.94 301.44 319.13 301.65 319.12 301.66C319.11 301.67 318.89 301.49 318.49 301.12C318.07 300.72 317.48 300.17 316.72 299.45C315.16 297.94 312.89 295.76 309.99 292.96C304.16 287.26 295.77 279.04 285.4 268.9C277.12 260.72 267.57 251.28 257.09 240.92C255 238.89 252.87 236.82 250.7 234.72C250.72 234.74 250.73 234.76 250.75 234.78C264.5 248.4 279.63 263.39 295.53 279.14C320.79 304.21 344.16 327.34 363.15 345.99H365.06C345.9 327.19 321.97 303.89 296.01 278.67C279.95 263.05 264.67 248.18 250.79 234.67V234.68Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 233.89L249.87 233.9L249.86 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83 233.71C248 231.26 246.2 228.85 244.43 226.49C246.1 228.77 247.8 231.08 249.53 233.44C249.64 233.55 249.75 233.66 249.86 233.77C249.86 233.75 249.84 233.74 249.83 233.72V233.71Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 234.42C250.31 234.42 250.31 234.46 250.31 234.48C250.34 234.53 250.37 234.59 250.39 234.64C250.41 234.67 250.44 234.71 250.46 234.74C250.4 234.63 250.35 234.53 250.29 234.42H250.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.17 301.06C302.54 304.31 304.39 306.83 305.66 308.58C306.27 309.43 306.73 310.08 307.07 310.55C307.38 311 307.53 311.23 307.52 311.24C307.51 311.24 307.32 311.04 306.99 310.61C306.64 310.15 306.15 309.52 305.51 308.69C304.21 306.97 302.32 304.47 299.9 301.26C295.06 294.75 288.08 285.36 279.46 273.78C273.19 265.27 266.05 255.56 258.25 244.96C255.62 241.44 253.03 237.99 250.51 234.61C250.6 234.79 250.69 234.96 250.78 235.14C262.13 250.61 274.62 267.62 287.74 285.5C303.78 307.39 318.9 327.99 332.19 346H333.8C321.42 329.37 307.34 310.54 292.36 290.55C295.37 294.6 297.99 298.13 300.17 301.07V301.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.88 221.75C242.05 223.31 243.23 224.89 244.43 226.49C244.29 226.3 244.14 226.1 244 225.91C242.97 224.53 241.93 223.15 240.88 221.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 233.95C249.91 233.95 249.88 233.92 249.87 233.91C249.87 233.92 249.89 233.93 249.9 233.95H249.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87 233.9C249.88 233.91 249.9 233.93 249.91 233.94C249.89 233.92 249.88 233.91 249.86 233.9H249.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.78 307.83C290.6 311.4 292.02 314.17 293 316.09C293.46 317.02 293.82 317.74 294.07 318.25C294.31 318.74 294.42 318.99 294.4 319C294.38 319 294.24 318.77 293.97 318.29C293.7 317.79 293.31 317.08 292.81 316.17C291.8 314.27 290.34 311.52 288.46 307.98C284.72 300.81 279.34 290.48 272.69 277.73C267.78 268.19 262.18 257.31 256.04 245.38C254.12 241.72 252.24 238.14 250.39 234.62C250.37 234.59 250.35 234.57 250.33 234.54C250.38 234.7 250.43 234.85 250.49 235.01C259.24 252.07 268.88 270.84 279 290.57C289.08 310.24 298.69 328.98 307.45 345.99H308.84C300.72 330.46 291.82 313.51 282.47 295.71C284.91 300.39 287.02 304.46 288.77 307.83H288.78Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 233.86C249.95 233.86 249.96 233.87 249.97 233.88C249.9 233.79 249.84 233.71 249.78 233.62C249.8 233.65 249.81 233.69 249.83 233.72C249.85 233.75 249.88 233.78 249.9 233.82C249.92 233.84 249.93 233.85 249.95 233.87V233.86Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.91 226.06C247.09 228.37 248.3 230.71 249.52 233.09C249.62 233.22 249.71 233.35 249.81 233.48C248.49 230.97 247.19 228.49 245.92 226.06H245.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79 222.03C244.49 223.36 245.19 224.7 245.91 226.06C245.83 225.9 245.74 225.73 245.66 225.57C245.04 224.4 244.42 223.21 243.79 222.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 233.87C249.97 233.87 249.96 233.86 249.95 233.85C249.95 233.85 249.96 233.86 249.97 233.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83 233.71C249.83 233.71 249.85 233.74 249.86 233.76C249.88 233.78 249.89 233.79 249.91 233.81C249.89 233.78 249.86 233.75 249.84 233.71H249.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 234.48C250.32 234.48 250.34 234.53 250.35 234.56C250.37 234.59 250.39 234.61 250.41 234.64C250.38 234.59 250.35 234.53 250.33 234.48H250.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.04 187.52C234.71 186.51 234.38 185.51 234.05 184.52C235.34 188.48 236.61 192.4 237.87 196.27C236.89 193.25 235.95 190.32 235.04 187.51V187.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83 233.02C249.55 232.17 249.27 231.33 248.99 230.49C249.28 231.38 249.57 232.27 249.86 233.16C249.86 233.11 249.84 233.07 249.84 233.02H249.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5 235.02C250.46 234.95 250.43 234.88 250.39 234.8C251.23 237.39 252.06 239.95 252.88 242.47C257.62 256.59 261.92 269.43 265.65 280.55C270.14 294.17 273.77 305.19 276.3 312.84C277.52 316.64 278.47 319.6 279.13 321.64C279.43 322.63 279.67 323.39 279.84 323.94C279.99 324.46 280.06 324.73 280.05 324.73C280.03 324.73 279.93 324.48 279.74 323.97C279.55 323.43 279.28 322.68 278.94 321.7C278.25 319.67 277.25 316.73 275.97 312.94C273.44 305.29 269.8 294.27 265.3 280.66C261.68 269.51 257.49 256.64 252.89 242.47C252.27 240.62 251.64 238.75 251.01 236.86C256.74 254.56 263.01 273.94 269.58 294.27C275.44 312.44 281.07 329.86 286.31 345.99H287.56C282.17 329.8 276.33 312.31 270.22 294.07C263.22 273.11 256.56 253.15 250.5 235.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.74C250.05 233.68 250.03 233.62 250.01 233.56C250.01 233.61 250.02 233.66 250.03 233.71C250.04 233.73 250.05 233.75 250.06 233.77C250.06 233.76 250.06 233.75 250.06 233.74H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 234.7C250.36 234.7 250.38 234.77 250.4 234.81C250.44 234.88 250.47 234.95 250.51 235.03C250.46 234.87 250.41 234.72 250.35 234.56C250.35 234.56 250.34 234.54 250.33 234.54C250.33 234.6 250.35 234.65 250.36 234.71V234.7Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 234.53C250.33 234.53 250.34 234.55 250.35 234.55C250.35 234.52 250.33 234.5 250.32 234.47C250.32 234.49 250.32 234.51 250.32 234.52L250.33 234.53Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1 214.54C247.65 217.97 248.22 221.48 248.8 225.07C246.59 210.5 244.57 197.26 242.83 185.78C240.63 171.76 238.84 160.4 237.59 152.46C238.56 158.78 239.54 165.21 240.53 171.74C242.81 186.58 245.01 200.94 247.09 214.54H247.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 233.11V233.05C249.65 230.35 249.22 227.69 248.8 225.07C249.22 227.84 249.65 230.67 250.09 233.53C250.09 233.39 250.09 233.25 250.09 233.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 233.75C250.2 233.75 250.2 233.7 250.19 233.68C250.19 233.71 250.19 233.75 250.19 233.78C250.19 233.77 250.19 233.76 250.2 233.74V233.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43 235.16C250.37 234.98 250.31 234.81 250.25 234.63C250.96 239.28 251.68 244.04 252.42 248.91C254.42 261.19 256.25 272.43 257.87 282.36C260.1 296.49 261.9 307.93 263.16 315.88C263.75 319.82 264.21 322.89 264.53 325C264.67 326.02 264.78 326.81 264.86 327.38C264.93 327.92 264.95 328.19 264.94 328.2C264.92 328.2 264.86 327.93 264.76 327.4C264.66 326.84 264.52 326.05 264.34 325.04C263.99 322.93 263.48 319.87 262.83 315.94C261.62 308.32 259.9 297.48 257.79 284.15C258.41 288.22 259.03 292.34 259.67 296.49C262.29 313.8 264.81 330.44 267.19 346H268.36C265.85 330.41 263.16 313.73 260.34 296.39C256.83 274.66 253.49 253.98 250.45 235.17L250.43 235.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 234.47C250.32 234.45 250.32 234.43 250.32 234.41C250.32 234.39 250.3 234.37 250.29 234.36C250.3 234.4 250.31 234.43 250.33 234.47H250.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.28C250.23 234.28 250.23 234.28 250.23 234.29C250.26 234.35 250.29 234.41 250.32 234.46C250.31 234.42 250.3 234.39 250.28 234.35C250.27 234.33 250.26 234.31 250.25 234.29C250.25 234.29 250.24 234.29 250.23 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 234.7C250.36 234.64 250.34 234.59 250.33 234.53C250.31 234.51 250.3 234.49 250.28 234.46C250.31 234.54 250.33 234.61 250.36 234.69V234.7Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.29C250.25 234.35 250.27 234.4 250.28 234.46C250.3 234.48 250.31 234.5 250.33 234.53C250.33 234.51 250.33 234.49 250.33 234.48C250.33 234.48 250.33 234.48 250.33 234.47C250.3 234.41 250.27 234.35 250.24 234.3L250.23 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.51C250.08 234.58 250.08 234.64 250.08 234.71C250.08 234.68 250.09 234.64 250.1 234.61C250.1 234.61 250.1 234.55 250.09 234.52L250.08 234.51Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 297.15C250.18 275.24 250.18 254.38 250.18 235.41C250.16 238.51 250.13 241.56 250.11 244.55C250.13 258.76 250.14 271.7 250.16 282.95C250.11 297.25 250.07 308.82 250.04 316.86C250 320.84 249.96 323.94 249.94 326.08C249.92 327.11 249.9 327.91 249.89 328.48C249.87 329.02 249.85 329.3 249.84 329.3C249.83 329.3 249.81 329.02 249.79 328.48C249.79 327.91 249.77 327.12 249.75 326.08C249.75 323.94 249.73 320.84 249.71 316.86C249.73 308.82 249.77 297.25 249.81 282.95C249.9 271.69 250 258.75 250.12 244.55C250.12 241.45 250.12 238.3 250.11 235.08C250.11 235.12 250.1 235.17 250.09 235.21C249.91 254.23 249.72 275.16 249.52 297.15C249.35 314.2 249.19 330.61 249.06 345.99H250.2C250.21 330.61 250.21 314.19 250.2 297.15H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.88 315.84C236.2 319.77 235.67 322.82 235.3 324.93C235.11 325.95 234.97 326.73 234.86 327.29C234.76 327.82 234.69 328.09 234.68 328.09C234.66 328.09 234.69 327.81 234.76 327.28C234.84 326.72 234.96 325.93 235.1 324.91C235.43 322.8 235.91 319.73 236.53 315.8C237.84 307.86 239.72 296.43 242.05 282.32C243.53 273.64 245.18 263.94 246.97 253.42C248.01 246.97 249.03 240.7 250.01 234.63C249.95 234.81 249.89 234.99 249.83 235.16C246.61 253.94 243.07 274.6 239.35 296.3C236.36 313.68 233.49 330.39 230.83 346.01H232C233.59 336.22 235.25 326 236.95 315.46C236.93 315.59 236.91 315.73 236.88 315.86V315.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.55 225.14C251.11 227.73 250.66 230.36 250.2 233.03C250.2 233.2 250.2 233.36 250.2 233.53C250.66 230.69 251.11 227.89 251.56 225.14H251.55Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 233.68C250.08 233.68 250.08 233.72 250.07 233.74C250.07 233.74 250.07 233.76 250.07 233.77C250.07 233.74 250.07 233.71 250.07 233.68H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12 184.59C258.05 185.01 257.98 185.43 257.91 185.85C256.05 197.33 253.91 210.57 251.55 225.14C251.87 223.26 252.19 221.41 252.5 219.57C254.29 208.4 256.17 196.69 258.11 184.59H258.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.34 281.47C229.89 294.63 226.27 305.31 223.75 312.77C222.44 316.54 221.42 319.48 220.72 321.51C220.37 322.48 220.1 323.23 219.9 323.77C219.71 324.28 219.6 324.54 219.59 324.53C219.57 324.53 219.64 324.26 219.8 323.74C219.97 323.19 220.21 322.43 220.52 321.45C221.19 319.41 222.16 316.46 223.41 312.67C225.99 305.03 229.7 294.03 234.29 280.45C238.1 269.36 242.5 256.54 247.33 242.45C248.16 239.95 249.01 237.41 249.86 234.84C249.83 234.9 249.8 234.96 249.77 235.02C243.54 253.1 236.68 273 229.47 293.9C223.14 312.22 217.09 329.77 211.51 346.01H212.78C218.21 329.84 224.04 312.35 230.13 294.11C231.55 289.86 232.96 285.65 234.35 281.49L234.34 281.47Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.53 277.91C240.36 263.46 244.98 249.62 249.31 236.69C248.65 238.63 247.99 240.54 247.34 242.44C243 255.47 239.03 267.41 235.54 277.92L235.53 277.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.71C250.23 233.68 250.24 233.64 250.25 233.61C250.23 233.66 250.22 233.71 250.2 233.75C250.2 233.75 250.2 233.76 250.2 233.77C250.2 233.75 250.22 233.73 250.23 233.71Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.75 232.15C250.64 232.46 250.54 232.77 250.43 233.08C250.43 233.1 250.43 233.13 250.42 233.15C250.53 232.82 250.64 232.49 250.75 232.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.79C250.19 233.79 250.2 233.77 250.21 233.76C250.21 233.76 250.21 233.75 250.21 233.74C250.21 233.75 250.21 233.76 250.2 233.78C250.2 233.78 250.2 233.78 250.2 233.79H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.77 235C249.82 234.84 249.88 234.69 249.93 234.53C249.91 234.55 249.89 234.58 249.88 234.6C248.41 237.34 246.91 240.12 245.4 242.95C238.69 255.77 232.57 267.44 227.26 277.58C220.52 290.29 215.07 300.58 211.28 307.72C209.38 311.25 207.9 313.99 206.87 315.88C206.37 316.79 205.98 317.49 205.7 317.99C205.43 318.46 205.28 318.7 205.27 318.69C205.25 318.69 205.37 318.43 205.61 317.94C205.87 317.43 206.23 316.71 206.7 315.79C207.69 313.88 209.13 311.11 210.98 307.56C214.76 300.41 220.21 290.12 226.94 277.4C231.49 268.9 236.63 259.31 242.22 248.88C235.23 261.88 227.82 275.68 220.13 289.99C209.42 309.89 199.25 328.81 190.07 345.98H191.46C200.46 328.91 210.35 310.08 220.73 290.3C231.05 270.67 240.87 251.98 249.79 235H249.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.78 233.08C252.02 230.71 253.25 228.38 254.46 226.08C253.16 228.51 251.83 230.97 250.49 233.48C250.59 233.35 250.69 233.22 250.79 233.08H250.78Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44 222.31C255.79 223.56 255.13 224.81 254.46 226.08C261.48 213.02 267.87 201.12 273.4 190.82C277.27 183.53 280.72 177.04 283.67 171.48C282.48 173.7 281.29 175.92 280.08 178.16C271.82 193.59 263.87 208.42 256.43 222.31H256.44Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 233.83C250.35 233.83 250.42 233.74 250.46 233.69C250.48 233.66 250.49 233.63 250.51 233.6C250.44 233.69 250.38 233.78 250.31 233.87C250.32 233.87 250.33 233.85 250.35 233.84C250.35 233.84 250.35 233.84 250.36 233.83H250.35Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 234.52C249.94 234.52 249.94 234.52 249.94 234.53C249.89 234.69 249.83 234.84 249.78 235C249.81 234.94 249.84 234.88 249.87 234.82C249.89 234.77 249.9 234.72 249.92 234.66C249.92 234.61 249.94 234.56 249.95 234.51L249.94 234.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 234.52C249.94 234.52 249.92 234.62 249.91 234.67C249.93 234.6 249.96 234.53 249.98 234.47C249.97 234.49 249.95 234.51 249.94 234.53V234.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5 235.11C249.59 234.94 249.68 234.77 249.77 234.59C247.92 237.01 246.04 239.48 244.14 241.97C235.4 253.67 227.44 264.33 220.54 273.57C211.84 285.1 204.8 294.43 199.91 300.92C197.46 304.11 195.56 306.6 194.24 308.31C193.6 309.13 193.1 309.76 192.74 310.22C192.4 310.65 192.22 310.86 192.2 310.85C192.19 310.84 192.34 310.61 192.66 310.16C193 309.69 193.47 309.04 194.08 308.2C195.37 306.46 197.23 303.95 199.63 300.72C204.52 294.24 211.55 284.9 220.24 273.36C226.81 264.73 234.31 254.87 242.53 244.08C232.78 256.85 222.35 270.52 211.49 284.75C194.53 306.93 178.61 327.8 164.8 345.99H166.42C180.02 327.92 195.55 307.19 212.03 285.14C225.33 267.38 237.98 250.48 249.49 235.11H249.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.07 223.67C257.36 224.61 256.64 225.58 255.92 226.54C264.87 214.82 273.02 204.13 280.08 194.88C284.69 188.78 288.83 183.3 292.44 178.52C291.2 180.15 289.96 181.77 288.71 183.41C278 197.49 267.7 211.01 258.07 223.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 234.41C249.9 234.51 249.85 234.62 249.79 234.72C249.82 234.68 249.85 234.65 249.87 234.61C249.89 234.57 249.92 234.52 249.94 234.48C249.94 234.46 249.94 234.44 249.95 234.41H249.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42 233.76C250.53 233.65 250.63 233.55 250.74 233.45C252.5 231.11 254.22 228.8 255.92 226.53C254.13 228.88 252.31 231.26 250.46 233.69C250.45 233.71 250.43 233.74 250.42 233.76Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.33C250 234.33 249.97 234.38 249.96 234.41C249.96 234.43 249.96 234.45 249.95 234.48C249.95 234.48 249.95 234.47 249.96 234.46C249.97 234.42 249.99 234.38 250 234.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.28C250.04 234.28 250.02 234.29 250.02 234.3C250.02 234.3 250.02 234.32 250.01 234.33C250 234.37 249.98 234.41 249.97 234.46C249.99 234.41 250.02 234.37 250.04 234.32C250.04 234.31 250.04 234.3 250.04 234.29V234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.47C249.95 234.47 249.9 234.56 249.88 234.6C249.9 234.58 249.92 234.55 249.93 234.53C249.93 234.52 249.93 234.5 249.94 234.49C249.94 234.49 249.94 234.48 249.94 234.47H249.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42 233.76C250.42 233.76 250.45 233.71 250.46 233.69C250.42 233.74 250.39 233.78 250.35 233.83C250.37 233.81 250.39 233.79 250.42 233.76Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.47C249.95 234.47 249.95 234.48 249.95 234.49C249.95 234.48 249.95 234.46 249.96 234.45C249.96 234.45 249.96 234.46 249.95 234.47Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 234.49C249.94 234.49 249.94 234.52 249.93 234.53C249.93 234.53 249.93 234.53 249.93 234.52C249.93 234.52 249.93 234.5 249.93 234.49H249.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.32C250.03 234.32 249.98 234.41 249.96 234.46C249.96 234.47 249.96 234.49 249.95 234.5C249.95 234.5 249.95 234.52 249.95 234.53C249.96 234.51 249.98 234.49 249.99 234.47C250.01 234.42 250.02 234.37 250.04 234.32H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54 234.74C249.54 234.74 249.54 234.73 249.55 234.72C247.37 236.81 245.23 238.85 243.12 240.87C232.56 251.16 222.94 260.53 214.61 268.66C204.17 278.73 195.72 286.89 189.85 292.55C186.92 295.34 184.64 297.5 183.07 299C182.3 299.71 181.71 300.26 181.29 300.66C180.88 301.03 180.67 301.21 180.66 301.2C180.65 301.19 180.84 300.98 181.22 300.59C181.63 300.18 182.2 299.61 182.94 298.87C184.49 297.35 186.73 295.15 189.62 292.32C195.48 286.65 203.93 278.49 214.36 268.41C222.77 260.36 232.48 251.07 243.13 240.87C245.22 238.83 247.34 236.76 249.5 234.66C249.48 234.67 249.46 234.69 249.44 234.7C235.43 248.07 220.02 262.78 203.83 278.25C177.12 303.71 152.56 327.18 133.03 345.99H134.96C154.32 327.33 178.32 304.02 204.31 278.72C220.37 263.1 235.66 248.24 249.55 234.74H249.54Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54 233.8C253.06 232.02 255.53 230.27 257.96 228.55C255.62 230.17 253.24 231.83 250.82 233.51C250.71 233.62 250.6 233.72 250.48 233.83C250.5 233.83 250.52 233.81 250.54 233.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.59 234.36C249.59 234.36 249.52 234.41 249.48 234.43C249.59 234.38 249.7 234.32 249.81 234.27C249.79 234.27 249.77 234.27 249.75 234.27C249.7 234.3 249.64 234.32 249.59 234.35V234.36Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.97 275.26C187.86 278.15 184.27 280.67 181.27 282.77C177.93 285.08 175.33 286.87 173.54 288.11C172.67 288.7 172 289.15 171.51 289.48C171.05 289.78 170.81 289.93 170.8 289.92C170.79 289.91 171.01 289.73 171.45 289.4C171.92 289.06 172.57 288.58 173.42 287.96C175.19 286.69 177.76 284.86 181.06 282.5C187.76 277.79 197.41 271 209.33 262.62C218.09 256.52 228.08 249.57 239 241.97C242.61 239.42 246.15 236.91 249.61 234.46C249.43 234.55 249.25 234.64 249.07 234.72C233.16 245.77 215.66 257.91 197.28 270.67C160.69 296.03 127.6 319.04 103.75 335.84C98.5001 339.54 93.6901 342.93 89.3901 345.99H91.4501C95.4301 343.23 99.8001 340.19 104.53 336.89C127.2 321.08 157.93 299.37 191.97 275.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.54 225.31C261.03 226.38 259.51 227.46 257.96 228.55C258.15 228.42 258.34 228.29 258.52 228.16C259.85 227.22 261.19 226.27 262.53 225.31H262.54Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 233.89C250.3 233.89 250.31 233.88 250.32 233.87L250.34 233.85C250.33 233.85 250.32 233.87 250.3 233.88V233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 233.87C250.32 233.87 250.31 233.88 250.3 233.89C250.3 233.89 250.31 233.88 250.32 233.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39 233.92C250.39 233.92 250.38 233.93 250.37 233.94C250.46 233.88 250.55 233.81 250.64 233.75C250.61 233.77 250.57 233.78 250.54 233.8C250.5 233.82 250.47 233.85 250.43 233.87C250.41 233.88 250.4 233.9 250.38 233.91L250.39 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8 275.81C164.84 276.26 164.11 276.6 163.58 276.85C163.08 277.08 162.81 277.19 162.81 277.17C162.81 277.15 163.05 277.01 163.54 276.76C164.06 276.49 164.78 276.12 165.72 275.63C167.68 274.65 170.51 273.23 174.15 271.4C181.53 267.76 192.15 262.53 205.27 256.06C215.06 251.29 226.24 245.85 238.47 239.89C242.25 238.01 245.97 236.17 249.6 234.36C249.63 234.34 249.65 234.32 249.68 234.3C249.52 234.35 249.36 234.4 249.2 234.45C231.65 242.97 212.34 252.34 192.06 262.19C151.84 281.67 115.45 299.38 89.1901 312.34C76.0601 318.82 65.4501 324.12 58.1501 327.83C54.5001 329.69 51.6801 331.15 49.7701 332.16C47.8701 333.18 46.8901 333.74 46.9201 333.82C46.9601 333.89 48.0101 333.46 49.9801 332.58C51.9501 331.69 54.8401 330.35 58.5401 328.6C65.9501 325.09 76.6201 319.94 89.7801 313.51C114.82 301.28 148.84 284.43 186.52 265.69C181.8 268.01 177.7 270.03 174.29 271.71C170.62 273.48 167.77 274.86 165.79 275.81H165.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.4 229.99C256.03 231.14 253.62 232.31 251.18 233.5C251.04 233.59 250.91 233.69 250.78 233.78C253.36 232.5 255.91 231.23 258.41 229.99H258.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.79 227.81C261.34 228.53 259.88 229.26 258.39 229.99C258.57 229.9 258.75 229.81 258.93 229.73C260.21 229.09 261.49 228.45 262.78 227.81H262.79Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 233.94C250.37 233.94 250.38 233.93 250.39 233.92L250.37 233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75 234.28C249.75 234.28 249.7 234.3 249.67 234.3C249.64 234.32 249.62 234.34 249.59 234.36C249.64 234.33 249.7 234.31 249.75 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54 233.8C250.54 233.8 250.5 233.82 250.48 233.83C250.46 233.85 250.45 233.86 250.43 233.88C250.47 233.86 250.5 233.83 250.54 233.81V233.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57 236.76C227.02 241.38 213.8 245.57 202.36 249.21C188.35 253.58 177.01 257.12 169.14 259.58C165.23 260.77 162.19 261.69 160.09 262.33C159.07 262.63 158.29 262.85 157.73 263.02C157.2 263.17 156.92 263.24 156.91 263.22C156.91 263.2 157.17 263.1 157.69 262.92C158.24 262.74 159.02 262.48 160.02 262.14C162.11 261.47 165.14 260.5 169.03 259.25C176.9 256.79 188.24 253.24 202.24 248.86C213.72 245.33 226.98 241.25 241.57 236.76C243.49 236.15 245.43 235.54 247.39 234.91C229.16 240.49 209.19 246.61 188.24 253.02C145.37 266.11 106.57 278.03 78.5301 286.82C64.5101 291.21 53.1801 294.82 45.3701 297.37C41.4601 298.65 38.4401 299.66 36.4001 300.37C34.3601 301.08 33.3001 301.49 33.3201 301.57C33.3501 301.65 34.4501 301.38 36.5401 300.81C38.6301 300.24 41.7001 299.35 45.6401 298.19C53.5201 295.86 64.9001 292.4 78.9401 288.06C107.02 279.39 145.72 267.19 188.45 253.65C210.02 246.83 230.54 240.35 249.2 234.45C249.27 234.41 249.35 234.38 249.42 234.34C246.77 235.16 244.15 235.96 241.58 236.75L241.57 236.76Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.05 219.4C299.12 219.07 300.16 218.74 301.2 218.42C297.09 219.68 293.03 220.93 289.02 222.17C292.14 221.22 295.16 220.29 298.06 219.4H298.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.51 234.04C250.57 234.02 250.63 234 250.69 233.98C250.64 233.98 250.59 233.99 250.54 234C250.52 234.01 250.5 234.02 250.48 234.03C250.48 234.03 250.5 234.03 250.51 234.03V234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.24 233.81C252.1 233.54 252.95 233.27 253.79 233C252.89 233.28 251.99 233.55 251.1 233.83C251.15 233.83 251.19 233.82 251.24 233.81Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.69 234.29C249.63 234.29 249.58 234.31 249.52 234.32C249.48 234.33 249.44 234.34 249.4 234.36C249.33 234.4 249.25 234.43 249.18 234.47C249.34 234.42 249.5 234.37 249.66 234.32C249.66 234.32 249.68 234.31 249.68 234.3L249.69 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.69 234.29C249.69 234.29 249.67 234.3 249.67 234.31C249.7 234.31 249.72 234.29 249.75 234.29C249.73 234.29 249.71 234.29 249.7 234.29H249.69Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92 236.33C222.28 238.28 210.7 240.07 200.49 241.65C185.95 243.83 174.18 245.59 166.01 246.81C161.96 247.39 158.8 247.84 156.62 248.15C155.57 248.29 154.76 248.39 154.17 248.47C153.62 248.54 153.33 248.56 153.33 248.54C153.33 248.52 153.61 248.46 154.15 248.37C154.73 248.27 155.53 248.14 156.58 247.96C158.75 247.62 161.9 247.12 165.94 246.48C173.8 245.3 184.99 243.62 198.76 241.54C194.53 242.15 190.26 242.77 185.95 243.39C141.5 249.76 101.25 255.6 72.1401 259.99C57.5901 262.18 45.8101 264.01 37.6901 265.34C33.6301 266 30.4801 266.54 28.3401 266.93C26.2101 267.32 25.0901 267.56 25.1101 267.64C25.1201 267.72 26.2601 267.63 28.4201 267.38C30.5801 267.13 33.7501 266.73 37.8301 266.18C45.9901 265.08 57.7901 263.41 72.3501 261.27C101.48 257 141.68 250.87 186.06 244.04C208.42 240.61 229.7 237.35 249.04 234.39C249.22 234.33 249.4 234.27 249.58 234.22C244.8 234.91 239.91 235.61 234.91 236.34L234.92 236.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21 234.06C253.99 233.63 256.73 233.21 259.42 232.8C256.57 233.21 253.67 233.63 250.72 234.05C250.88 234.05 251.05 234.05 251.21 234.05V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.27 231.14C266.74 231.68 263.12 232.24 259.41 232.8C274.4 230.64 288.03 228.67 299.84 226.97C314.38 224.8 326.15 223.05 334.33 221.83H334.35C327.78 222.78 321.08 223.75 314.28 224.74C299.02 226.96 284.25 229.11 270.26 231.14H270.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43 234.14C250.43 234.14 250.46 234.15 250.48 234.16C250.5 234.16 250.53 234.16 250.55 234.16C250.58 234.16 250.62 234.15 250.65 234.14C250.58 234.14 250.51 234.14 250.44 234.14H250.43Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76 234.28C249.78 234.28 249.8 234.28 249.82 234.28C249.84 234.28 249.86 234.26 249.88 234.25C249.84 234.26 249.81 234.27 249.77 234.29L249.76 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.19C249.95 234.19 249.95 234.19 249.94 234.19C249.88 234.22 249.82 234.25 249.76 234.28C249.8 234.27 249.83 234.26 249.87 234.24C249.89 234.23 249.91 234.22 249.93 234.21C249.93 234.21 249.94 234.2 249.95 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.53 234.32C249.59 234.32 249.64 234.3 249.7 234.29C249.72 234.27 249.74 234.26 249.77 234.24C249.69 234.26 249.61 234.29 249.53 234.31V234.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76 234.28C249.82 234.25 249.88 234.22 249.94 234.19C249.88 234.21 249.82 234.23 249.76 234.24C249.74 234.26 249.72 234.27 249.69 234.29C249.71 234.29 249.73 234.29 249.74 234.29C249.74 234.29 249.74 234.29 249.75 234.29L249.76 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.53 234.05C249.53 234.05 249.59 234.05 249.62 234.06C249.65 234.06 249.68 234.06 249.7 234.05C249.64 234.05 249.58 234.05 249.52 234.05H249.53Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87 234.03C185.16 233.95 173.25 233.89 164.98 233.85C160.88 233.8 157.7 233.76 155.49 233.73C154.43 233.71 153.61 233.69 153.02 233.67C152.46 233.65 152.18 233.63 152.18 233.62C152.18 233.61 152.47 233.59 153.02 233.58C153.61 233.58 154.42 233.56 155.49 233.55C157.69 233.55 160.88 233.54 164.98 233.53C173.25 233.57 185.16 233.62 199.87 233.69C211.45 233.8 224.76 233.92 239.38 234.06C242.57 234.06 245.83 234.06 249.14 234.06C249.1 234.06 249.06 234.05 249.01 234.04C229.43 233.88 207.88 233.71 185.25 233.52C140.32 233.12 99.62 232.82 70.17 232.78C55.44 232.75 43.52 232.78 35.28 232.87C31.16 232.91 27.96 232.96 25.79 233.03C23.62 233.09 22.48 233.17 22.48 233.24C22.48 233.32 23.62 233.4 25.79 233.48C27.96 233.56 31.16 233.64 35.28 233.71C43.52 233.85 55.44 233.98 70.17 234.06C99.63 234.24 140.32 234.24 185.26 234.19C207.86 234.18 229.37 234.16 248.93 234.15C245.69 234.12 242.5 234.09 239.38 234.06C224.76 234.06 211.45 234.04 199.87 234.04V234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.29 234.58C339.39 234.57 342.57 234.55 344.78 234.55C345.84 234.53 346.66 234.52 347.25 234.51C347.81 234.5 348.09 234.48 348.09 234.46C348.09 234.44 347.81 234.43 347.25 234.41C346.66 234.4 345.85 234.38 344.78 234.36C342.58 234.34 339.39 234.3 335.29 234.26C327.02 234.23 315.11 234.18 300.4 234.12C288.82 234.12 275.51 234.13 260.89 234.14C275.5 234.26 288.82 234.37 300.4 234.46C315.11 234.51 327.02 234.55 335.29 234.58Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38 234.1C249.3 234.09 249.23 234.08 249.15 234.06C245.84 234.06 242.58 234.06 239.39 234.06C242.52 234.09 245.7 234.12 248.94 234.15C248.99 234.15 249.03 234.15 249.08 234.15C249.18 234.13 249.28 234.12 249.38 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.98 233.52C160.88 233.52 157.69 233.54 155.49 233.54C154.43 233.55 153.61 233.56 153.02 233.57C152.46 233.58 152.18 233.6 152.18 233.61C152.18 233.62 152.46 233.64 153.02 233.66C153.61 233.67 154.42 233.69 155.49 233.72C157.69 233.75 160.88 233.79 164.98 233.84C173.25 233.88 185.16 233.95 199.87 234.02C211.45 234.02 224.77 234.04 239.38 234.04C224.77 233.9 211.45 233.78 199.87 233.67C185.16 233.6 173.25 233.54 164.98 233.51V233.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9 234.11C250.98 234.12 251.06 234.14 251.13 234.15C254.44 234.15 257.69 234.15 260.88 234.15C257.88 234.13 254.82 234.1 251.71 234.08C251.53 234.08 251.35 234.08 251.17 234.08C251.08 234.09 250.98 234.11 250.89 234.12L250.9 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61 234.06C249.61 234.06 249.61 234.06 249.62 234.06C249.59 234.06 249.56 234.06 249.53 234.05C249.36 234.05 249.19 234.05 249.02 234.05C249.06 234.05 249.1 234.06 249.15 234.07C249.3 234.07 249.46 234.07 249.62 234.07L249.61 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.1C249.92 234.1 249.9 234.1 249.89 234.1C249.8 234.11 249.71 234.13 249.62 234.14C249.62 234.14 249.64 234.14 249.65 234.14C249.7 234.14 249.76 234.14 249.81 234.14C249.83 234.14 249.84 234.13 249.86 234.12C249.88 234.12 249.89 234.1 249.91 234.1H249.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.15 234.06C249.23 234.07 249.3 234.08 249.38 234.1C249.46 234.09 249.54 234.08 249.62 234.06C249.46 234.06 249.31 234.06 249.15 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93 234.11H249.92C249.92 234.11 249.89 234.12 249.87 234.13C249.89 234.13 249.91 234.12 249.94 234.11H249.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9 234.11C250.99 234.1 251.09 234.08 251.18 234.07C251.01 234.07 250.84 234.07 250.66 234.07C250.66 234.07 250.65 234.07 250.64 234.07C250.72 234.08 250.81 234.1 250.89 234.11H250.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43 234.14C250.5 234.14 250.57 234.14 250.64 234.14C250.55 234.13 250.46 234.11 250.38 234.1H250.36C250.38 234.11 250.41 234.12 250.43 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43 234.14C250.43 234.14 250.38 234.12 250.36 234.1C250.36 234.1 250.34 234.1 250.33 234.1C250.36 234.11 250.4 234.12 250.43 234.13V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7 219.52C155.65 219.33 154.85 219.19 154.27 219.09C153.72 218.99 153.45 218.93 153.45 218.91C153.45 218.89 153.74 218.92 154.29 218.99C154.87 219.07 155.68 219.18 156.73 219.33C158.91 219.66 162.06 220.13 166.1 220.74C174.26 222.03 186.02 223.88 200.54 226.17C210.81 227.84 222.45 229.73 235.17 231.8C240.09 232.55 244.91 233.28 249.61 234C249.43 233.94 249.25 233.88 249.07 233.82C229.74 230.7 208.47 227.27 186.14 223.67C141.82 216.49 101.67 210.04 72.5702 205.55C58.0202 203.3 46.2402 201.53 38.0902 200.37C34.0102 199.79 30.8502 199.36 28.6902 199.1C26.5402 198.84 25.4002 198.74 25.3902 198.82C25.3802 198.9 26.4902 199.15 28.6202 199.56C30.7502 199.97 33.9002 200.53 37.9502 201.22C46.0602 202.61 57.8202 204.53 72.3602 206.84C101.43 211.46 141.63 217.61 186.03 224.33C190.44 225 194.8 225.66 199.11 226.32C185.22 224.12 173.95 222.33 166.04 221.08C162 220.41 158.86 219.89 156.69 219.53L156.7 219.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.39 235.47C256.73 235.04 254.03 234.6 251.28 234.16C251.11 234.16 250.94 234.16 250.76 234.16C253.68 234.6 256.56 235.04 259.38 235.47H259.39Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.58 234.05C250.58 234.05 250.53 234.05 250.51 234.04C250.5 234.04 250.49 234.04 250.48 234.05C250.51 234.05 250.55 234.05 250.58 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.22 243.97C320.71 244.96 327.1 245.94 333.38 246.9C325.26 245.62 313.82 243.83 299.79 241.62C287.99 239.82 274.37 237.75 259.39 235.47C262.98 236.05 266.49 236.62 269.92 237.17C283.99 239.33 298.85 241.61 314.22 243.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65 234.14C250.69 234.14 250.73 234.15 250.76 234.16C250.93 234.16 251.1 234.16 251.28 234.16C251.23 234.16 251.18 234.14 251.14 234.14C250.98 234.14 250.82 234.14 250.66 234.14H250.65Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.92 237.17C280.77 238.92 290.77 240.53 299.73 241.98C314.25 244.25 326.01 246.09 334.18 247.37C338.23 247.97 341.38 248.44 343.56 248.77C344.61 248.91 345.42 249.03 346 249.11C346.55 249.18 346.84 249.21 346.84 249.19C346.84 249.17 346.56 249.11 346.02 249.01C345.44 248.91 344.64 248.77 343.59 248.58C341.42 248.22 338.28 247.71 334.24 247.04C333.96 247 333.67 246.95 333.39 246.91C327.1 245.95 320.71 244.97 314.23 243.98C298.86 241.62 284 239.34 269.93 237.18L269.92 237.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.55 226.16C186.03 223.87 174.27 222.02 166.11 220.73C162.06 220.12 158.91 219.65 156.74 219.32C155.69 219.17 154.88 219.06 154.3 218.98C153.75 218.91 153.46 218.88 153.46 218.9C153.46 218.92 153.74 218.98 154.28 219.08C154.86 219.18 155.66 219.33 156.71 219.51C158.88 219.87 162.02 220.39 166.06 221.06C173.96 222.31 185.24 224.1 199.13 226.3C211.61 228.2 223.68 230.04 235.19 231.79C222.47 229.72 210.83 227.83 200.56 226.16H200.55Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.72 234C249.53 233.94 249.34 233.88 249.15 233.82C249.13 233.82 249.11 233.82 249.08 233.81C249.26 233.87 249.44 233.93 249.62 233.99C249.65 233.99 249.69 234 249.72 234.01V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 233.94C249.9 233.94 249.92 233.95 249.93 233.96C249.93 233.96 249.92 233.95 249.91 233.94H249.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 233.95C249.91 233.95 249.92 233.96 249.93 233.97L249.91 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 234.05C250.45 234.05 250.47 234.05 250.48 234.05C250.49 234.05 250.5 234.05 250.51 234.04C250.5 234.04 250.49 234.04 250.48 234.04C250.47 234.04 250.46 234.05 250.45 234.06V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 234.1C250.35 234.1 250.37 234.1 250.38 234.1C250.47 234.09 250.56 234.07 250.65 234.06C250.65 234.06 250.64 234.06 250.63 234.06C250.57 234.06 250.51 234.06 250.44 234.06C250.42 234.06 250.41 234.07 250.39 234.08C250.38 234.08 250.36 234.09 250.35 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14 234.14C251.06 234.13 250.98 234.11 250.91 234.1C250.83 234.11 250.74 234.13 250.66 234.14C250.82 234.14 250.98 234.14 251.14 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39 234.08C250.39 234.08 250.42 234.07 250.44 234.06H250.42C250.42 234.06 250.4 234.07 250.39 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38 234.1C250.47 234.11 250.56 234.13 250.64 234.14H250.65C250.73 234.13 250.82 234.11 250.9 234.1C250.82 234.09 250.73 234.07 250.65 234.06C250.56 234.07 250.47 234.09 250.38 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.37 218.96C188.4 214.47 177.1 210.83 169.25 208.3C165.37 207.02 162.35 206.02 160.27 205.34C159.27 205 158.5 204.73 157.94 204.54C157.42 204.35 157.15 204.25 157.16 204.23C157.16 204.21 157.44 204.28 157.97 204.44C158.53 204.61 159.31 204.84 160.33 205.15C162.43 205.81 165.46 206.75 169.36 207.97C177.21 210.49 188.52 214.12 202.49 218.6C213.9 222.32 227.08 226.62 241.57 231.35C244.13 232.16 246.73 232.98 249.37 233.82C249.31 233.79 249.26 233.76 249.2 233.74C230.59 227.69 210.12 221.04 188.6 214.05C145.99 200.17 107.39 187.66 79.3903 178.77C65.3903 174.32 54.0403 170.77 46.1803 168.38C42.2503 167.18 39.1903 166.27 37.1103 165.68C35.0303 165.09 33.9203 164.82 33.8903 164.9C33.8603 164.98 34.9203 165.4 36.9603 166.13C39.0003 166.86 42.0103 167.89 45.9103 169.2C53.7003 171.81 65.0003 175.51 78.9803 180.02C106.94 189.03 145.64 201.26 188.4 214.69C209.59 221.37 229.79 227.73 248.18 233.52C245.95 232.79 243.75 232.07 241.57 231.36C227.03 226.76 213.81 222.58 202.37 218.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71 234.88C252.21 234.72 251.71 234.55 251.21 234.39C251.18 234.39 251.15 234.39 251.13 234.38C251.66 234.55 252.19 234.71 252.72 234.88H252.71Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 249.19C297.4 249.03 296.88 248.86 296.35 248.7C297.04 248.92 297.74 249.14 298.44 249.36C298.26 249.3 298.09 249.25 297.92 249.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54 234.2C250.54 234.2 250.54 234.2 250.55 234.2C250.59 234.2 250.62 234.21 250.66 234.22C250.61 234.2 250.56 234.19 250.5 234.17C250.5 234.17 250.49 234.17 250.48 234.17C250.5 234.17 250.52 234.19 250.54 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55 234.2C250.74 234.26 250.93 234.32 251.12 234.38C251.15 234.38 251.18 234.38 251.2 234.39C251.02 234.33 250.83 234.27 250.65 234.21C250.61 234.21 250.58 234.2 250.54 234.19L250.55 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.81 234.33C250.81 234.33 250.86 234.35 250.89 234.37C253.53 235.2 256.14 236.03 258.71 236.83C256.74 236.19 254.74 235.54 252.72 234.88C252.19 234.71 251.66 234.54 251.13 234.38C251.02 234.36 250.92 234.35 250.81 234.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8 249.54C311.78 254.01 323.09 257.62 330.95 260.13C334.85 261.35 337.89 262.29 339.98 262.94C341 263.24 341.78 263.48 342.34 263.64C342.87 263.79 343.15 263.86 343.15 263.85C343.15 263.83 342.89 263.73 342.37 263.55C341.82 263.36 341.04 263.1 340.04 262.76C337.95 262.07 334.93 261.08 331.05 259.81C323.3 257.33 312.17 253.76 298.44 249.36C297.74 249.14 297.04 248.92 296.35 248.7C285.27 245.21 272.59 241.22 258.69 236.84C273.19 241.55 286.38 245.84 297.79 249.55L297.8 249.54Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.46 233.87C249.46 233.87 249.4 233.84 249.37 233.83C246.73 232.99 244.13 232.17 241.57 231.36C243.74 232.07 245.95 232.79 248.18 233.52C248.5 233.62 248.83 233.72 249.15 233.83C249.25 233.85 249.36 233.86 249.46 233.88V233.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 234H249.72L249.73 234.01V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.36 207.98C165.46 206.76 162.43 205.81 160.33 205.16C159.31 204.86 158.53 204.62 157.97 204.45C157.44 204.3 157.16 204.23 157.16 204.24C157.16 204.26 157.42 204.36 157.94 204.55C158.49 204.74 159.27 205 160.27 205.35C162.35 206.04 165.37 207.03 169.25 208.31C177.1 210.84 188.41 214.47 202.37 218.97C213.81 222.59 227.03 226.77 241.57 231.37C227.07 226.64 213.89 222.34 202.49 218.62C188.52 214.14 177.21 210.51 169.36 207.99V207.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.81 234.33C250.92 234.35 251.02 234.36 251.13 234.38C250.94 234.32 250.75 234.26 250.56 234.2C250.65 234.24 250.74 234.29 250.82 234.33H250.81Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54 234.2C250.54 234.2 250.5 234.18 250.48 234.17C250.48 234.17 250.47 234.17 250.46 234.17C250.49 234.17 250.51 234.19 250.54 234.19V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.18C250.41 234.18 250.5 234.19 250.54 234.2C250.51 234.2 250.49 234.18 250.46 234.18C250.44 234.18 250.43 234.18 250.41 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.88 234.37C250.88 234.37 250.83 234.34 250.8 234.33C250.77 234.33 250.74 234.33 250.71 234.32C250.77 234.34 250.82 234.35 250.88 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.18C250.44 234.2 250.48 234.23 250.51 234.25C250.58 234.27 250.65 234.29 250.72 234.32C250.75 234.32 250.78 234.32 250.81 234.33C250.72 234.29 250.63 234.24 250.55 234.2C250.51 234.2 250.46 234.19 250.42 234.18H250.41Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 234.19C250.33 234.19 250.35 234.19 250.36 234.2C250.36 234.2 250.34 234.2 250.34 234.19H250.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 234.2C250.36 234.2 250.46 234.23 250.51 234.25C250.48 234.23 250.44 234.2 250.41 234.18C250.39 234.18 250.36 234.18 250.34 234.19C250.34 234.19 250.36 234.19 250.36 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46 234.16C250.46 234.16 250.47 234.16 250.48 234.17C250.48 234.17 250.49 234.17 250.5 234.17H250.48C250.48 234.17 250.47 234.17 250.46 234.17V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46 234.16C250.46 234.16 250.47 234.16 250.48 234.16C250.46 234.16 250.45 234.15 250.43 234.14C250.43 234.14 250.45 234.15 250.46 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46 234.17C250.46 234.17 250.47 234.17 250.48 234.17C250.48 234.17 250.47 234.17 250.46 234.16C250.44 234.16 250.43 234.16 250.41 234.16C250.43 234.16 250.44 234.16 250.46 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 234.14C250.37 234.14 250.4 234.14 250.42 234.15C250.44 234.15 250.45 234.15 250.47 234.15C250.46 234.15 250.45 234.14 250.44 234.13H250.38L250.37 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.16C250.41 234.16 250.39 234.16 250.37 234.16C250.38 234.16 250.39 234.17 250.4 234.18C250.42 234.18 250.43 234.18 250.45 234.18C250.43 234.18 250.42 234.18 250.4 234.17L250.41 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38 234.16C250.38 234.16 250.4 234.16 250.42 234.16C250.4 234.16 250.39 234.16 250.37 234.15H250.36C250.36 234.15 250.37 234.15 250.38 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 234.19C250.33 234.19 250.31 234.19 250.31 234.18C250.31 234.18 250.31 234.18 250.31 234.19H250.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.16C250.3 234.16 250.37 234.17 250.41 234.18C250.4 234.18 250.39 234.17 250.38 234.16C250.35 234.16 250.33 234.16 250.3 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.14C250.29 234.14 250.29 234.14 250.29 234.15C250.32 234.15 250.34 234.15 250.37 234.15C250.37 234.15 250.36 234.15 250.35 234.14C250.33 234.14 250.3 234.14 250.28 234.14H250.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.16C250.3 234.16 250.3 234.17 250.31 234.18C250.31 234.18 250.33 234.18 250.33 234.19C250.35 234.19 250.38 234.19 250.4 234.18C250.36 234.18 250.33 234.17 250.29 234.16H250.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 234.11C250.34 234.11 250.35 234.12 250.36 234.13C250.36 234.13 250.37 234.13 250.38 234.13H250.44C250.41 234.12 250.37 234.11 250.34 234.1L250.33 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 234.14C250.35 234.14 250.33 234.13 250.32 234.12C250.32 234.12 250.31 234.12 250.3 234.12C250.32 234.12 250.33 234.12 250.35 234.13V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.13C250.3 234.13 250.33 234.13 250.35 234.13C250.33 234.13 250.32 234.13 250.3 234.12C250.3 234.12 250.28 234.12 250.28 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.46 233.87C249.36 233.85 249.25 233.84 249.15 233.82C249.34 233.88 249.53 233.94 249.72 234C249.63 233.96 249.54 233.91 249.46 233.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61 233.85C245.82 231.93 241.96 229.97 238.01 227.97C226.02 222.01 215.06 216.56 205.44 211.78C192.38 205.21 181.8 199.89 174.45 196.19C170.83 194.33 168 192.89 166.06 191.89C165.13 191.4 164.41 191.02 163.89 190.75C163.4 190.49 163.16 190.35 163.17 190.33C163.17 190.31 163.44 190.43 163.94 190.66C164.47 190.91 165.2 191.26 166.15 191.72C168.11 192.69 170.96 194.09 174.61 195.89C177.79 197.49 181.58 199.39 185.91 201.57C148.73 182.7 115.18 165.75 90.44 153.42C77.33 146.89 66.7 141.64 59.33 138.08C55.64 136.3 52.77 134.93 50.81 134.03C48.85 133.13 47.8 132.69 47.76 132.76C47.72 132.83 48.7 133.41 50.59 134.44C52.48 135.47 55.3 136.95 58.93 138.84C66.2 142.61 76.76 147.99 89.84 154.57C115.99 167.75 152.23 185.74 192.28 205.55C212.49 215.56 231.72 225.1 249.2 233.76C249.36 233.81 249.52 233.86 249.68 233.92C249.65 233.9 249.63 233.88 249.61 233.87V233.85Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.4 234.3C250.45 234.33 250.5 234.37 250.54 234.4C250.57 234.41 250.59 234.43 250.62 234.44C250.53 234.38 250.45 234.32 250.36 234.25C250.36 234.26 250.38 234.27 250.39 234.28L250.4 234.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17 234.72C253.61 235.93 256.02 237.12 258.39 238.3C255.89 237.03 253.35 235.75 250.77 234.44C250.9 234.54 251.04 234.63 251.17 234.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39 238.3C260.86 239.55 263.29 240.78 265.67 241.99C263.52 240.9 261.39 239.82 259.29 238.75C258.99 238.6 258.69 238.45 258.39 238.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 234.01C249.73 234.01 249.77 234.03 249.79 234.04C249.79 234.04 249.8 234.04 249.81 234.04C249.78 234.04 249.76 234.02 249.73 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.7 272.22C329.36 274.02 332.2 275.42 334.17 276.38C335.12 276.84 335.86 277.19 336.38 277.44C336.88 277.67 337.14 277.78 337.15 277.77C337.15 277.75 336.91 277.61 336.43 277.35C335.91 277.08 335.19 276.7 334.26 276.21C332.31 275.22 329.49 273.77 325.86 271.92C318.51 268.23 307.93 262.93 294.85 256.37C284.44 251.21 272.45 245.27 259.28 238.75C261.39 239.82 263.51 240.9 265.66 241.99C276.27 247.37 286.02 252.31 294.67 256.69C307.75 263.24 318.34 268.54 325.69 272.22H325.7Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16 191.72C165.21 191.26 164.47 190.91 163.95 190.66C163.45 190.43 163.19 190.31 163.18 190.33C163.18 190.35 163.42 190.49 163.9 190.75C164.42 191.02 165.13 191.4 166.07 191.89C168.02 192.89 170.84 194.33 174.46 196.19C181.8 199.88 192.38 205.21 205.45 211.78C215.07 216.56 226.03 222.01 238.02 227.97C223.74 220.73 208.47 213 192.6 204.96C190.36 203.82 188.14 202.69 185.92 201.57C181.59 199.39 177.8 197.49 174.62 195.89C170.97 194.09 168.12 192.69 166.16 191.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 234.27C250.45 234.27 250.4 234.27 250.37 234.26C250.46 234.32 250.54 234.38 250.63 234.45C250.81 234.54 250.99 234.63 251.16 234.71C251.02 234.61 250.89 234.52 250.76 234.43C250.65 234.38 250.55 234.32 250.44 234.27H250.45Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 234.22C250.35 234.22 250.37 234.24 250.38 234.26C250.41 234.26 250.43 234.26 250.46 234.27C250.43 234.26 250.4 234.24 250.38 234.23C250.38 234.23 250.37 234.23 250.36 234.23L250.35 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 234.22C250.35 234.22 250.36 234.22 250.37 234.22C250.37 234.22 250.35 234.22 250.35 234.21V234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.57 233.89C249.57 233.89 249.66 233.9 249.71 233.91C249.71 233.91 249.71 233.91 249.7 233.91C249.54 233.86 249.38 233.81 249.22 233.75C249.28 233.78 249.33 233.81 249.39 233.83C249.45 233.85 249.52 233.87 249.58 233.89H249.57Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38 233.83C249.38 233.83 249.44 233.86 249.47 233.87C249.5 233.87 249.54 233.88 249.57 233.89C249.51 233.87 249.44 233.85 249.38 233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.02C249.86 234.02 249.77 234.01 249.73 234C249.76 234 249.78 234.02 249.81 234.03C249.83 234.03 249.84 234.03 249.86 234.03V234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7 233.91C249.7 233.91 249.61 233.9 249.56 233.89C249.62 233.91 249.69 233.93 249.75 233.95C249.73 233.94 249.71 233.92 249.7 233.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.02C249.83 234 249.79 233.97 249.76 233.95C249.7 233.93 249.63 233.91 249.57 233.89C249.54 233.89 249.5 233.88 249.47 233.87C249.56 233.91 249.65 233.96 249.73 234C249.77 234 249.82 234.01 249.86 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.45 226.42C228.44 218.63 218.39 211.5 209.57 205.26C197.72 196.78 188.13 189.92 181.47 185.16C178.19 182.78 175.64 180.92 173.87 179.64C173.03 179.01 172.38 178.53 171.91 178.18C171.47 177.85 171.25 177.67 171.26 177.66C171.27 177.65 171.51 177.8 171.97 178.1C172.45 178.43 173.12 178.89 173.99 179.48C175.77 180.73 178.36 182.55 181.67 184.89C184.86 187.17 188.73 189.93 193.19 193.12C159.01 168.48 128.12 146.29 105.39 130.16C93.4999 121.72 83.8399 114.92 77.1299 110.28C73.7699 107.96 71.1599 106.17 69.3599 104.98C67.5699 103.79 66.5999 103.2 66.5499 103.26C66.4999 103.32 67.3699 104.04 69.0799 105.35C70.7799 106.65 73.3199 108.55 76.6099 110.96C83.1799 115.79 92.7499 122.71 104.6 131.2C128.31 148.19 161.21 171.47 197.58 197.11C215.85 210.02 233.25 222.3 249.06 233.47C249.24 233.56 249.42 233.65 249.6 233.74C246.28 231.35 242.88 228.9 239.43 226.42H239.45Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82 233.93C249.71 233.87 249.59 233.82 249.48 233.76C249.52 233.79 249.56 233.82 249.61 233.85C249.66 233.87 249.7 233.9 249.75 233.92H249.82V233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.16 241.33C259.51 240.86 258.85 240.39 258.21 239.92C258.12 239.86 258.03 239.79 257.94 239.73C258.68 240.26 259.43 240.8 260.16 241.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48 234.38C250.48 234.38 250.49 234.39 250.5 234.4C250.6 234.5 250.69 234.59 250.79 234.69C253.21 236.4 255.59 238.08 257.94 239.74C255.52 238 253.06 236.23 250.56 234.43C250.53 234.42 250.51 234.4 250.48 234.39V234.38Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82 233.93C249.82 233.93 249.87 233.93 249.89 233.94C249.8 233.87 249.71 233.81 249.62 233.74C249.44 233.65 249.26 233.56 249.08 233.47C249.22 233.57 249.35 233.66 249.49 233.76C249.6 233.82 249.71 233.87 249.83 233.93H249.82Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.52 263.18C302.38 271.63 311.99 278.48 318.66 283.23C321.98 285.56 324.57 287.37 326.35 288.63C327.22 289.22 327.89 289.68 328.37 290.01C328.83 290.32 329.07 290.47 329.08 290.45C329.09 290.44 328.87 290.26 328.43 289.93C327.96 289.58 327.31 289.1 326.47 288.47C324.71 287.19 322.15 285.34 318.87 282.96C312.2 278.2 302.6 271.35 290.75 262.89C281.24 256.17 270.26 248.42 258.22 239.92C258.87 240.39 259.52 240.86 260.17 241.33C271.37 249.39 281.59 256.75 290.53 263.18H290.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 179.48C173.13 178.88 172.46 178.43 171.98 178.1C171.52 177.79 171.28 177.64 171.27 177.66C171.26 177.67 171.48 177.85 171.92 178.18C172.39 178.53 173.04 179.01 173.88 179.64C175.64 180.92 178.2 182.78 181.48 185.16C188.14 189.93 197.73 196.79 209.58 205.26C218.39 211.5 228.45 218.63 239.46 226.42C226.43 217.04 212.5 207.01 198.01 196.58C196.4 195.42 194.81 194.27 193.21 193.12C188.75 189.93 184.88 187.17 181.69 184.89C178.37 182.56 175.79 180.74 174.01 179.48H174Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77 234.67C250.77 234.67 250.78 234.67 250.79 234.68C250.69 234.58 250.6 234.49 250.5 234.39C250.59 234.48 250.68 234.57 250.78 234.66L250.77 234.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.3C250.25 234.3 250.24 234.28 250.23 234.27C250.23 234.27 250.23 234.28 250.23 234.29C250.23 234.29 250.24 234.29 250.25 234.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.77 233.93C249.77 233.93 249.86 233.96 249.91 233.97C249.88 233.96 249.85 233.94 249.83 233.93H249.76C249.76 233.93 249.77 233.93 249.78 233.93H249.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 233.98C249.92 233.98 249.9 233.96 249.89 233.94C249.87 233.94 249.84 233.94 249.82 233.93C249.85 233.94 249.88 233.96 249.9 233.97C249.9 233.97 249.91 233.97 249.92 233.97V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 233.99C249.96 233.99 249.94 233.97 249.93 233.96C249.93 233.96 249.91 233.95 249.9 233.94C249.9 233.95 249.92 233.96 249.93 233.98C249.94 233.98 249.95 233.98 249.96 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 233.97C249.94 233.97 249.96 233.99 249.97 234C249.97 234 249.95 233.99 249.95 233.98L249.94 233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.01C249.95 234.01 249.94 233.99 249.93 233.98C249.93 233.98 249.92 233.98 249.91 233.97C249.86 233.96 249.82 233.94 249.77 233.93C249.81 233.95 249.86 233.97 249.9 234C249.91 234 249.93 234 249.94 234.01H249.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.01C249.95 234.01 249.92 234.01 249.91 234C249.91 234 249.93 234 249.94 234.01C249.94 234.01 249.94 234.01 249.95 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 233.98C249.92 233.98 249.91 233.98 249.9 233.98C249.9 233.98 249.91 233.98 249.92 233.99V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93 233.98C249.93 233.98 249.94 234 249.95 234.01H249.97C249.96 234.01 249.94 234 249.93 233.99V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.01C249.97 234.01 249.96 234 249.95 233.99C249.94 233.99 249.93 233.99 249.92 233.98C249.93 233.98 249.95 233.99 249.96 234L249.97 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.01C249.97 234.01 249.96 234.01 249.95 234C249.95 234 249.96 234.01 249.97 234.02V234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 234.41C250.56 234.41 250.46 234.34 250.42 234.31C250.44 234.33 250.46 234.35 250.49 234.38C250.52 234.39 250.54 234.41 250.57 234.42L250.56 234.41Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75 233.92C249.75 233.92 249.66 233.87 249.61 233.85C249.64 233.87 249.66 233.89 249.68 233.9C249.69 233.9 249.71 233.9 249.72 233.91C249.72 233.91 249.73 233.91 249.74 233.91L249.75 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 233.92C249.73 233.92 249.76 233.92 249.77 233.93C249.77 233.93 249.76 233.93 249.75 233.93C249.75 233.93 249.74 233.93 249.73 233.93V233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.69 233.9C249.69 233.9 249.69 233.9 249.7 233.9C249.7 233.9 249.72 233.9 249.73 233.9C249.72 233.9 249.7 233.9 249.69 233.89V233.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.09V234.08L250 234.09H250.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 234C249.9 234 249.81 233.96 249.77 233.93C249.76 233.93 249.74 233.93 249.73 233.92C249.73 233.92 249.71 233.92 249.7 233.92C249.72 233.93 249.74 233.95 249.75 233.96C249.8 233.98 249.85 233.99 249.9 234.01V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 234C249.9 234 249.8 233.97 249.75 233.95C249.78 233.97 249.82 234 249.85 234.02C249.87 234.02 249.9 234.02 249.92 234.01C249.92 234.01 249.9 234.01 249.89 234H249.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.19 227.28C232.62 217 222.99 207.63 214.65 199.51C204.3 189.35 195.93 181.12 190.11 175.4C187.25 172.55 185.02 170.33 183.49 168.8C182.76 168.05 182.19 167.48 181.79 167.06C181.41 166.66 181.22 166.46 181.24 166.44C181.25 166.43 181.46 166.61 181.87 166.99C182.29 167.39 182.88 167.94 183.64 168.66C185.2 170.17 187.46 172.35 190.37 175.16C196.19 180.87 204.57 189.09 214.92 199.25C223.19 207.44 232.73 216.9 243.2 227.27C245.29 229.3 247.41 231.37 249.58 233.47C249.57 233.45 249.55 233.44 249.54 233.42C235.77 219.81 220.62 204.84 204.7 189.11C173.22 157.95 144.66 129.77 123.86 109.5C113.46 99.3601 105.01 91.1901 99.1202 85.5901C96.1802 82.7901 93.8802 80.6301 92.3002 79.1801C90.7202 77.7301 89.8602 77.0001 89.8002 77.0601C89.7402 77.1201 90.4902 77.9601 91.9602 79.5001C93.4402 81.0501 95.6402 83.3001 98.5002 86.1801C104.22 91.9401 112.56 100.22 122.92 110.4C143.62 130.77 172.4 158.73 204.22 189.57C220.29 205.17 235.59 220.01 249.49 233.5C249.49 233.5 249.51 233.51 249.52 233.52C247.38 231.4 245.28 229.32 243.21 227.27L243.19 227.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79 233.83C249.69 233.73 249.59 233.63 249.49 233.54C249.49 233.54 249.47 233.53 249.46 233.52C249.57 233.62 249.67 233.73 249.78 233.83H249.79Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79 233.83C249.81 233.85 249.83 233.87 249.86 233.9C249.84 233.88 249.82 233.86 249.8 233.84L249.79 233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71 234.72C252.88 236.82 255.01 238.89 257.1 240.92C255.03 238.87 252.92 236.79 250.78 234.67C250.71 234.62 250.64 234.57 250.57 234.52C250.62 234.59 250.67 234.65 250.72 234.72H250.71Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.56 233.49C247.4 231.39 245.27 229.32 243.18 227.29C245.25 229.34 247.35 231.42 249.49 233.54C249.56 233.59 249.63 233.64 249.7 233.69C249.65 233.62 249.6 233.56 249.56 233.49Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.35 175.17C187.45 172.36 185.18 170.18 183.62 168.67C182.86 167.95 182.27 167.4 181.85 167C181.45 166.63 181.23 166.44 181.22 166.45C181.21 166.46 181.4 166.67 181.77 167.07C182.17 167.48 182.74 168.06 183.47 168.81C185.01 170.34 187.23 172.56 190.09 175.41C195.91 181.12 204.28 189.35 214.63 199.52C222.98 207.64 232.61 217.01 243.17 227.29C232.7 216.92 223.16 207.46 214.89 199.27C204.54 189.11 196.15 180.89 190.34 175.18L190.35 175.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 292.96C312.91 295.76 315.17 297.95 316.73 299.45C317.49 300.17 318.08 300.72 318.5 301.12C318.9 301.49 319.12 301.68 319.13 301.66C319.14 301.65 318.95 301.44 318.57 301.05C318.16 300.64 317.6 300.06 316.87 299.32C315.33 297.79 313.1 295.57 310.24 292.73C304.42 287.02 296.03 278.81 285.67 268.65C277.32 260.54 267.68 251.19 257.1 240.92C267.58 251.28 277.13 260.72 285.41 268.9C295.78 279.04 304.17 287.26 310 292.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 233.9V233.89L249.87 233.9H249.86Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.71 233.68C249.64 233.63 249.57 233.58 249.5 233.53C249.6 233.63 249.7 233.72 249.8 233.82C249.81 233.82 249.82 233.83 249.83 233.84C249.79 233.79 249.75 233.73 249.71 233.68Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 233.89C249.85 233.87 249.83 233.85 249.82 233.84C249.81 233.84 249.8 233.83 249.79 233.82C249.81 233.84 249.83 233.86 249.85 233.88L249.86 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87 233.78C249.87 233.78 249.87 233.77 249.86 233.76C249.75 233.65 249.64 233.54 249.53 233.43C249.54 233.45 249.56 233.46 249.57 233.48C249.67 233.58 249.77 233.68 249.87 233.78Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88 233.8C249.88 233.8 249.88 233.78 249.87 233.78C249.77 233.68 249.67 233.58 249.57 233.48C249.62 233.55 249.67 233.61 249.71 233.68C249.77 233.72 249.82 233.76 249.88 233.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 233.95H249.93C249.91 233.93 249.88 233.91 249.86 233.9C249.88 233.92 249.89 233.93 249.91 233.94V233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88 233.8C249.82 233.76 249.77 233.72 249.71 233.68C249.75 233.73 249.79 233.79 249.83 233.84C249.86 233.86 249.9 233.87 249.93 233.89C249.91 233.86 249.9 233.83 249.88 233.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 233.95C249.95 233.95 249.93 233.91 249.92 233.89C249.89 233.87 249.85 233.86 249.82 233.84C249.83 233.86 249.85 233.88 249.86 233.89C249.88 233.91 249.91 233.93 249.93 233.94C249.93 233.94 249.94 233.94 249.95 233.94V233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 233.81C249.9 233.81 249.91 233.83 249.92 233.84C249.92 233.84 249.94 233.85 249.95 233.86C249.93 233.84 249.92 233.83 249.9 233.81Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 233.89C249.98 233.89 249.97 233.88 249.96 233.87C249.96 233.87 249.94 233.86 249.93 233.85C249.95 233.87 249.96 233.88 249.98 233.9V233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93 233.84C249.93 233.84 249.96 233.89 249.98 233.91V233.89C249.96 233.87 249.95 233.86 249.93 233.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 233.84C249.92 233.84 249.91 233.82 249.9 233.81C249.88 233.79 249.87 233.78 249.85 233.76C249.85 233.76 249.85 233.77 249.86 233.78C249.88 233.8 249.9 233.81 249.91 233.83L249.92 233.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 233.84V233.83L249.93 233.84H249.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 233.83C249.92 233.83 249.88 233.79 249.87 233.78C249.87 233.78 249.87 233.79 249.88 233.8C249.89 233.81 249.91 233.82 249.92 233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 233.92C249.98 233.92 249.98 233.92 249.98 233.91C249.96 233.89 249.95 233.86 249.93 233.84C249.92 233.83 249.9 233.82 249.89 233.81C249.9 233.84 249.92 233.87 249.94 233.9C249.96 233.9 249.98 233.92 250 233.93L249.98 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 233.92C249.98 233.92 249.94 233.9 249.92 233.89C249.93 233.91 249.94 233.93 249.95 233.95C249.96 233.95 249.97 233.95 249.98 233.95C249.98 233.94 249.98 233.93 249.98 233.91V233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234C249.98 234 249.98 233.98 249.97 233.97C249.97 233.97 249.95 233.96 249.95 233.95H249.93L249.95 233.97C249.96 233.97 249.97 233.99 249.99 234H249.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 233.95C249.95 233.95 249.94 233.95 249.93 233.95C249.93 233.95 249.95 233.96 249.95 233.97C249.95 233.97 249.95 233.97 249.95 233.96V233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 233.99C249.99 233.99 249.97 233.98 249.96 233.97C249.96 233.97 249.96 233.99 249.97 234C249.97 234 249.98 234 249.99 234C249.99 234 249.99 234 249.99 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 233.99C249.99 233.99 249.99 233.97 249.99 233.96C249.98 233.96 249.97 233.96 249.96 233.96C249.96 233.96 249.96 233.96 249.96 233.97C249.97 233.97 249.98 233.98 249.99 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.31L250.4 234.3L250.41 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5 234.4C250.5 234.4 250.49 234.39 250.48 234.38C250.48 234.38 250.49 234.39 250.5 234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48 234.38C250.48 234.38 250.46 234.37 250.45 234.36C250.49 234.41 250.53 234.47 250.57 234.52C250.64 234.57 250.71 234.62 250.78 234.67C250.69 234.58 250.6 234.49 250.5 234.4C250.5 234.4 250.49 234.39 250.48 234.38Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 233.97C249.94 233.97 249.95 233.98 249.96 233.99C249.96 233.99 249.96 233.99 249.97 233.99C249.96 233.99 249.95 233.97 249.93 233.96L249.94 233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234C249.98 234 249.98 234 249.97 234C249.97 234 249.98 234 249.99 234.01L249.98 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.31C250.41 234.31 250.46 234.36 250.48 234.38C250.46 234.36 250.44 234.34 250.41 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 234.36C250.45 234.36 250.47 234.37 250.48 234.38C250.46 234.36 250.43 234.33 250.41 234.31C250.42 234.33 250.44 234.34 250.45 234.36Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.28 285.1C289.65 286.92 291 288.73 292.35 290.54C288.69 285.62 284.47 279.93 279.75 273.57C272.77 264.26 264.71 253.52 255.86 241.72C256.66 242.8 257.46 243.89 258.24 244.96C267.69 257.59 277.78 271.08 288.28 285.11V285.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.19 167.08C197.82 163.83 195.98 161.3 194.71 159.56C194.11 158.71 193.64 158.06 193.31 157.59C193 157.14 192.85 156.91 192.86 156.9C192.87 156.9 193.05 157.1 193.39 157.53C193.74 157.99 194.23 158.62 194.87 159.45C196.17 161.18 198.05 163.68 200.47 166.89C205.31 173.41 212.27 182.8 220.87 194.4C227.64 203.63 235.44 214.25 244 225.91C245.96 228.52 247.89 231.09 249.78 233.62C249.69 233.45 249.6 233.27 249.51 233.1C238.13 217.64 225.62 200.63 212.47 182.77C186.36 147.23 162.66 115.08 145.35 91.9099C136.7 80.3199 129.66 70.9699 124.74 64.5499C122.28 61.3399 120.35 58.8599 119.02 57.1899C117.69 55.5199 116.96 54.6699 116.89 54.7199C116.82 54.7699 117.43 55.7099 118.64 57.4599C119.85 59.2099 121.67 61.7699 124.03 65.0499C128.76 71.6099 135.67 81.0499 144.27 92.6699C161.46 115.92 185.41 147.89 211.91 183.16C222 196.62 231.73 209.58 240.87 221.76C233.42 211.81 226.59 202.67 220.56 194.62C211.97 183.02 205.01 173.62 200.18 167.1L200.19 167.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44 234.5C252.28 236.95 254.08 239.35 255.86 241.72C254.19 239.45 252.49 237.14 250.76 234.79C250.65 234.68 250.54 234.57 250.42 234.45C250.42 234.47 250.44 234.48 250.45 234.5H250.44Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87 233.57C249.87 233.57 249.83 233.51 249.8 233.48C249.85 233.58 249.91 233.68 249.96 233.78C249.96 233.76 249.96 233.74 249.96 233.73C249.93 233.68 249.9 233.62 249.88 233.57H249.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 234.22C250.34 234.22 250.33 234.2 250.32 234.2H250.3C250.31 234.2 250.33 234.21 250.34 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42 234.45C250.53 234.56 250.64 234.67 250.76 234.79C250.74 234.77 250.73 234.75 250.71 234.73C250.61 234.63 250.51 234.53 250.41 234.44C250.41 234.44 250.41 234.46 250.42 234.46V234.45Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.87 194.39C212.27 182.79 205.3 173.4 200.47 166.88C198.05 163.67 196.17 161.17 194.87 159.44C194.23 158.61 193.74 157.98 193.39 157.52C193.05 157.09 192.87 156.88 192.86 156.89C192.85 156.89 193 157.13 193.31 157.58C193.64 158.05 194.11 158.7 194.71 159.55C195.98 161.3 197.83 163.82 200.19 167.07C205.02 173.59 211.98 182.99 220.57 194.59C226.6 202.64 233.43 211.78 240.88 221.73C241.93 223.13 242.97 224.51 244 225.89C235.44 214.23 227.64 203.61 220.87 194.38V194.39Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.24 244.95C266.05 255.56 273.19 265.26 279.45 273.77C288.07 285.36 295.04 294.74 299.89 301.25C302.31 304.46 304.2 306.96 305.5 308.68C306.14 309.51 306.63 310.14 306.98 310.6C307.32 311.03 307.5 311.24 307.51 311.23C307.52 311.22 307.37 310.99 307.06 310.54C306.73 310.07 306.26 309.42 305.65 308.57C304.37 306.83 302.53 304.3 300.16 301.05C297.98 298.11 295.35 294.58 292.35 290.53C291 288.73 289.64 286.92 288.28 285.09C277.78 271.06 267.69 257.57 258.24 244.94V244.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 233.87C249.97 233.87 249.97 233.81 249.96 233.79C249.91 233.69 249.85 233.59 249.8 233.49C249.7 233.36 249.61 233.23 249.51 233.1C249.6 233.27 249.69 233.45 249.78 233.62C249.85 233.71 249.91 233.79 249.97 233.88V233.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.18C250.28 234.18 250.28 234.18 250.29 234.19H250.31C250.3 234.19 250.28 234.19 250.27 234.18H250.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.16C250.27 234.16 250.27 234.17 250.28 234.18C250.29 234.18 250.31 234.18 250.32 234.19C250.32 234.19 250.32 234.19 250.32 234.18C250.31 234.18 250.29 234.17 250.28 234.16H250.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.16C250.27 234.16 250.29 234.16 250.3 234.16C250.3 234.16 250.3 234.16 250.3 234.15H250.28C250.28 234.15 250.28 234.15 250.28 234.16H250.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 234.18C250.31 234.18 250.31 234.17 250.3 234.16C250.29 234.16 250.28 234.16 250.27 234.16C250.28 234.16 250.3 234.17 250.31 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 234.26C250.36 234.26 250.39 234.29 250.41 234.3C250.41 234.29 250.39 234.28 250.38 234.27C250.38 234.27 250.38 234.27 250.37 234.27L250.36 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 234.26C250.37 234.26 250.35 234.25 250.35 234.24C250.35 234.24 250.36 234.25 250.37 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 234.21C250.31 234.21 250.33 234.23 250.34 234.24C250.34 234.24 250.36 234.25 250.36 234.26C250.36 234.25 250.34 234.24 250.33 234.22C250.32 234.22 250.31 234.22 250.3 234.21H250.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.2C250.3 234.2 250.31 234.21 250.32 234.22C250.33 234.22 250.34 234.22 250.35 234.23C250.34 234.23 250.32 234.22 250.31 234.21L250.3 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.2L250.29 234.19L250.3 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39 234.4C250.39 234.4 250.39 234.42 250.4 234.42C250.5 234.52 250.6 234.62 250.7 234.71C250.65 234.64 250.6 234.58 250.55 234.51C250.49 234.47 250.44 234.43 250.38 234.39L250.39 234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.19C250.29 234.19 250.29 234.19 250.28 234.18L250.29 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 234.26C250.36 234.26 250.39 234.29 250.41 234.31C250.39 234.3 250.38 234.28 250.36 234.27V234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 234.26C250.36 234.26 250.35 234.25 250.34 234.24C250.34 234.24 250.36 234.25 250.36 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 234.24C250.33 234.24 250.31 234.22 250.3 234.21L250.32 234.23L250.33 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.2C250.29 234.2 250.29 234.2 250.3 234.21C250.3 234.21 250.29 234.2 250.28 234.19L250.29 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.31C250.41 234.31 250.38 234.28 250.36 234.26H250.34C250.36 234.28 250.39 234.3 250.41 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.21C250.29 234.21 250.3 234.23 250.31 234.24C250.31 234.24 250.32 234.25 250.33 234.26H250.35C250.35 234.26 250.33 234.25 250.33 234.24C250.32 234.24 250.31 234.22 250.29 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.21C250.29 234.21 250.31 234.23 250.33 234.24L250.31 234.22C250.31 234.22 250.31 234.22 250.3 234.22L250.29 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.21C250.29 234.21 250.29 234.21 250.3 234.21C250.3 234.21 250.3 234.21 250.29 234.2V234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.19V234.2H250.3L250.29 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39 234.4C250.45 234.44 250.5 234.48 250.56 234.52C250.52 234.47 250.48 234.41 250.44 234.36C250.41 234.34 250.38 234.33 250.34 234.31C250.36 234.34 250.37 234.37 250.39 234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.31C250.41 234.31 250.36 234.27 250.34 234.26C250.34 234.26 250.33 234.26 250.32 234.26C250.33 234.28 250.34 234.3 250.35 234.32C250.38 234.34 250.41 234.35 250.45 234.37C250.44 234.35 250.42 234.34 250.41 234.32V234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 234.25C250.32 234.25 250.33 234.25 250.34 234.25C250.34 234.25 250.33 234.24 250.32 234.23C250.32 234.23 250.32 234.23 250.32 234.24V234.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62 290.28C280.58 292.1 281.53 293.91 282.48 295.71C279.73 290.42 276.56 284.34 273.04 277.57C267.59 267.23 261.3 255.28 254.39 242.15C254.95 243.24 255.5 244.31 256.05 245.38C263.45 259.48 271.38 274.57 279.62 290.27V290.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59 160.32C209.77 156.75 208.36 153.97 207.38 152.06C206.92 151.13 206.57 150.41 206.31 149.9C206.07 149.41 205.96 149.16 205.98 149.15C206 149.15 206.14 149.38 206.41 149.86C206.68 150.36 207.07 151.07 207.56 151.98C208.57 153.88 210.03 156.64 211.9 160.18C215.63 167.35 220.99 177.69 227.63 190.45C232.9 200.73 238.98 212.57 245.66 225.58C247.08 228.29 248.49 230.95 249.87 233.58C249.89 233.61 249.91 233.63 249.93 233.66C249.88 233.5 249.83 233.35 249.77 233.19C240.99 216.14 231.34 197.38 221.19 177.67C201.12 138.6 182.88 103.24 169.52 77.7202C162.84 64.9602 157.39 54.6602 153.56 47.5702C151.65 44.0202 150.14 41.2802 149.1 39.4302C148.05 37.5802 147.47 36.6302 147.39 36.6702C147.32 36.7102 147.76 37.7302 148.67 39.6402C149.58 41.5502 150.97 44.3602 152.77 47.9602C156.38 55.1602 161.7 65.5302 168.32 78.3202C181.56 103.9 200.07 139.12 220.58 177.98C228.69 193.38 236.48 208.18 243.79 222.05C237.72 210.49 232.17 199.91 227.29 190.62C220.67 177.85 215.31 167.52 211.59 160.34V160.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39 242.15C253.2 239.85 252 237.5 250.78 235.13C250.68 234.99 250.59 234.86 250.49 234.73C251.81 237.24 253.12 239.72 254.4 242.15H254.39Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 234.4C250.37 234.4 250.33 234.36 250.31 234.34C250.31 234.34 250.3 234.34 250.29 234.33C250.36 234.42 250.42 234.51 250.49 234.6C250.47 234.56 250.45 234.53 250.43 234.49C250.41 234.46 250.38 234.43 250.36 234.39L250.37 234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 234.34C250.31 234.34 250.35 234.38 250.37 234.4C250.37 234.39 250.35 234.38 250.34 234.36C250.33 234.36 250.32 234.35 250.31 234.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 234.42C250.37 234.53 250.42 234.63 250.48 234.74C250.58 234.87 250.67 235.01 250.77 235.14C250.68 234.97 250.59 234.79 250.5 234.61C250.43 234.52 250.37 234.43 250.3 234.34C250.3 234.37 250.3 234.39 250.31 234.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63 190.44C221 177.68 215.63 167.34 211.9 160.17C210.03 156.63 208.57 153.87 207.56 151.97C207.06 151.06 206.68 150.35 206.41 149.85C206.14 149.38 206 149.14 205.98 149.14C205.96 149.14 206.08 149.4 206.31 149.89C206.56 150.4 206.92 151.12 207.38 152.05C208.36 153.97 209.77 156.74 211.59 160.31C215.31 167.49 220.67 177.82 227.29 190.59C232.17 199.88 237.72 210.45 243.79 222.02C244.41 223.21 245.04 224.39 245.66 225.56C238.98 212.54 232.9 200.7 227.63 190.43V190.44Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.05 245.39C262.19 257.31 267.79 268.2 272.7 277.74C279.35 290.5 284.73 300.82 288.47 307.99C290.35 311.53 291.81 314.28 292.82 316.18C293.32 317.09 293.7 317.79 293.98 318.3C294.25 318.77 294.39 319.01 294.41 319.01C294.43 319.01 294.31 318.75 294.08 318.26C293.83 317.75 293.47 317.03 293.01 316.1C292.03 314.18 290.61 311.41 288.79 307.84C287.04 304.47 284.92 300.4 282.49 295.72C281.54 293.91 280.59 292.11 279.63 290.29C271.39 274.59 263.47 259.5 256.06 245.4L256.05 245.39Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 233.8C250.06 233.8 250.06 233.78 250.06 233.77C250.05 233.75 250.04 233.73 250.03 233.71C250.03 233.71 250.03 233.71 250.03 233.72C250.03 233.75 250.05 233.77 250.05 233.8H250.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.34V234.33H250.29L250.3 234.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.31C250.26 234.31 250.27 234.35 250.28 234.36C250.28 234.38 250.3 234.4 250.31 234.41C250.31 234.38 250.31 234.36 250.3 234.33C250.3 234.33 250.28 234.32 250.27 234.31H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.36C250.28 234.36 250.27 234.33 250.26 234.31C250.26 234.31 250.25 234.31 250.24 234.3C250.25 234.32 250.26 234.34 250.27 234.36H250.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 233.8V233.77C250.08 233.77 250.06 233.79 250.06 233.8C250.06 233.82 250.07 233.84 250.08 233.86C250.08 233.84 250.08 233.82 250.08 233.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.33C250.3 234.33 250.31 234.33 250.32 234.34C250.32 234.34 250.31 234.33 250.3 234.32V234.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 234.36C250.34 234.36 250.31 234.33 250.29 234.31C250.29 234.31 250.29 234.31 250.29 234.32C250.29 234.32 250.3 234.33 250.31 234.34C250.32 234.34 250.33 234.36 250.34 234.36Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.31C250.27 234.31 250.28 234.33 250.29 234.33C250.29 234.33 250.28 234.32 250.27 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.28C250.25 234.28 250.26 234.3 250.27 234.31C250.27 234.31 250.28 234.32 250.29 234.33C250.29 234.33 250.29 234.33 250.29 234.32C250.28 234.31 250.26 234.29 250.25 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.31C250.26 234.31 250.28 234.32 250.29 234.33C250.29 234.33 250.28 234.31 250.27 234.31C250.27 234.31 250.26 234.3 250.25 234.29C250.25 234.29 250.25 234.3 250.25 234.31H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.29C250.26 234.29 250.27 234.3 250.28 234.31C250.28 234.31 250.27 234.29 250.26 234.28C250.26 234.28 250.26 234.28 250.26 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.26C250.23 234.27 250.24 234.28 250.25 234.29C250.25 234.29 250.26 234.29 250.27 234.3C250.27 234.3 250.27 234.29 250.27 234.28C250.27 234.28 250.25 234.26 250.24 234.25L250.23 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.26C250.23 234.26 250.25 234.28 250.26 234.29C250.26 234.29 250.26 234.29 250.26 234.28C250.26 234.28 250.25 234.27 250.24 234.26H250.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 234.36C250.34 234.36 250.31 234.31 250.29 234.29V234.31C250.31 234.33 250.32 234.34 250.34 234.36Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.26C250.25 234.26 250.25 234.26 250.25 234.27C250.26 234.28 250.28 234.3 250.29 234.31V234.29C250.29 234.29 250.29 234.28 250.28 234.27C250.28 234.27 250.26 234.27 250.25 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.27C250.25 234.27 250.25 234.27 250.25 234.26C250.25 234.26 250.25 234.27 250.26 234.28L250.25 234.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.26C250.23 234.26 250.24 234.27 250.25 234.28C250.25 234.28 250.25 234.27 250.24 234.26H250.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.26C250.25 234.26 250.27 234.26 250.28 234.27C250.28 234.26 250.26 234.25 250.25 234.23C250.25 234.23 250.25 234.23 250.24 234.23V234.25L250.25 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.23C250.24 234.23 250.24 234.23 250.24 234.24C250.24 234.24 250.24 234.24 250.25 234.24C250.25 234.24 250.25 234.23 250.24 234.22V234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.26L250.23 234.25L250.24 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44 234.5C250.44 234.5 250.42 234.47 250.41 234.45C250.39 234.43 250.38 234.42 250.36 234.4C250.38 234.43 250.41 234.46 250.43 234.5H250.44Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 233.73C249.95 233.73 249.93 233.68 249.93 233.66C249.91 233.63 249.89 233.61 249.87 233.58C249.9 233.63 249.93 233.69 249.95 233.74V233.73Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 234.37C250.35 234.37 250.37 234.39 250.38 234.41C250.4 234.43 250.41 234.44 250.43 234.46C250.43 234.46 250.43 234.44 250.42 234.44C250.4 234.42 250.38 234.4 250.36 234.38L250.35 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.17C250.27 234.17 250.27 234.16 250.26 234.15C250.26 234.15 250.26 234.15 250.26 234.16L250.27 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.16C250.26 234.16 250.27 234.17 250.28 234.18C250.28 234.18 250.28 234.18 250.28 234.17L250.26 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.15C250.25 234.15 250.26 234.15 250.27 234.15C250.27 234.15 250.27 234.15 250.27 234.14L250.25 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 234.37L250.34 234.36L250.35 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.42C250.41 234.42 250.41 234.4 250.4 234.4C250.38 234.39 250.37 234.38 250.35 234.37C250.37 234.39 250.39 234.41 250.41 234.43V234.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.18C250.27 234.18 250.27 234.18 250.28 234.19L250.27 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.18C250.27 234.18 250.27 234.18 250.28 234.18C250.28 234.18 250.28 234.18 250.27 234.17V234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.17C250.25 234.17 250.27 234.17 250.28 234.18H250.26L250.25 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.18H250.28L250.27 234.17V234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.16C250.25 234.16 250.26 234.17 250.27 234.18C250.27 234.18 250.26 234.17 250.25 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.16C250.25 234.16 250.25 234.16 250.25 234.17H250.27C250.27 234.17 250.26 234.16 250.25 234.15V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.2C250.28 234.2 250.28 234.2 250.28 234.21C250.29 234.21 250.3 234.23 250.31 234.23C250.31 234.23 250.3 234.21 250.29 234.2C250.29 234.2 250.28 234.2 250.27 234.2H250.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.21V234.2H250.28L250.29 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.2C250.26 234.2 250.27 234.2 250.28 234.21C250.28 234.21 250.28 234.21 250.28 234.2C250.28 234.2 250.28 234.2 250.27 234.2H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.19L250.28 234.2L250.27 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.19C250.25 234.19 250.26 234.19 250.27 234.2C250.27 234.2 250.27 234.2 250.28 234.2C250.28 234.2 250.26 234.2 250.25 234.2V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.19C250.24 234.19 250.26 234.19 250.27 234.19C250.27 234.19 250.25 234.18 250.24 234.17C250.24 234.17 250.24 234.18 250.24 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.17C250.25 234.17 250.27 234.18 250.28 234.19C250.28 234.19 250.26 234.19 250.25 234.18V234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.28C250.29 234.28 250.29 234.28 250.29 234.29C250.31 234.31 250.32 234.34 250.34 234.36C250.36 234.37 250.37 234.38 250.39 234.39C250.37 234.36 250.36 234.33 250.34 234.3C250.32 234.3 250.3 234.28 250.28 234.27L250.29 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.29C250.29 234.29 250.29 234.29 250.29 234.28C250.29 234.28 250.29 234.28 250.28 234.28C250.28 234.28 250.28 234.29 250.29 234.3V234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.28C250.29 234.28 250.33 234.3 250.35 234.31C250.34 234.29 250.33 234.27 250.32 234.25C250.31 234.25 250.3 234.25 250.29 234.25C250.29 234.26 250.29 234.27 250.29 234.29V234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.21C250.28 234.21 250.28 234.23 250.28 234.24C250.29 234.24 250.3 234.24 250.31 234.24C250.31 234.24 250.31 234.24 250.31 234.23C250.3 234.23 250.29 234.21 250.28 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.24C250.25 234.24 250.27 234.26 250.28 234.28C250.28 234.28 250.28 234.28 250.29 234.28C250.29 234.27 250.29 234.26 250.29 234.24C250.28 234.24 250.27 234.24 250.26 234.24H250.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.21C250.24 234.21 250.24 234.22 250.24 234.23C250.24 234.23 250.24 234.24 250.25 234.25C250.26 234.25 250.27 234.25 250.28 234.25C250.28 234.24 250.28 234.23 250.28 234.22C250.28 234.22 250.27 234.22 250.26 234.21C250.26 234.21 250.25 234.21 250.24 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.19C250.24 234.19 250.24 234.2 250.24 234.21C250.24 234.21 250.25 234.21 250.26 234.21C250.26 234.21 250.25 234.21 250.24 234.2V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.99 230.5C245.47 219.66 241.74 208.2 237.87 196.28C240.78 205.26 243.97 215.15 247.41 225.76C247.93 227.32 248.46 228.9 248.99 230.49V230.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43 235.16C250.62 235.73 250.81 236.29 251 236.86C250.8 236.25 250.61 235.64 250.41 235.04C250.41 235.08 250.42 235.12 250.43 235.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.44C250.2 234.44 250.2 234.46 250.2 234.47C250.22 234.53 250.24 234.58 250.26 234.64C250.26 234.59 250.25 234.55 250.24 234.5C250.23 234.48 250.22 234.46 250.21 234.44H250.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.41 225.76C242.69 211.62 238.4 198.76 234.68 187.63C230.21 174.01 226.59 162.98 224.08 155.32C222.86 151.52 221.92 148.56 221.26 146.52C220.96 145.53 220.72 144.77 220.56 144.22C220.41 143.7 220.34 143.43 220.35 143.43C220.37 143.43 220.47 143.68 220.66 144.19C220.85 144.73 221.11 145.48 221.46 146.46C222.15 148.49 223.14 151.44 224.42 155.22C226.75 162.31 230.03 172.28 234.06 184.52C232.92 181.03 231.78 177.5 230.62 173.95C217.12 132.29 204.84 94.5901 195.77 67.3501C191.24 53.7301 187.52 42.7201 184.89 35.1301C183.57 31.3401 182.53 28.4001 181.8 26.4101C181.07 24.4201 180.64 23.3901 180.56 23.4201C180.48 23.4401 180.75 24.5201 181.34 26.5501C181.93 28.5801 182.84 31.5601 184.05 35.3901C186.45 43.0501 190.02 54.1101 194.49 67.7501C203.43 95.0301 216.01 132.64 229.96 174.16C236.99 195.11 243.68 215.06 249.75 233.19C249.79 233.27 249.83 233.34 249.87 233.42C249.03 230.83 248.21 228.28 247.4 225.77L247.41 225.76Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.41C250.21 234.41 250.21 234.43 250.21 234.44C250.22 234.46 250.23 234.48 250.24 234.5C250.24 234.5 250.24 234.49 250.24 234.48C250.24 234.46 250.22 234.43 250.22 234.41H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.96 312.95C277.24 316.73 278.24 319.67 278.93 321.71C279.27 322.69 279.54 323.44 279.73 323.98C279.92 324.49 280.02 324.75 280.04 324.74C280.06 324.74 279.99 324.47 279.83 323.95C279.66 323.4 279.43 322.64 279.12 321.65C278.46 319.61 277.51 316.65 276.29 312.85C273.77 305.2 270.13 294.17 265.64 280.56C261.91 269.44 257.61 256.61 252.87 242.48C257.47 256.65 261.66 269.52 265.28 280.67C269.78 294.28 273.42 305.3 275.95 312.95H275.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.45 146.47C221.11 145.49 220.84 144.74 220.65 144.2C220.46 143.69 220.36 143.43 220.34 143.44C220.32 143.44 220.39 143.71 220.55 144.23C220.72 144.78 220.95 145.54 221.25 146.53C221.9 148.57 222.85 151.53 224.07 155.33C226.58 162.99 230.2 174.01 234.67 187.64C238.39 198.77 242.68 211.62 247.4 225.77C243.97 215.16 240.77 205.27 237.86 196.29C236.6 192.42 235.33 188.5 234.04 184.54C230.01 172.3 226.73 162.32 224.4 155.24C223.12 151.46 222.13 148.51 221.44 146.48L221.45 146.47Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 235.04C250.61 235.64 250.8 236.25 251 236.86C251.63 238.75 252.26 240.62 252.88 242.47C252.06 239.96 251.23 237.4 250.39 234.8C250.39 234.78 250.37 234.77 250.36 234.75C250.38 234.84 250.39 234.94 250.41 235.03V235.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88 233.41C249.88 233.41 249.89 233.43 249.9 233.45C249.88 233.35 249.87 233.26 249.85 233.16C249.56 232.28 249.27 231.39 248.98 230.49C248.45 228.9 247.92 227.32 247.4 225.76C248.21 228.27 249.04 230.82 249.87 233.41H249.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 234.75C250.37 234.75 250.39 234.78 250.4 234.8C250.39 234.76 250.38 234.73 250.36 234.69C250.36 234.71 250.36 234.73 250.36 234.75H250.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.41C250.21 234.41 250.23 234.46 250.23 234.48C250.23 234.45 250.22 234.41 250.21 234.38C250.21 234.39 250.21 234.4 250.21 234.41Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.51C250.24 234.51 250.24 234.5 250.24 234.49C250.24 234.54 250.25 234.58 250.26 234.63C250.32 234.81 250.38 234.98 250.44 235.16C250.44 235.12 250.43 235.08 250.42 235.04C250.36 234.86 250.31 234.69 250.25 234.51H250.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.5C250.23 234.5 250.23 234.51 250.23 234.52C250.23 234.51 250.23 234.5 250.22 234.49C250.22 234.49 250.22 234.5 250.22 234.51L250.23 234.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 235.04C250.39 234.95 250.38 234.85 250.36 234.76C250.32 234.68 250.28 234.6 250.24 234.52C250.3 234.7 250.35 234.87 250.41 235.05V235.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.37C250.21 234.37 250.22 234.44 250.23 234.47C250.23 234.48 250.23 234.49 250.24 234.5C250.28 234.58 250.32 234.66 250.36 234.74C250.36 234.72 250.36 234.7 250.36 234.68C250.33 234.6 250.31 234.53 250.28 234.45C250.26 234.42 250.24 234.39 250.21 234.36V234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.37C250.21 234.37 250.25 234.43 250.28 234.46C250.26 234.4 250.24 234.35 250.23 234.29C250.23 234.31 250.23 234.34 250.22 234.36L250.21 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 233.99L250.08 233.98V233.99H250.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 233.67C249.94 233.61 249.92 233.55 249.91 233.49C249.91 233.46 249.89 233.44 249.88 233.41C249.84 233.33 249.8 233.26 249.76 233.18C249.81 233.34 249.86 233.49 249.92 233.65C249.92 233.65 249.93 233.66 249.94 233.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88 233.41C249.88 233.41 249.9 233.46 249.91 233.49C249.91 233.48 249.91 233.46 249.91 233.45C249.91 233.44 249.9 233.43 249.89 233.41H249.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 233.8C250.06 233.8 250.04 233.75 250.04 233.72C250.04 233.76 250.05 233.79 250.06 233.83C250.06 233.82 250.06 233.81 250.06 233.79V233.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 233.87C250.08 233.87 250.08 233.87 250.08 233.86C250.08 233.84 250.07 233.82 250.06 233.8C250.06 233.81 250.06 233.82 250.06 233.84C250.06 233.85 250.08 233.86 250.09 233.87H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 233.67C249.94 233.67 249.93 233.66 249.92 233.65C249.92 233.67 249.94 233.7 249.94 233.72V233.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 233.87C250.08 233.87 250.06 233.85 250.05 233.84C250.05 233.87 250.06 233.91 250.07 233.94C250.07 233.91 250.07 233.89 250.07 233.86L250.08 233.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5 282.42C257.59 283 257.68 283.57 257.77 284.14C255.92 271.95 254.13 260.16 252.42 248.92C252.11 247.01 251.8 245.09 251.48 243.13C253.71 257.7 255.74 270.94 257.5 282.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1 214.54C245.41 204.1 243.86 194.47 242.46 185.84C240.25 171.7 238.46 160.26 237.22 152.32C236.63 148.38 236.18 145.31 235.86 143.19C235.72 142.17 235.61 141.38 235.54 140.81C235.47 140.27 235.45 140 235.46 139.99C235.48 139.99 235.54 140.26 235.64 140.79C235.74 141.35 235.88 142.14 236.06 143.15C236.41 145.26 236.91 148.32 237.56 152.25C237.57 152.32 237.58 152.39 237.59 152.45C232.16 116.96 227.23 85.14 223.38 61.12C221.11 46.98 219.22 35.54 217.85 27.64C217.17 23.69 216.61 20.63 216.21 18.56C215.81 16.49 215.55 15.41 215.47 15.42C215.39 15.43 215.48 16.54 215.74 18.63C216 20.72 216.41 23.81 216.98 27.77C218.11 35.7 219.85 47.17 222.05 61.32C226.46 89.63 232.79 128.7 239.85 171.83C243.39 193.55 246.76 214.22 249.82 233.01C249.88 233.19 249.94 233.37 250 233.55C249.06 227.4 248.08 221.05 247.08 214.53L247.1 214.54Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 235.14C250.62 237.84 251.05 240.51 251.48 243.13C251.05 240.36 250.62 237.53 250.18 234.67C250.18 234.83 250.18 234.99 250.18 235.15V235.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 233.9C249.99 233.9 249.98 233.88 249.97 233.87C249.97 233.87 249.98 233.88 249.99 233.89V233.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 233.69C250.03 233.69 250.03 233.69 250.03 233.7C250.03 233.65 250.02 233.6 250.01 233.55C249.95 233.37 249.89 233.19 249.83 233.01C249.83 233.06 249.85 233.1 249.85 233.15C249.91 233.33 249.96 233.5 250.02 233.68L250.03 233.69Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.06 143.15C235.88 142.13 235.74 141.35 235.64 140.79C235.54 140.26 235.48 139.99 235.46 139.99C235.44 139.99 235.46 140.27 235.54 140.81C235.62 141.37 235.72 142.16 235.86 143.19C236.17 145.31 236.63 148.37 237.22 152.32C238.46 160.27 240.25 171.71 242.46 185.84C243.85 194.47 245.41 204.1 247.1 214.54C245.01 200.94 242.81 186.58 240.54 171.74C239.54 165.21 238.56 158.78 237.6 152.46C237.59 152.39 237.58 152.32 237.57 152.26C236.92 148.33 236.42 145.27 236.07 143.16L236.06 143.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82 315.93C263.47 319.86 263.98 322.92 264.33 325.03C264.51 326.05 264.65 326.83 264.75 327.39C264.85 327.92 264.91 328.19 264.93 328.19C264.95 328.19 264.93 327.91 264.85 327.37C264.77 326.81 264.66 326.02 264.52 324.99C264.2 322.87 263.74 319.81 263.15 315.87C261.9 307.93 260.09 296.48 257.86 282.35C256.24 272.43 254.41 261.18 252.41 248.9C254.12 260.14 255.91 271.94 257.76 284.12C259.87 297.46 261.59 308.3 262.8 315.91L262.82 315.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.39C250.09 234.39 250.09 234.42 250.08 234.43C250.08 234.46 250.08 234.48 250.08 234.51C250.08 234.54 250.08 234.57 250.09 234.6C250.09 234.53 250.09 234.46 250.09 234.39Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 233.9C249.99 233.9 249.98 233.89 249.97 233.88C249.98 233.89 250 233.91 250.01 233.92C250.01 233.92 250 233.9 249.99 233.89V233.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 233.94C250.02 233.94 250.02 233.94 250.02 233.93C250.01 233.92 249.99 233.9 249.98 233.89C249.98 233.89 249.98 233.9 249.98 233.91C249.98 233.91 249.98 233.91 249.99 233.92C250 233.92 250.01 233.93 250.02 233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 233.94C250.02 233.94 250 233.93 249.99 233.92C249.99 233.93 250.01 233.95 250.02 233.96C250.02 233.96 250.02 233.96 250.03 233.96V233.94H250.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 233.91C249.98 233.91 249.98 233.91 249.98 233.92C249.98 233.92 249.98 233.92 249.97 233.91H249.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 233.96C250.02 233.96 250 233.94 249.99 233.92C249.99 233.93 249.99 233.94 249.99 233.96C250 233.96 250.01 233.96 250.02 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 233.98C250.03 233.98 250.03 233.98 250.03 233.97C250.03 233.97 250.03 233.97 250.02 233.97C250.02 233.97 250.02 233.98 250.03 233.99V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234C250 234 250 234 250.01 234C250.01 234 250 234 249.99 233.99C249.99 233.99 249.99 233.99 249.99 234H250Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234C250.03 234 250.03 233.99 250.03 233.98C250.03 233.98 250.03 233.97 250.02 233.96C250.01 233.96 250 233.96 249.99 233.96C249.99 233.97 249.99 233.98 249.99 233.99C249.99 233.99 250 233.99 250.01 234C250.01 234 250.02 234 250.03 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.99C250.04 233.99 250.04 234 250.04 234.01C250.04 234.01 250.04 234.01 250.05 234.01L250.04 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 233.74C249.95 233.76 249.95 233.78 249.95 233.79C249.95 233.81 249.97 233.83 249.98 233.84C249.97 233.81 249.96 233.77 249.95 233.74Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 233.9C250.01 233.9 250 233.86 249.99 233.84C249.99 233.82 249.97 233.8 249.96 233.79C249.96 233.82 249.96 233.85 249.97 233.87C249.98 233.87 249.99 233.88 250 233.89L250.01 233.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 233.92V233.9C250 233.9 249.99 233.89 249.98 233.88C249.98 233.88 249.99 233.9 250 233.91C250 233.91 250.01 233.92 250.02 233.93L250.01 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 233.93C250.02 233.93 250.02 233.93 250.02 233.92C250.02 233.92 250.01 233.91 250 233.9C250 233.9 250.01 233.92 250.02 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 233.16C249.88 233.26 249.89 233.35 249.91 233.45C249.95 233.53 249.99 233.61 250.04 233.69C249.98 233.51 249.93 233.34 249.87 233.16H249.86Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 233.93C250.02 233.93 250.02 233.93 250.02 233.94C250.02 233.94 250.02 233.93 250.01 233.92L250.02 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.96C250.04 233.96 250.04 233.96 250.04 233.97C250.04 233.97 250.04 233.97 250.05 233.97C250.05 233.97 250.05 233.97 250.05 233.96H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234C250.04 234 250.05 234 250.06 234C250.06 234 250.05 233.98 250.04 233.98C250.04 233.98 250.04 233.98 250.03 233.98C250.03 233.98 250.03 233.98 250.03 233.99C250.03 233.99 250.03 233.99 250.03 234H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.92C250.04 233.92 250.04 233.92 250.04 233.91C250.01 233.85 249.98 233.8 249.95 233.74C249.96 233.77 249.97 233.81 249.98 233.84C249.99 233.86 250 233.88 250.02 233.91C250.02 233.91 250.03 233.91 250.04 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 233.91C250.02 233.91 250.03 233.93 250.04 233.94C250.04 233.94 250.04 233.93 250.04 233.92C250.04 233.92 250.03 233.92 250.02 233.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 233.84C249.99 233.84 250 233.88 250.01 233.9C250.01 233.9 250.02 233.9 250.03 233.91C250.02 233.89 250.01 233.87 249.99 233.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.94C250.04 233.93 250.03 233.92 250.02 233.91C250.02 233.91 250.01 233.91 250 233.9V233.92C250 233.92 250.02 233.94 250.03 233.94H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 233.93V233.92L250.04 233.91V233.92L250.05 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 233.96C250.05 233.95 250.05 233.94 250.04 233.93C250.04 233.93 250.04 233.94 250.04 233.95L250.05 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 233.96C250.06 233.96 250.06 233.96 250.07 233.97L250.06 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.97C250.07 233.97 250.06 233.94 250.05 233.93C250.05 233.94 250.05 233.95 250.06 233.96C250.06 233.96 250.06 233.96 250.07 233.96V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.97H250.08H250.07L250.06 233.96V233.97H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 233.97H250.07L250.08 233.98V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.95C250.04 233.95 250.02 233.93 250.01 233.93C250.01 233.93 250.01 233.93 250.01 233.94C250.01 233.94 250.02 233.95 250.03 233.96L250.04 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.95C250.04 233.95 250.03 233.94 250.02 233.93C250.02 233.93 250.02 233.94 250.03 233.95H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 233.94L250.04 233.96V233.95L250.03 233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.95H250.05V233.96L250.04 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 233.97C250.06 233.97 250.06 233.97 250.05 233.96L250.06 233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 233.96L250.06 233.97L250.05 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.95H250.05H250.04V233.94V233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 233.95C250.05 233.95 250.05 233.95 250.06 233.96L250.05 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 233.96C250.04 233.96 250.04 233.96 250.04 233.97C250.04 233.97 250.04 233.97 250.03 233.96H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.97H250.06L250.07 233.98V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.99C250.07 233.99 250.07 233.99 250.07 233.98C250.07 233.98 250.07 233.99 250.08 234L250.07 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.99C250.07 233.99 250.07 233.98 250.06 233.97C250.06 233.97 250.07 233.99 250.08 233.99H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 233.99C250.08 233.99 250.08 233.99 250.07 233.98C250.07 233.98 250.07 233.98 250.08 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.98C250.07 233.98 250.07 233.98 250.07 233.99C250.07 233.99 250.07 233.99 250.06 233.98H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 233.49C249.91 233.55 249.93 233.61 249.94 233.67C249.96 233.69 249.97 233.72 249.99 233.74C249.96 233.66 249.94 233.57 249.91 233.49Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 233.83C250.06 233.83 250.05 233.76 250.04 233.72C250.04 233.72 250.04 233.7 250.04 233.69C250 233.61 249.96 233.53 249.91 233.45C249.91 233.46 249.91 233.48 249.91 233.49C249.94 233.57 249.96 233.66 249.99 233.74C250.01 233.77 250.03 233.8 250.05 233.83H250.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 233.74C249.98 233.8 250.01 233.85 250.04 233.91C250.02 233.86 250 233.8 249.99 233.75C249.97 233.73 249.96 233.7 249.94 233.68V233.73C249.94 233.73 249.95 233.73 249.95 233.74Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 233.83C250.06 233.83 250.02 233.77 250 233.74C250.02 233.79 250.03 233.85 250.05 233.9C250.05 233.88 250.05 233.85 250.06 233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 233.93C250.05 233.93 250.06 233.93 250.07 233.94C250.07 233.91 250.06 233.87 250.05 233.84C250.05 233.86 250.05 233.89 250.04 233.91C250.04 233.91 250.04 233.91 250.04 233.92L250.05 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 233.97C250.08 233.97 250.08 233.95 250.08 233.94C250.08 233.94 250.07 233.94 250.06 233.93C250.06 233.94 250.07 233.96 250.08 233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 223.64C250.18 209.44 250.18 196.5 250.18 185.25C250.25 170.95 250.31 159.38 250.35 151.34C250.4 147.36 250.44 144.26 250.46 142.12C250.48 141.09 250.5 140.29 250.52 139.72C250.54 139.18 250.56 138.9 250.57 138.9C250.59 138.9 250.6 139.18 250.62 139.72C250.62 140.29 250.64 141.08 250.66 142.12C250.66 144.26 250.68 147.36 250.69 151.34C250.65 159.38 250.6 170.95 250.54 185.25C250.44 196.5 250.32 209.44 250.18 223.64C250.18 226.75 250.18 229.91 250.18 233.14C250.18 233.1 250.19 233.07 250.2 233.03C250.35 214 250.52 193.06 250.69 171.06C251.07 127.39 251.35 87.8399 251.38 59.2099C251.4 44.8899 251.36 33.3099 251.27 25.2999C251.23 21.2999 251.17 18.1899 251.1 16.0799C251.03 13.9699 250.96 12.8599 250.88 12.8599C250.8 12.8599 250.72 13.9699 250.64 16.0699C250.56 18.1799 250.48 21.2899 250.41 25.2899C250.27 33.2999 250.15 44.8799 250.07 59.1999C249.91 87.8299 249.92 127.38 250.01 171.05C250.04 193.06 250.06 214.01 250.09 233.05C250.12 229.85 250.15 226.72 250.18 223.64Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.52C250.19 233.52 250.19 233.57 250.18 233.6C250.18 233.62 250.18 233.65 250.19 233.67C250.19 233.62 250.19 233.57 250.19 233.51V233.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.82C250.18 233.81 250.18 233.8 250.19 233.79C250.19 233.76 250.19 233.72 250.19 233.69C250.19 233.67 250.19 233.64 250.18 233.62C250.18 233.62 250.18 233.62 250.18 233.63C250.18 233.7 250.18 233.77 250.18 233.83V233.82Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.14C250.18 229.92 250.18 226.75 250.18 223.64C250.15 226.72 250.12 229.86 250.09 233.05C250.11 233.15 250.12 233.25 250.14 233.35C250.15 233.28 250.17 233.2 250.18 233.13V233.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.68 151.34C250.67 147.36 250.66 144.26 250.65 142.12C250.63 141.09 250.62 140.29 250.61 139.72C250.6 139.18 250.58 138.9 250.56 138.9C250.54 138.9 250.52 139.18 250.51 139.72C250.5 140.29 250.48 141.08 250.45 142.12C250.42 144.26 250.39 147.36 250.34 151.34C250.3 159.38 250.24 170.95 250.17 185.25C250.17 196.5 250.17 209.44 250.17 223.64C250.3 209.44 250.42 196.51 250.53 185.25C250.59 170.95 250.64 159.38 250.68 151.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.69 316.86C249.71 320.84 249.72 323.94 249.73 326.08C249.75 327.11 249.76 327.91 249.77 328.48C249.78 329.02 249.8 329.3 249.82 329.3C249.84 329.3 249.85 329.02 249.87 328.48C249.88 327.91 249.9 327.12 249.92 326.08C249.94 323.94 249.98 320.84 250.02 316.86C250.05 308.82 250.09 297.25 250.14 282.95C250.13 271.69 250.11 258.75 250.09 244.55C249.98 258.76 249.87 271.7 249.78 282.95C249.74 297.25 249.7 308.82 249.68 316.86H249.69Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.85C250.12 234.93 250.1 235.01 250.09 235.08C250.09 238.29 250.09 241.45 250.1 244.55C250.12 241.56 250.15 238.51 250.17 235.41V235.13C250.16 235.04 250.14 234.94 250.12 234.85H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 233.6C250.11 233.52 250.13 233.44 250.14 233.35C250.12 233.25 250.11 233.15 250.09 233.05C250.09 233.07 250.09 233.09 250.09 233.1C250.09 233.25 250.09 233.4 250.09 233.55C250.09 233.56 250.09 233.58 250.09 233.59L250.1 233.6Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.82C250.18 233.75 250.18 233.68 250.18 233.62C250.17 233.7 250.15 233.79 250.14 233.87V233.89C250.15 233.87 250.16 233.84 250.18 233.82Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.59C250.18 233.59 250.18 233.59 250.18 233.6C250.18 233.57 250.18 233.55 250.19 233.52C250.19 233.35 250.19 233.19 250.19 233.02C250.19 233.06 250.18 233.09 250.17 233.13V233.59H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 233.89C250.13 233.89 250.13 233.87 250.13 233.86C250.12 233.77 250.1 233.69 250.09 233.6C250.09 233.61 250.09 233.63 250.09 233.64C250.09 233.69 250.09 233.74 250.09 233.79C250.09 233.81 250.1 233.83 250.11 233.85C250.11 233.86 250.12 233.88 250.13 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.59V233.13C250.17 233.2 250.15 233.28 250.14 233.35C250.15 233.43 250.17 233.51 250.18 233.58V233.59Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 233.85C250.11 233.85 250.1 233.81 250.09 233.79C250.09 233.79 250.09 233.8 250.09 233.81C250.09 233.82 250.1 233.84 250.11 233.85Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 233.6C250.11 233.69 250.13 233.77 250.14 233.86C250.15 233.78 250.17 233.69 250.18 233.61V233.59C250.17 233.51 250.15 233.43 250.14 233.36C250.13 233.44 250.11 233.52 250.1 233.61V233.6Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.78C250.19 233.78 250.19 233.8 250.18 233.81C250.18 233.81 250.18 233.8 250.19 233.79C250.19 233.79 250.19 233.79 250.19 233.78Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 233.89C250.13 233.89 250.12 233.86 250.11 233.85C250.11 233.87 250.12 233.89 250.13 233.9C250.13 233.9 250.13 233.9 250.13 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 233.91C250.13 233.89 250.12 233.87 250.11 233.86C250.11 233.85 250.1 233.83 250.09 233.82V233.89C250.09 233.89 250.11 233.92 250.12 233.93C250.12 233.93 250.12 233.93 250.12 233.92L250.13 233.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 233.94C250.11 233.94 250.11 233.93 250.12 233.92C250.11 233.91 250.1 233.89 250.09 233.88C250.09 233.88 250.1 233.92 250.11 233.95V233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.27C250.13 234.27 250.13 234.27 250.13 234.28C250.13 234.27 250.13 234.26 250.13 234.24C250.13 234.24 250.13 234.25 250.12 234.26L250.13 234.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.23C250.15 234.24 250.15 234.25 250.14 234.26C250.14 234.26 250.14 234.25 250.15 234.24V234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 233.94C250.11 233.94 250.1 233.9 250.09 233.88C250.09 233.9 250.09 233.93 250.09 233.95C250.09 233.95 250.09 233.95 250.1 233.95C250.1 233.95 250.1 233.94 250.1 233.93L250.11 233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 233.98C250.09 233.98 250.09 233.98 250.09 233.97C250.09 233.97 250.09 233.97 250.08 233.97V233.99L250.09 233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.85C250.14 234.94 250.16 235.04 250.18 235.13V234.63C250.18 234.63 250.18 234.62 250.18 234.61C250.17 234.69 250.15 234.77 250.14 234.86L250.13 234.85Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.32C250.13 234.32 250.11 234.37 250.09 234.39C250.09 234.46 250.09 234.53 250.09 234.6C250.1 234.51 250.12 234.43 250.13 234.34V234.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.38C250.09 234.38 250.11 234.33 250.13 234.31V234.28C250.13 234.28 250.1 234.34 250.09 234.37V234.38Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.54C250.18 234.54 250.18 234.49 250.19 234.46C250.19 234.45 250.19 234.44 250.18 234.42C250.18 234.46 250.18 234.49 250.18 234.53V234.54Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.02 296.39C238.98 302.84 237.96 309.2 236.95 315.44C238.26 307.52 240.13 296.25 242.43 282.36C244.27 270.89 246.39 257.65 248.73 243.09C248.13 246.61 247.55 250.04 246.98 253.4C244.77 267.06 242.44 281.47 240.03 296.38L240.02 296.39Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.08 143.29C265.27 142.27 265.42 141.49 265.52 140.93C265.63 140.4 265.69 140.13 265.71 140.13C265.73 140.13 265.7 140.41 265.63 140.94C265.55 141.5 265.43 142.29 265.28 143.31C264.94 145.42 264.46 148.49 263.84 152.42C262.52 160.35 260.62 171.78 258.28 185.9C256.57 195.88 254.63 207.2 252.51 219.56C251.74 224.34 250.99 229.02 250.26 233.59C250.32 233.41 250.38 233.24 250.44 233.06C253.64 214.27 257.15 193.6 260.84 171.89C268.2 128.81 274.81 89.78 279.41 61.5C281.72 47.36 283.53 35.91 284.72 27.99C285.31 24.03 285.75 20.95 286.03 18.86C286.3 16.77 286.4 15.66 286.32 15.65C286.24 15.64 285.98 16.72 285.56 18.79C285.14 20.86 284.57 23.92 283.86 27.86C282.44 35.75 280.47 47.17 278.1 61.3C273.36 89.56 267.06 128.63 260.17 171.79C259.48 176.09 258.8 180.36 258.12 184.57C260.38 171.04 262.21 160.06 263.5 152.36C264.19 148.43 264.72 145.38 265.09 143.27L265.08 143.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.73 243.1C249.17 240.51 249.62 237.88 250.07 235.21C250.07 235.04 250.07 234.87 250.07 234.71C249.61 237.55 249.16 240.35 248.72 243.1H248.73Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.28V234.29H250.23V234.28H250.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.3V234.29H250.22L250.23 234.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.71C250.07 234.88 250.07 235.05 250.07 235.21C250.07 235.17 250.08 235.12 250.09 235.08C250.09 234.92 250.09 234.76 250.09 234.6C250.09 234.63 250.08 234.67 250.07 234.7V234.71Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.98 253.41C245.19 263.93 243.54 273.63 242.06 282.31C239.73 296.43 237.85 307.86 236.54 315.79C235.92 319.73 235.44 322.79 235.11 324.9C234.96 325.92 234.85 326.71 234.77 327.27C234.7 327.81 234.67 328.08 234.69 328.08C234.71 328.08 234.77 327.81 234.87 327.28C234.97 326.72 235.12 325.94 235.31 324.92C235.68 322.81 236.21 319.75 236.89 315.83C236.91 315.7 236.93 315.56 236.96 315.43C237.97 309.18 238.99 302.83 240.03 296.38C242.44 281.47 244.77 267.05 246.98 253.4V253.41Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.27 185.91C260.62 171.8 262.52 160.37 263.83 152.43C264.45 148.49 264.94 145.43 265.27 143.32C265.42 142.3 265.53 141.51 265.62 140.95C265.69 140.41 265.72 140.14 265.7 140.14C265.68 140.14 265.62 140.41 265.51 140.94C265.41 141.5 265.26 142.28 265.07 143.3C264.7 145.41 264.17 148.46 263.48 152.39C262.2 160.08 260.36 171.07 258.1 184.6C256.16 196.7 254.28 208.42 252.49 219.58C254.61 207.22 256.55 195.9 258.26 185.92L258.27 185.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.7C250.3 233.51 250.36 233.33 250.43 233.14C250.43 233.12 250.43 233.09 250.44 233.07C250.38 233.24 250.32 233.42 250.26 233.6C250.26 233.63 250.25 233.67 250.24 233.7Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 233.88C250.3 233.88 250.28 233.9 250.28 233.91C250.28 233.91 250.29 233.9 250.3 233.89V233.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 233.89C250.3 233.89 250.29 233.9 250.28 233.91L250.3 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.25C250.21 234.26 250.21 234.27 250.22 234.29C250.22 234.29 250.22 234.28 250.22 234.27C250.22 234.27 250.22 234.27 250.21 234.26V234.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.26C250.23 234.26 250.23 234.26 250.24 234.27L250.23 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.23V234.24V234.25H250.22V234.24L250.21 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.24L250.21 234.23L250.22 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.21C250.2 234.21 250.2 234.21 250.2 234.22C250.2 234.22 250.2 234.21 250.19 234.2L250.2 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.2H250.2L250.19 234.19V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.25H250.22L250.23 234.26V234.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.25H250.23L250.22 234.24V234.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.23V234.22H250.23L250.24 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.25C250.23 234.25 250.23 234.25 250.23 234.24C250.23 234.24 250.23 234.24 250.22 234.24C250.22 234.24 250.22 234.24 250.23 234.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.21C250.23 234.21 250.22 234.21 250.21 234.21C250.21 234.21 250.22 234.23 250.23 234.23C250.23 234.23 250.23 234.23 250.24 234.23C250.24 234.23 250.24 234.23 250.24 234.22L250.23 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.23C250.21 234.23 250.21 234.23 250.2 234.22L250.21 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.23C250.21 234.23 250.2 234.21 250.19 234.21C250.19 234.21 250.19 234.22 250.2 234.23H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.18C250.2 234.18 250.2 234.19 250.2 234.2C250.2 234.2 250.21 234.2 250.22 234.2C250.22 234.19 250.2 234.18 250.2 234.17V234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.18V234.19L250.2 234.18H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.16V234.15H250.24L250.25 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.16C250.23 234.16 250.23 234.16 250.24 234.16C250.24 234.16 250.24 234.16 250.24 234.15C250.24 234.15 250.23 234.15 250.22 234.15L250.23 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.16C250.22 234.16 250.24 234.17 250.25 234.18C250.25 234.18 250.25 234.17 250.25 234.16C250.25 234.16 250.25 234.16 250.24 234.16C250.24 234.16 250.24 234.16 250.23 234.16H250.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.17H250.22V234.16L250.21 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.22C250.23 234.22 250.23 234.21 250.23 234.2C250.23 234.2 250.23 234.2 250.22 234.2L250.23 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.18V234.2C250.22 234.2 250.22 234.2 250.23 234.2C250.23 234.2 250.23 234.19 250.23 234.18C250.23 234.18 250.22 234.18 250.21 234.18H250.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.17C250.22 234.17 250.22 234.17 250.22 234.18C250.22 234.18 250.23 234.18 250.24 234.18C250.24 234.18 250.22 234.17 250.21 234.16L250.22 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.21C250.23 234.21 250.23 234.19 250.23 234.18C250.23 234.18 250.22 234.18 250.21 234.18C250.21 234.19 250.23 234.2 250.23 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.17C250.21 234.17 250.22 234.17 250.23 234.17C250.23 234.17 250.23 234.17 250.23 234.16L250.21 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.17V234.18L250.21 234.17H250.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.43C250.18 234.43 250.18 234.45 250.19 234.47C250.19 234.47 250.19 234.45 250.19 234.44C250.19 234.43 250.18 234.42 250.17 234.41V234.43H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.34C250.19 234.34 250.19 234.38 250.19 234.4C250.19 234.41 250.2 234.42 250.21 234.43C250.21 234.43 250.21 234.41 250.21 234.4C250.21 234.38 250.2 234.36 250.19 234.33V234.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.34C250.19 234.36 250.2 234.38 250.21 234.41C250.21 234.4 250.21 234.39 250.21 234.38C250.21 234.37 250.19 234.36 250.18 234.34H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.34C250.19 234.34 250.21 234.36 250.22 234.38C250.22 234.34 250.21 234.31 250.2 234.27C250.2 234.27 250.2 234.27 250.19 234.27C250.19 234.3 250.19 234.32 250.19 234.35V234.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.28C250.22 234.28 250.21 234.28 250.2 234.27C250.2 234.31 250.21 234.34 250.22 234.38C250.22 234.36 250.22 234.33 250.23 234.31C250.23 234.31 250.23 234.31 250.23 234.3L250.22 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.23C250.19 234.23 250.19 234.24 250.19 234.25C250.19 234.25 250.19 234.25 250.2 234.25C250.2 234.25 250.2 234.23 250.2 234.22L250.19 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.24C250.2 234.24 250.21 234.27 250.22 234.28C250.22 234.27 250.22 234.26 250.21 234.24C250.21 234.24 250.21 234.24 250.2 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.24C250.19 234.24 250.19 234.26 250.19 234.27C250.19 234.27 250.2 234.27 250.21 234.28C250.21 234.27 250.2 234.25 250.19 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.23H250.2L250.19 234.22V234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.24V234.23H250.2L250.21 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.21C250.19 234.21 250.19 234.21 250.18 234.2L250.19 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.23V234.24H250.2L250.19 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.21C250.19 234.21 250.19 234.21 250.2 234.22C250.2 234.22 250.2 234.22 250.2 234.21H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.31C250.14 234.31 250.14 234.33 250.14 234.34C250.15 234.43 250.17 234.51 250.18 234.6C250.18 234.6 250.18 234.59 250.18 234.58V234.4C250.18 234.4 250.17 234.37 250.16 234.35C250.16 234.34 250.14 234.32 250.14 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.6C250.09 234.76 250.09 234.92 250.09 235.08C250.1 235 250.12 234.92 250.13 234.85C250.12 234.77 250.1 234.69 250.09 234.6Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.31C250.14 234.31 250.16 234.34 250.16 234.35C250.16 234.33 250.15 234.31 250.14 234.29C250.14 234.29 250.14 234.3 250.14 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.33L250.19 234.34L250.18 234.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.36C250.16 234.36 250.17 234.39 250.18 234.41V234.39C250.18 234.39 250.17 234.37 250.16 234.36Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.3C250.14 234.32 250.15 234.34 250.16 234.36C250.16 234.37 250.17 234.38 250.18 234.39V234.33C250.18 234.33 250.16 234.3 250.15 234.29C250.15 234.29 250.15 234.29 250.15 234.3H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.26C250.16 234.26 250.16 234.28 250.15 234.28C250.16 234.29 250.17 234.31 250.18 234.32C250.18 234.32 250.17 234.27 250.16 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.26C250.16 234.26 250.17 234.3 250.18 234.32V234.25C250.18 234.25 250.18 234.26 250.18 234.27L250.16 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.24C250.15 234.24 250.15 234.26 250.15 234.28C250.15 234.28 250.15 234.26 250.16 234.26C250.16 234.26 250.16 234.25 250.16 234.24H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.23C250.16 234.23 250.16 234.24 250.16 234.25C250.16 234.25 250.16 234.24 250.16 234.23C250.16 234.23 250.16 234.23 250.15 234.23H250.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.23V234.24L250.16 234.23H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.23C250.16 234.23 250.16 234.23 250.17 234.23C250.17 234.23 250.17 234.23 250.17 234.22C250.17 234.22 250.17 234.22 250.16 234.22V234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.22V234.23H250.16L250.15 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.22L250.16 234.23V234.22H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.21H250.18V234.22H250.19V234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.2V234.21H250.19L250.18 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.22H250.18V234.21L250.17 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.2H250.16L250.15 234.21V234.22H250.16H250.17L250.18 234.21L250.17 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.2L250.18 234.21V234.2H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.18L250.19 234.19V234.18H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.19V234.2L250.19 234.19L250.18 234.18V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.19L250.18 234.2V234.19H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.2H250.18L250.17 234.19V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.34C250.12 234.43 250.1 234.51 250.09 234.6C250.1 234.68 250.12 234.76 250.13 234.85C250.14 234.77 250.16 234.69 250.17 234.6C250.16 234.51 250.14 234.43 250.13 234.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.44C250.07 234.44 250.05 234.48 250.04 234.49C250.04 234.49 250.03 234.57 250.02 234.61C250.04 234.56 250.06 234.51 250.07 234.46C250.07 234.46 250.07 234.45 250.07 234.44Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.65 280.56C234.94 279.69 235.23 278.81 235.53 277.92C235.14 279.1 234.74 280.29 234.34 281.48C234.44 281.17 234.55 280.87 234.65 280.57V280.56Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3 236.69C249.48 236.18 249.65 235.66 249.83 235.14C249.83 235.11 249.83 235.08 249.84 235.05C249.66 235.59 249.48 236.14 249.29 236.68L249.3 236.69Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.69 187.67C270.3 174.09 274.04 163.1 276.63 155.47C277.94 151.7 278.97 148.76 279.67 146.74C280.02 145.77 280.29 145.02 280.49 144.48C280.68 143.97 280.79 143.71 280.8 143.72C280.82 143.72 280.75 143.99 280.59 144.51C280.42 145.06 280.18 145.82 279.86 146.8C279.19 148.84 278.21 151.79 276.96 155.58C274.37 163.21 270.65 174.21 266.04 187.79C262.22 198.88 257.8 211.69 252.95 225.78C252.12 228.27 251.27 230.81 250.41 233.38C250.44 233.32 250.47 233.27 250.5 233.21C256.71 215.12 263.54 195.22 270.72 174.3C284.97 132.88 297.82 95.36 306.95 68.1301C311.52 54.5201 315.16 43.49 317.62 35.85C318.85 32.0301 319.78 29.0501 320.39 27.0301C321 25.0001 321.27 23.9301 321.19 23.9001C321.11 23.8701 320.68 24.9001 319.93 26.8801C319.18 28.8601 318.12 31.7901 316.78 35.5801C314.1 43.1501 310.3 54.1301 305.67 67.7301C296.41 94.9101 283.86 132.53 270.07 174.1C263.22 194.68 256.7 214.29 250.75 232.16C251.49 230.01 252.23 227.88 252.95 225.78C257.67 211.65 261.97 198.8 265.68 187.68L265.69 187.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85 235.06C249.85 235.06 249.85 235.12 249.84 235.15C249.9 234.97 249.96 234.79 250.02 234.62C250.02 234.58 250.03 234.55 250.04 234.51C249.98 234.7 249.92 234.88 249.85 235.07V235.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.71V233.7L250.23 233.71H250.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 234.75C249.9 234.75 249.88 234.8 249.86 234.82C249 237.4 248.16 239.94 247.33 242.43C247.98 240.54 248.64 238.62 249.3 236.68C249.48 236.14 249.66 235.59 249.85 235.05C249.87 234.95 249.88 234.85 249.9 234.74V234.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 233.45C250.37 233.45 250.4 233.39 250.41 233.37C251.27 230.8 252.12 228.26 252.95 225.77C252.23 227.87 251.49 230 250.75 232.15C250.64 232.48 250.53 232.81 250.42 233.15C250.4 233.25 250.39 233.35 250.37 233.45Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.5L250.04 234.49L250.03 234.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.97 155.58C278.22 151.79 279.2 148.84 279.87 146.8C280.18 145.81 280.42 145.05 280.6 144.51C280.76 143.99 280.83 143.72 280.81 143.72C280.79 143.72 280.69 143.97 280.5 144.48C280.3 145.02 280.03 145.77 279.68 146.74C278.97 148.77 277.95 151.7 276.64 155.47C274.05 163.1 270.31 174.09 265.7 187.67C261.98 198.79 257.69 211.64 252.97 225.77C257.83 211.68 262.24 198.87 266.06 187.78C270.66 174.2 274.39 163.21 276.98 155.57L276.97 155.58Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.28 280.44C229.69 294.03 225.98 305.02 223.4 312.66C222.15 316.45 221.18 319.4 220.51 321.44C220.2 322.43 219.96 323.19 219.79 323.73C219.63 324.25 219.56 324.52 219.58 324.52C219.6 324.52 219.7 324.27 219.89 323.76C220.08 323.22 220.35 322.47 220.71 321.5C221.41 319.47 222.43 316.54 223.74 312.76C226.27 305.3 229.88 294.62 234.33 281.46C234.73 280.27 235.12 279.08 235.52 277.9C239.01 267.4 242.99 255.46 247.32 242.42C242.48 256.52 238.08 269.33 234.28 280.42V280.44Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 234.75C249.88 234.85 249.87 234.95 249.85 235.06C249.91 234.87 249.97 234.69 250.04 234.5C250 234.59 249.95 234.67 249.91 234.76L249.9 234.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.49C250.04 234.49 250.06 234.45 250.07 234.44C250.07 234.44 250.07 234.43 250.07 234.42C250.07 234.45 250.05 234.47 250.04 234.5V234.49Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 234.67C249.89 234.72 249.88 234.77 249.86 234.83C249.87 234.81 249.88 234.78 249.9 234.76C249.9 234.73 249.9 234.7 249.91 234.68V234.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.37C250.05 234.37 250.04 234.45 250.03 234.5C250.03 234.47 250.05 234.45 250.06 234.42C250.06 234.4 250.06 234.39 250.06 234.37H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.37C250.03 234.4 250 234.43 249.98 234.47C249.96 234.54 249.93 234.61 249.91 234.67C249.91 234.7 249.91 234.73 249.9 234.75C249.94 234.66 249.99 234.58 250.03 234.49C250.03 234.45 250.04 234.41 250.05 234.36V234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.29C250.04 234.29 250.04 234.31 250.04 234.32C250.04 234.32 250.04 234.31 250.05 234.3L250.04 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.32C250.03 234.32 250 234.42 249.98 234.47C250 234.44 250.03 234.41 250.05 234.37C250.05 234.35 250.05 234.32 250.04 234.3C250.04 234.3 250.04 234.31 250.03 234.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.42C250.08 234.42 250.08 234.44 250.07 234.44C250.07 234.44 250.07 234.45 250.07 234.46C250.07 234.46 250.07 234.44 250.07 234.43C250.07 234.43 250.07 234.42 250.07 234.41L250.08 234.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.42C250.08 234.42 250.08 234.43 250.08 234.44C250.08 234.43 250.08 234.41 250.09 234.4C250.09 234.4 250.09 234.41 250.08 234.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.37C250.08 234.37 250.07 234.4 250.06 234.42C250.06 234.42 250.06 234.43 250.06 234.44C250.06 234.44 250.06 234.42 250.07 234.42C250.07 234.4 250.07 234.39 250.07 234.37H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.33C250.09 234.33 250.09 234.36 250.08 234.37C250.08 234.39 250.08 234.4 250.08 234.42V234.39C250.08 234.39 250.09 234.35 250.09 234.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.37C250.06 234.39 250.06 234.4 250.06 234.42C250.06 234.4 250.07 234.39 250.08 234.37C250.08 234.36 250.08 234.35 250.08 234.34C250.08 234.35 250.06 234.36 250.06 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.32C250.09 234.32 250.09 234.33 250.08 234.34C250.08 234.35 250.08 234.36 250.08 234.37C250.08 234.36 250.08 234.34 250.09 234.33V234.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.29C250.04 234.29 250.04 234.27 250.05 234.27C250.05 234.27 250.05 234.27 250.04 234.27V234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.26C250.07 234.26 250.06 234.33 250.05 234.36C250.05 234.35 250.07 234.34 250.07 234.33C250.07 234.3 250.07 234.28 250.07 234.25V234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.26C250.08 234.26 250.08 234.31 250.08 234.34C250.08 234.34 250.08 234.33 250.09 234.32C250.09 234.3 250.09 234.27 250.09 234.25C250.09 234.25 250.09 234.25 250.08 234.25V234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.26C250.07 234.26 250.06 234.26 250.05 234.27C250.05 234.27 250.05 234.29 250.04 234.29C250.04 234.31 250.04 234.34 250.05 234.36C250.05 234.33 250.06 234.29 250.07 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.26V234.27L250.14 234.26H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.23C250.15 234.23 250.15 234.23 250.14 234.23C250.14 234.23 250.14 234.23 250.14 234.24C250.14 234.24 250.14 234.25 250.14 234.26C250.14 234.25 250.14 234.24 250.15 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.22H250.14L250.15 234.23V234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.22H250.15L250.14 234.21V234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.21H250.14L250.15 234.22V234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.21L250.16 234.2L250.15 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.29C250.13 234.3 250.11 234.31 250.11 234.32C250.11 234.32 250.11 234.33 250.11 234.34C250.11 234.36 250.11 234.38 250.11 234.4C250.12 234.37 250.13 234.34 250.14 234.31L250.13 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.31C250.1 234.31 250.12 234.29 250.12 234.28C250.12 234.28 250.12 234.27 250.12 234.26C250.12 234.28 250.11 234.29 250.1 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.24C250.1 234.24 250.1 234.24 250.09 234.24C250.09 234.26 250.09 234.29 250.09 234.31C250.09 234.29 250.1 234.28 250.11 234.26C250.11 234.26 250.11 234.25 250.1 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.24C250.11 234.24 250.11 234.26 250.12 234.27C250.12 234.27 250.12 234.26 250.12 234.25C250.12 234.25 250.12 234.25 250.12 234.24H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 233.45C250.39 233.35 250.4 233.25 250.42 233.15C250.36 233.34 250.3 233.52 250.23 233.71C250.27 233.62 250.32 233.54 250.36 233.45H250.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.21L250.16 234.2L250.15 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2 248.89C243.28 246.89 244.34 244.91 245.39 242.95C245.54 242.67 245.68 242.39 245.83 242.11C244.6 244.41 243.39 246.67 242.2 248.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39 233.59C252.36 229.91 254.38 226.14 256.43 222.3C262.55 210.65 268.15 199.99 273.06 190.64C279.81 177.94 285.28 167.66 289.08 160.52C290.99 157 292.47 154.25 293.5 152.36C294.01 151.45 294.4 150.75 294.67 150.25C294.94 149.78 295.09 149.54 295.1 149.55C295.12 149.55 295 149.81 294.76 150.3C294.5 150.81 294.14 151.52 293.67 152.45C292.68 154.36 291.23 157.12 289.38 160.67C287.76 163.71 285.84 167.33 283.65 171.46C303 135.39 320.38 102.85 333.03 78.8401C339.74 66.1001 345.13 55.7601 348.8 48.5901C350.63 45.0001 352.04 42.2101 352.96 40.3001C353.89 38.3901 354.34 37.3701 354.26 37.3401C354.19 37.3001 353.59 38.2501 352.54 40.0901C351.48 41.9301 349.96 44.6701 348.02 48.2001C344.14 55.2701 338.62 65.5301 331.85 78.2501C318.31 103.68 299.82 138.91 279.47 177.84C269.18 197.49 259.39 216.19 250.49 233.18C250.44 233.34 250.38 233.49 250.33 233.65C250.35 233.63 250.37 233.6 250.38 233.58L250.39 233.59Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93 234.36C249.89 234.41 249.86 234.45 249.82 234.5C249.81 234.53 249.79 234.55 249.78 234.58C249.85 234.49 249.91 234.41 249.97 234.33C249.96 234.33 249.95 234.35 249.93 234.36Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5 235.11C248.26 237.48 247.04 239.82 245.83 242.11C247.13 239.69 248.45 237.22 249.79 234.72C249.69 234.85 249.6 234.98 249.5 235.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.71C250.23 233.71 250.21 233.75 250.2 233.77C250.2 233.77 250.2 233.78 250.2 233.79C250.2 233.76 250.22 233.74 250.23 233.71Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.79C250.21 233.79 250.21 233.78 250.21 233.77C250.21 233.77 250.2 233.79 250.19 233.8C250.19 233.82 250.19 233.83 250.19 233.85C250.19 233.83 250.2 233.81 250.21 233.79Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.92 277.42C220.19 290.13 214.74 300.43 210.96 307.58C209.11 311.13 207.68 313.9 206.68 315.81C206.21 316.74 205.85 317.45 205.59 317.96C205.35 318.45 205.24 318.7 205.25 318.71C205.27 318.71 205.41 318.48 205.68 318.01C205.96 317.51 206.35 316.81 206.85 315.9C207.87 314.01 209.35 311.26 211.26 307.74C215.05 300.6 220.5 290.31 227.24 277.6C232.55 267.46 238.66 255.79 245.38 242.97C244.33 244.93 243.26 246.91 242.19 248.91C236.6 259.34 231.46 268.94 226.91 277.43L226.92 277.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.69 152.46C294.16 151.53 294.52 150.82 294.78 150.31C295.02 149.82 295.14 149.57 295.12 149.56C295.1 149.56 294.96 149.79 294.69 150.26C294.41 150.76 294.02 151.46 293.52 152.37C292.5 154.26 291.01 157 289.1 160.53C285.3 167.67 279.83 177.95 273.08 190.65C268.17 200 262.57 210.65 256.45 222.31C263.89 208.42 271.83 193.59 280.1 178.16C281.3 175.92 282.5 173.69 283.69 171.48C285.88 167.35 287.8 163.73 289.42 160.69C291.27 157.14 292.71 154.37 293.71 152.47L293.69 152.46Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 234.41C249.96 234.41 249.96 234.36 249.97 234.34C249.91 234.43 249.84 234.51 249.78 234.59C249.69 234.76 249.6 234.93 249.51 235.11C249.61 234.98 249.7 234.85 249.8 234.72C249.86 234.62 249.91 234.51 249.97 234.41H249.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.31C250.01 234.31 249.99 234.33 249.97 234.34C249.97 234.37 249.97 234.39 249.96 234.41C249.97 234.38 249.99 234.36 250 234.33C250 234.33 250 234.32 250 234.31H250.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.31C250.01 234.31 250.01 234.32 250.01 234.33C250.01 234.33 250.01 234.31 250.02 234.3L250.01 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 233.91C250.14 233.91 250.16 233.85 250.17 233.81C250.17 233.81 250.15 233.86 250.13 233.88C250.13 233.88 250.13 233.9 250.13 233.91H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.88V233.84C250.18 233.84 250.19 233.81 250.19 233.79C250.19 233.79 250.19 233.8 250.18 233.81V233.87V233.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 233.92C250.15 233.92 250.17 233.9 250.17 233.89C250.17 233.89 250.17 233.89 250.17 233.88V233.82C250.17 233.82 250.15 233.88 250.14 233.92H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 233.92H250.14L250.15 233.93V233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 233.94C250.14 233.94 250.14 233.94 250.14 233.93C250.14 233.94 250.14 233.95 250.14 233.96C250.14 233.96 250.14 233.95 250.15 233.94H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.96C250.12 233.96 250.12 233.94 250.12 233.93C250.12 233.93 250.12 233.93 250.11 233.95C250.11 233.95 250.11 233.96 250.11 233.97L250.12 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 233.97C250.11 233.97 250.11 233.96 250.11 233.95C250.11 233.95 250.11 233.96 250.11 233.97C250.11 233.97 250.11 233.97 250.12 233.97H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 233.97C250.11 233.97 250.11 233.97 250.1 233.97C250.1 233.97 250.1 233.97 250.1 233.98C250.1 233.98 250.1 233.98 250.11 233.98V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 233.99V233.98H250.09V233.99H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 233.55C250.35 233.55 250.33 233.64 250.33 233.68C250.33 233.68 250.33 233.68 250.33 233.67C250.38 233.51 250.44 233.36 250.49 233.2C250.46 233.26 250.43 233.31 250.4 233.37C250.38 233.43 250.36 233.49 250.34 233.55H250.35Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 233.37C250.41 233.37 250.38 233.43 250.37 233.45C250.37 233.48 250.36 233.51 250.35 233.55C250.37 233.49 250.39 233.43 250.41 233.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 233.83C250.22 233.83 250.23 233.75 250.24 233.71C250.24 233.74 250.22 233.76 250.21 233.79C250.21 233.8 250.21 233.82 250.21 233.83H250.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.84C250.19 233.84 250.19 233.86 250.19 233.87C250.19 233.86 250.21 233.85 250.21 233.84C250.21 233.83 250.21 233.81 250.21 233.8C250.21 233.82 250.2 233.84 250.19 233.86V233.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.87C250.19 233.87 250.19 233.85 250.19 233.84V233.88H250.18C250.18 233.88 250.18 233.87 250.19 233.86V233.87Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.89V233.88L250.17 233.89H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 233.68C250.33 233.68 250.35 233.59 250.35 233.55C250.33 233.61 250.31 233.67 250.29 233.74C250.3 233.72 250.32 233.7 250.33 233.69V233.68Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 233.83C250.24 233.8 250.27 233.76 250.29 233.73C250.31 233.67 250.33 233.61 250.35 233.54C250.35 233.51 250.36 233.48 250.37 233.44C250.33 233.53 250.28 233.61 250.24 233.7C250.24 233.74 250.23 233.78 250.22 233.82V233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 233.83L250.21 233.84L250.22 233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53 244.08C243.07 243.38 243.61 242.67 244.14 241.97C244.21 241.87 244.29 241.77 244.36 241.67C243.75 242.47 243.13 243.28 242.53 244.07V244.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.07 223.67C266.07 212.99 273.38 203.22 279.79 194.67C288.5 183.15 295.56 173.83 300.46 167.35C302.91 164.16 304.82 161.68 306.14 159.96C306.79 159.14 307.28 158.51 307.64 158.06C307.98 157.63 308.17 157.42 308.18 157.43C308.19 157.44 308.04 157.67 307.72 158.12C307.38 158.59 306.91 159.24 306.3 160.08C305.01 161.81 303.14 164.32 300.74 167.55C298.44 170.6 295.65 174.28 292.45 178.53C317.71 145.38 340.46 115.44 357.01 93.3798C365.69 81.8198 372.67 72.4198 377.45 65.8998C379.84 62.6398 381.67 60.0898 382.9 58.3498C384.12 56.6098 384.73 55.6698 384.66 55.6198C384.59 55.5698 383.86 56.4198 382.51 58.0798C381.17 59.7398 379.22 62.2098 376.74 65.3998C371.78 71.7898 364.67 81.0898 355.94 92.6198C338.48 115.68 314.55 147.66 288.18 183.03C274.91 200.8 262.28 217.71 250.8 233.09C250.71 233.26 250.62 233.44 250.52 233.62C252.99 230.38 255.51 227.06 258.08 223.68L258.07 223.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 233.8C250.37 233.69 250.43 233.58 250.49 233.47C250.46 233.51 250.43 233.55 250.4 233.59C250.38 233.64 250.35 233.68 250.33 233.73C250.33 233.75 250.33 233.78 250.32 233.8H250.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85 234.43C249.74 234.53 249.64 234.63 249.53 234.74C247.77 237.09 246.05 239.4 244.35 241.68C246.14 239.33 247.96 236.94 249.81 234.51L249.85 234.44V234.43Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 233.8C250.31 233.8 250.31 233.85 250.3 233.87C250.37 233.78 250.43 233.69 250.5 233.6C250.59 233.43 250.68 233.25 250.78 233.07C250.68 233.2 250.58 233.33 250.48 233.47C250.42 233.58 250.36 233.69 250.3 233.8H250.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.29 160.07C306.9 159.23 307.37 158.58 307.71 158.11C308.03 157.66 308.18 157.43 308.17 157.42C308.16 157.41 307.97 157.62 307.63 158.05C307.27 158.5 306.78 159.13 306.13 159.95C304.81 161.66 302.91 164.15 300.45 167.34C295.55 173.82 288.5 183.14 279.78 194.66C273.37 203.22 266.06 212.98 258.06 223.66C267.69 211 277.99 197.48 288.7 183.4C289.95 181.76 291.19 180.13 292.43 178.51C295.63 174.27 298.42 170.58 300.72 167.53C303.12 164.3 304.99 161.79 306.28 160.06L306.29 160.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.24 273.37C211.55 284.91 204.51 294.24 199.63 300.73C197.23 303.96 195.37 306.47 194.08 308.21C193.47 309.05 193 309.71 192.66 310.17C192.35 310.62 192.19 310.85 192.2 310.86C192.21 310.87 192.4 310.66 192.74 310.23C193.1 309.78 193.59 309.14 194.24 308.32C195.55 306.6 197.46 304.12 199.91 300.93C204.8 294.45 211.84 285.11 220.54 273.58C227.44 264.33 235.41 253.67 244.14 241.98C243.61 242.68 243.07 243.39 242.53 244.09C234.31 254.89 226.81 264.74 220.24 273.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85 234.43C249.75 234.53 249.65 234.62 249.55 234.72C249.55 234.72 249.55 234.73 249.54 234.74C249.65 234.64 249.75 234.54 249.86 234.43H249.85Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93 234.21C249.93 234.21 249.95 234.2 249.97 234.19C249.97 234.19 249.96 234.19 249.95 234.19C249.95 234.19 249.94 234.2 249.93 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.18C249.98 234.18 249.97 234.18 249.95 234.19C249.95 234.19 249.96 234.19 249.97 234.19C249.97 234.19 249.97 234.19 249.98 234.18H249.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.19C249.97 234.19 249.97 234.19 249.96 234.2L249.97 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 233.75C250.31 233.75 250.28 233.84 250.27 233.88C250.28 233.85 250.3 233.83 250.31 233.8C250.31 233.78 250.31 233.75 250.32 233.73C250.32 233.73 250.32 233.74 250.32 233.75H250.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 233.9C250.26 233.9 250.28 233.88 250.3 233.87C250.3 233.85 250.3 233.82 250.31 233.8C250.3 233.83 250.28 233.85 250.27 233.88C250.27 233.88 250.27 233.89 250.27 233.9H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 233.93C250.25 233.93 250.27 233.92 250.27 233.91C250.27 233.9 250.28 233.89 250.29 233.88C250.28 233.88 250.27 233.9 250.25 233.91C250.25 233.92 250.25 233.93 250.24 233.94L250.25 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 233.91C250.27 233.91 250.25 233.92 250.25 233.93C250.25 233.93 250.26 233.92 250.27 233.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.92C250.23 233.92 250.25 233.91 250.26 233.9C250.26 233.9 250.26 233.88 250.27 233.88C250.28 233.84 250.3 233.79 250.31 233.75C250.29 233.79 250.26 233.84 250.24 233.88C250.24 233.89 250.24 233.9 250.23 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.92C250.23 233.92 250.23 233.9 250.24 233.88C250.24 233.88 250.24 233.9 250.23 233.91C250.23 233.91 250.23 233.91 250.23 233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.92C250.23 233.92 250.23 233.92 250.23 233.91C250.23 233.91 250.23 233.93 250.22 233.93C250.22 233.93 250.22 233.93 250.23 233.93V233.92Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 233.9C250.26 233.9 250.26 233.89 250.26 233.88C250.26 233.88 250.26 233.9 250.25 233.9H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 233.9C250.26 233.9 250.24 233.91 250.23 233.92V233.94C250.23 233.93 250.24 233.91 250.25 233.9H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.96C250.21 233.96 250.21 233.96 250.22 233.95V233.93C250.22 233.94 250.22 233.96 250.21 233.97V233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.97C250.19 233.97 250.2 233.97 250.21 233.96C250.21 233.95 250.21 233.93 250.22 233.92C250.22 233.92 250.22 233.92 250.21 233.92C250.21 233.93 250.2 233.95 250.19 233.96V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.94C250.23 233.94 250.24 233.93 250.25 233.92C250.25 233.91 250.25 233.9 250.26 233.89C250.26 233.9 250.25 233.92 250.24 233.93L250.23 233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.95C250.23 233.95 250.23 233.95 250.22 233.96L250.23 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.95C250.23 233.95 250.24 233.94 250.25 233.93C250.25 233.93 250.24 233.94 250.23 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.96C250.21 233.96 250.2 233.96 250.19 233.97C250.19 233.97 250.19 233.97 250.2 233.97L250.21 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.97L250.22 233.96H250.21V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85 234.43L249.81 234.5C249.81 234.5 249.88 234.41 249.92 234.36C249.92 234.36 249.9 234.38 249.89 234.39C249.88 234.4 249.87 234.41 249.85 234.43Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 233.73C250.32 233.73 250.37 233.64 250.39 233.59C250.37 233.61 250.35 233.64 250.34 233.66C250.34 233.67 250.33 233.69 250.32 233.7C250.32 233.7 250.32 233.71 250.32 233.72V233.73Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85 234.43C249.86 234.42 249.87 234.41 249.89 234.39C249.88 234.4 249.87 234.41 249.85 234.43Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.17H249.99V234.18L249.98 234.19H249.99L250 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 233.89C250.17 233.89 250.15 233.91 250.15 233.92C250.15 233.92 250.15 233.93 250.15 233.94C250.15 233.92 250.16 233.91 250.17 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 233.96V233.93C250.15 233.93 250.15 233.93 250.14 233.93C250.14 233.93 250.14 233.94 250.14 233.95L250.15 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.98C250.12 233.97 250.12 233.96 250.13 233.95C250.13 233.95 250.13 233.96 250.12 233.97V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.98C250.12 233.98 250.12 233.98 250.13 233.98C250.13 233.98 250.13 233.97 250.13 233.96V233.94C250.13 233.95 250.13 233.96 250.12 233.97V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.97V233.96L250.11 233.97H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.98V233.97H250.11V233.98H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 233.98H250.1V233.99L250.11 233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 233.71C250.32 233.71 250.32 233.73 250.31 233.75C250.31 233.75 250.31 233.74 250.31 233.73C250.31 233.73 250.31 233.72 250.31 233.71H250.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 233.67C250.34 233.67 250.34 233.67 250.34 233.68C250.34 233.69 250.34 233.7 250.34 233.71C250.34 233.7 250.35 233.68 250.36 233.67H250.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 233.94C250.2 233.94 250.21 233.87 250.22 233.83C250.22 233.84 250.2 233.85 250.2 233.86C250.2 233.89 250.2 233.91 250.2 233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.96C250.18 233.96 250.18 233.96 250.19 233.96C250.19 233.93 250.19 233.91 250.19 233.88C250.19 233.88 250.19 233.89 250.18 233.9V233.97V233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 233.96V233.89C250.17 233.91 250.16 233.92 250.15 233.94C250.15 233.94 250.15 233.95 250.16 233.96H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.97C250.19 233.97 250.19 233.95 250.19 233.94C250.19 233.94 250.19 233.94 250.18 233.94V233.96C250.18 233.96 250.18 233.96 250.19 233.96V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 233.97C250.16 233.97 250.16 233.97 250.17 233.97C250.17 233.97 250.17 233.96 250.16 233.95V233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 233.98C250.16 233.98 250.16 233.98 250.17 233.98C250.17 233.98 250.17 233.98 250.17 233.97C250.17 233.97 250.17 233.97 250.16 233.97V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 233.98V233.97L250.14 233.98H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 233.98H250.16V233.97H250.15V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.88C250.24 233.88 250.29 233.79 250.31 233.75C250.31 233.74 250.31 233.73 250.32 233.71C250.32 233.7 250.32 233.69 250.32 233.68C250.31 233.7 250.29 233.72 250.28 233.73C250.26 233.78 250.25 233.83 250.23 233.88H250.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.88C250.24 233.88 250.27 233.78 250.29 233.73C250.27 233.76 250.24 233.8 250.22 233.83C250.22 233.85 250.22 233.88 250.23 233.9C250.23 233.9 250.23 233.88 250.24 233.87V233.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 233.94C250.2 233.94 250.21 233.94 250.22 233.93C250.22 233.93 250.22 233.91 250.23 233.91C250.23 233.89 250.23 233.86 250.22 233.84C250.22 233.88 250.21 233.91 250.2 233.95V233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 233.93C250.22 233.93 250.21 233.93 250.2 233.94C250.2 233.94 250.2 233.96 250.2 233.97C250.2 233.96 250.22 233.94 250.22 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.17 227.33C267.73 217.06 277.36 207.7 285.71 199.59C296.16 189.53 304.62 181.38 310.5 175.73C313.43 172.95 315.71 170.78 317.29 169.29C318.06 168.58 318.65 168.03 319.08 167.64C319.49 167.27 319.7 167.09 319.71 167.1C319.72 167.11 319.53 167.32 319.15 167.71C318.74 168.12 318.17 168.69 317.43 169.43C315.88 170.95 313.63 173.15 310.74 175.97C304.87 181.63 296.41 189.78 285.97 199.85C277.55 207.89 267.84 217.16 257.18 227.34C255.08 229.38 252.95 231.45 250.78 233.56C250.8 233.55 250.81 233.54 250.83 233.53C264.82 220.14 280.22 205.4 296.4 189.92C328.44 159.3 357.41 131.53 378.26 111.3C388.69 101.19 397.09 92.9699 402.85 87.2399C405.73 84.3799 407.95 82.1399 409.44 80.5999C410.93 79.0599 411.68 78.2299 411.62 78.1699C411.56 78.1099 410.7 78.8399 409.11 80.2699C407.52 81.7099 405.2 83.8499 402.24 86.6299C396.31 92.1899 387.8 100.31 377.33 110.37C356.39 130.51 327.63 158.49 295.92 189.44C279.88 205.07 264.62 219.95 250.75 233.46C250.75 233.47 250.74 233.48 250.73 233.49C252.92 231.4 255.06 229.35 257.18 227.34L257.17 227.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 233.83C250.35 233.83 250.35 233.83 250.34 233.84C250.34 233.84 250.34 233.84 250.35 233.84V233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42 233.77C250.52 233.67 250.62 233.58 250.72 233.48C250.72 233.47 250.73 233.46 250.74 233.45C250.63 233.56 250.53 233.66 250.42 233.76V233.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 233.83C250.35 233.83 250.39 233.79 250.42 233.77C250.4 233.79 250.38 233.81 250.35 233.84V233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77 233.54C252.94 231.43 255.07 229.36 257.17 227.32C255.06 229.34 252.91 231.39 250.72 233.47C250.67 233.54 250.62 233.61 250.57 233.68C250.64 233.63 250.71 233.59 250.77 233.54Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.61 292.32C186.73 295.15 184.48 297.35 182.93 298.87C182.19 299.61 181.62 300.18 181.21 300.59C180.83 300.98 180.64 301.19 180.65 301.2C180.66 301.21 180.88 301.03 181.28 300.66C181.7 300.27 182.3 299.72 183.06 299C184.63 297.5 186.91 295.34 189.84 292.55C195.71 286.89 204.16 278.73 214.6 268.66C222.94 260.54 232.56 251.16 243.11 240.87C232.46 251.06 222.75 260.36 214.34 268.41C203.91 278.49 195.46 286.65 189.6 292.32H189.61Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.73 175.96C313.62 173.13 315.86 170.94 317.42 169.42C318.16 168.68 318.73 168.11 319.14 167.7C319.52 167.31 319.71 167.1 319.7 167.09C319.69 167.08 319.47 167.26 319.07 167.63C318.65 168.02 318.05 168.57 317.28 169.28C315.7 170.77 313.42 172.94 310.49 175.72C304.61 181.38 296.15 189.52 285.7 199.58C277.36 207.69 267.73 217.05 257.16 227.32C267.82 217.14 277.54 207.87 285.95 199.83C296.39 189.76 304.85 181.61 310.72 175.95L310.73 175.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5 234.66C247.34 236.77 245.21 238.84 243.13 240.87C245.24 238.85 247.38 236.8 249.56 234.72C249.61 234.65 249.66 234.58 249.71 234.52C249.64 234.57 249.57 234.61 249.51 234.66H249.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 233.84V233.83L250.34 233.84H250.35Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.57 233.69C250.62 233.62 250.67 233.55 250.72 233.48C250.62 233.58 250.52 233.67 250.42 233.77C250.42 233.78 250.41 233.79 250.4 233.8C250.46 233.76 250.51 233.72 250.56 233.69H250.57Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 233.84C250.35 233.84 250.39 233.81 250.4 233.8C250.4 233.79 250.41 233.78 250.42 233.77C250.4 233.79 250.38 233.81 250.35 233.83V233.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47 233.84C250.47 233.84 250.48 233.84 250.49 233.84C250.6 233.73 250.71 233.63 250.83 233.52C250.81 233.53 250.8 233.54 250.78 233.55C250.68 233.65 250.58 233.75 250.48 233.85L250.47 233.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 233.84L250.32 233.86C250.32 233.86 250.34 233.84 250.35 233.84H250.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44 233.85C250.44 233.85 250.46 233.85 250.46 233.84C250.56 233.74 250.66 233.64 250.76 233.54C250.69 233.59 250.62 233.63 250.56 233.68C250.52 233.74 250.48 233.79 250.44 233.85Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 233.91C250.29 233.91 250.33 233.86 250.35 233.84C250.35 233.84 250.33 233.86 250.32 233.86C250.32 233.86 250.31 233.87 250.3 233.88V233.9L250.29 233.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44 233.85C250.48 233.79 250.52 233.74 250.56 233.68C250.5 233.72 250.45 233.76 250.4 233.79C250.38 233.82 250.37 233.85 250.35 233.89C250.38 233.88 250.41 233.86 250.44 233.85Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 233.93C250.29 233.93 250.33 233.91 250.35 233.9C250.37 233.87 250.38 233.84 250.4 233.8C250.38 233.81 250.36 233.83 250.35 233.84C250.33 233.86 250.31 233.89 250.29 233.91C250.29 233.91 250.29 233.92 250.29 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44 233.88C250.44 233.88 250.42 233.89 250.41 233.9C250.41 233.9 250.4 233.92 250.39 233.92C250.41 233.91 250.42 233.89 250.44 233.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36 233.95L250.38 233.93C250.38 233.93 250.39 233.91 250.4 233.91C250.38 233.93 250.37 233.94 250.35 233.96L250.36 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.4 233.9C250.4 233.9 250.35 233.93 250.33 233.95H250.35C250.37 233.93 250.38 233.92 250.4 233.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 233.9C250.41 233.9 250.43 233.89 250.44 233.88C250.46 233.86 250.47 233.85 250.49 233.83C250.49 233.83 250.48 233.83 250.47 233.83C250.45 233.85 250.43 233.87 250.41 233.89V233.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 233.9V233.89L250.4 233.9H250.41Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 233.89C250.41 233.89 250.45 233.85 250.47 233.83C250.47 233.83 250.45 233.83 250.45 233.84C250.44 233.85 250.43 233.87 250.42 233.88L250.41 233.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 233.95C250.32 233.95 250.32 233.95 250.33 233.95C250.35 233.93 250.38 233.92 250.4 233.9C250.41 233.89 250.42 233.87 250.43 233.86C250.4 233.87 250.37 233.89 250.34 233.9C250.34 233.92 250.32 233.94 250.31 233.96L250.32 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 233.95C250.32 233.95 250.34 233.91 250.35 233.89C250.33 233.9 250.31 233.91 250.29 233.92C250.29 233.93 250.29 233.94 250.29 233.95C250.3 233.95 250.32 233.95 250.33 233.95H250.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.95C250.24 233.95 250.26 233.95 250.27 233.94C250.27 233.94 250.28 233.93 250.29 233.92V233.9C250.29 233.9 250.27 233.91 250.27 233.92C250.27 233.93 250.25 233.94 250.24 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 233.93C250.29 233.93 250.29 233.92 250.29 233.91C250.29 233.91 250.28 233.92 250.27 233.93C250.27 233.93 250.27 233.93 250.28 233.93H250.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 233.96C250.25 233.96 250.27 233.94 250.27 233.93C250.26 233.93 250.25 233.93 250.24 233.94C250.24 233.94 250.24 233.95 250.24 233.96C250.24 233.96 250.24 233.96 250.25 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 233.96C250.25 233.96 250.27 233.96 250.28 233.96C250.28 233.95 250.28 233.94 250.28 233.93C250.28 233.93 250.28 233.93 250.27 233.93C250.27 233.94 250.25 233.95 250.25 233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 233.94L250.24 233.95L250.25 233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.96L250.23 233.97H250.24V233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.37L249.93 234.36L249.92 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.37L249.93 234.36L249.92 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87 234.4C249.81 234.44 249.76 234.48 249.7 234.52C249.65 234.59 249.6 234.66 249.55 234.72C249.65 234.62 249.75 234.53 249.85 234.43C249.85 234.42 249.86 234.41 249.87 234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 233.91C250.27 233.91 250.26 233.92 250.25 233.93C250.25 233.93 250.25 233.93 250.25 233.94C250.25 233.93 250.27 233.92 250.28 233.91H250.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.96V233.95L250.22 233.96H250.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.95C250.24 233.95 250.24 233.95 250.24 233.94C250.24 233.94 250.23 233.95 250.22 233.96L250.24 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 233.96L250.24 233.95H250.23V233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89 234.4C249.89 234.4 249.91 234.38 249.92 234.37C249.91 234.37 249.9 234.39 249.89 234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.37C249.9 234.38 249.88 234.39 249.87 234.41C249.87 234.42 249.86 234.43 249.85 234.44C249.86 234.43 249.87 234.42 249.89 234.4C249.9 234.4 249.91 234.38 249.92 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.19L250 234.18V234.17L249.99 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.16C250.02 234.16 250.01 234.16 250 234.16C250 234.16 250.02 234.16 250.02 234.15V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68 271.21C195.76 272.57 193.86 273.92 191.96 275.26C197.05 271.68 202.95 267.54 209.54 262.91C219.11 256.12 230.17 248.27 242.3 239.66C241.19 240.43 240.08 241.21 238.99 241.96C225.99 251.16 212.11 260.98 197.67 271.2L197.68 271.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06 185.52C322.4 183.22 325 181.42 326.8 180.18C327.67 179.59 328.35 179.14 328.83 178.82C329.29 178.52 329.53 178.37 329.54 178.38C329.55 178.39 329.33 178.57 328.89 178.9C328.42 179.24 327.77 179.72 326.92 180.34C325.14 181.61 322.57 183.44 319.27 185.79C312.56 190.49 302.91 197.27 290.98 205.64C281.48 212.24 270.53 219.83 258.53 228.17C255.86 230.06 253.23 231.93 250.65 233.76C250.83 233.67 251.01 233.59 251.18 233.5C267.08 222.43 284.57 210.26 302.94 197.47C339.49 172.07 372.56 149.01 396.39 132.18C408.31 123.77 417.92 116.92 424.53 112.13C427.83 109.74 430.39 107.86 432.1 106.57C433.81 105.28 434.69 104.56 434.64 104.5C434.59 104.44 433.62 105.02 431.82 106.2C430.02 107.38 427.39 109.15 424.02 111.44C417.27 116.04 407.57 122.77 395.61 131.13C371.7 147.85 338.81 171.15 302.54 196.93C288.59 206.83 275.15 216.36 262.54 225.31C272.89 217.98 282.39 211.26 290.76 205.34C302.69 196.98 312.36 190.21 319.07 185.51L319.06 185.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 234.4C247.22 236.18 244.75 237.94 242.32 239.66C244.66 238.03 247.03 236.38 249.44 234.7C249.56 234.59 249.67 234.48 249.78 234.37C249.76 234.37 249.74 234.39 249.73 234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67 233.84C250.67 233.84 250.73 233.8 250.77 233.77C250.67 233.82 250.56 233.87 250.46 233.92H250.52C250.57 233.89 250.62 233.86 250.68 233.83L250.67 233.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.3C250.02 234.3 250.04 234.29 250.04 234.28C250.04 234.28 250.04 234.27 250.04 234.26C250.04 234.27 250.03 234.29 250.02 234.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78 234.38C249.66 234.49 249.55 234.6 249.44 234.71C249.46 234.7 249.48 234.68 249.5 234.67C249.6 234.57 249.7 234.47 249.8 234.38C249.8 234.38 249.79 234.38 249.78 234.39V234.38Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.97 205.63C302.9 197.26 312.56 190.49 319.26 185.78C322.56 183.43 325.14 181.59 326.91 180.33C327.76 179.71 328.41 179.23 328.88 178.89C329.32 178.56 329.54 178.39 329.53 178.37C329.52 178.36 329.28 178.5 328.82 178.81C328.34 179.13 327.66 179.59 326.79 180.17C324.99 181.41 322.39 183.2 319.05 185.51C312.34 190.21 302.68 196.98 290.74 205.34C282.37 211.26 272.87 217.98 262.52 225.31C261.17 226.27 259.83 227.22 258.51 228.16C270.52 219.82 281.46 212.23 290.96 205.63H290.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 241.97C228.08 249.57 218.09 256.52 209.33 262.62C197.41 271 187.76 277.79 181.06 282.5C177.76 284.86 175.19 286.69 173.42 287.96C172.57 288.58 171.92 289.06 171.45 289.4C171.01 289.73 170.79 289.91 170.8 289.92C170.81 289.93 171.05 289.79 171.51 289.48C171.99 289.15 172.66 288.7 173.54 288.11C175.33 286.87 177.93 285.07 181.27 282.77C184.27 280.67 187.85 278.15 191.97 275.26C193.87 273.92 195.77 272.57 197.69 271.21C212.13 260.99 226.01 251.17 239.01 241.97H239Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 233.94C250.37 233.94 250.43 233.94 250.46 233.93C250.56 233.88 250.67 233.83 250.77 233.78C250.91 233.69 251.04 233.59 251.17 233.5C250.99 233.59 250.81 233.67 250.64 233.76C250.55 233.82 250.46 233.89 250.37 233.95V233.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.24C250.06 234.24 250.06 234.24 250.05 234.24C250.05 234.24 250.05 234.25 250.05 234.26C250.05 234.25 250.05 234.23 250.06 234.22V234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.19L250.17 234.2L250.16 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.19H250.18V234.18L250.17 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.19H250.16L250.17 234.2V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.23C250.08 234.23 250.07 234.23 250.06 234.24C250.06 234.25 250.06 234.27 250.05 234.28C250.05 234.28 250.05 234.28 250.06 234.28C250.06 234.27 250.07 234.25 250.08 234.24V234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.23C250.08 234.23 250.08 234.25 250.08 234.26C250.08 234.26 250.08 234.26 250.09 234.26C250.09 234.26 250.09 234.25 250.09 234.24C250.09 234.24 250.09 234.24 250.08 234.24V234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.27C250.05 234.27 250.06 234.27 250.07 234.26C250.07 234.26 250.07 234.24 250.07 234.23C250.07 234.24 250.06 234.26 250.05 234.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.23L250.13 234.22L250.12 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.22H250.14L250.13 234.21V234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.21H250.13L250.14 234.22V234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.21H250.14V234.2L250.13 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.19C250.16 234.19 250.15 234.19 250.14 234.19C250.14 234.19 250.14 234.19 250.14 234.18L250.16 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.23C250.09 234.23 250.09 234.24 250.09 234.25C250.09 234.25 250.09 234.25 250.1 234.25C250.1 234.25 250.1 234.25 250.1 234.24L250.09 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.23C250.11 234.23 250.11 234.23 250.1 234.23C250.1 234.23 250.1 234.23 250.1 234.24V234.23H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.23H250.11V234.24L250.12 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.23H250.1L250.09 234.22V234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.22L250.1 234.23H250.11L250.1 234.22H250.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.22H250.11H250.1L250.11 234.23H250.12V234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.21V234.22H250.12L250.11 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.32C249.97 234.32 249.94 234.35 249.92 234.36C249.93 234.36 249.94 234.34 249.96 234.33L249.97 234.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.33C249.97 234.33 249.98 234.31 249.99 234.3C249.99 234.3 249.98 234.31 249.97 234.32V234.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.28C250.02 234.28 250 234.3 249.99 234.31C249.99 234.31 249.98 234.33 249.97 234.34C249.98 234.34 249.99 234.32 250.01 234.31C250.01 234.3 250.01 234.29 250.02 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.26C250.04 234.26 250.03 234.27 250.02 234.28C250.02 234.29 250.02 234.3 250.01 234.31C250.01 234.3 250.02 234.28 250.03 234.27L250.04 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83 234.35C249.83 234.35 249.81 234.35 249.8 234.36C249.7 234.46 249.6 234.56 249.5 234.65C249.57 234.6 249.64 234.56 249.7 234.51C249.74 234.45 249.78 234.4 249.82 234.35H249.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.25V234.26L250.05 234.25H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.32C249.97 234.32 249.94 234.35 249.92 234.37C249.94 234.36 249.95 234.34 249.97 234.33V234.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.32C249.97 234.32 249.98 234.31 249.99 234.3L249.97 234.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.29C250 234.29 250.02 234.27 250.03 234.26C250.03 234.26 250.01 234.27 250.01 234.28L250 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.26C250.04 234.26 250.04 234.26 250.03 234.27C250.03 234.27 250.04 234.26 250.05 234.25L250.04 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.37C249.94 234.35 249.95 234.34 249.97 234.32V234.3C249.95 234.32 249.93 234.35 249.92 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.26C250.02 234.26 250.01 234.27 250 234.28C250 234.28 249.99 234.29 249.98 234.3V234.32C249.98 234.32 250 234.31 250 234.3C250 234.29 250.02 234.28 250.03 234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.29C250 234.29 250.02 234.28 250.02 234.27C250.02 234.27 250.02 234.27 250.02 234.26C250.02 234.27 250 234.28 249.99 234.3L250 234.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.26C250.03 234.26 250.03 234.26 250.03 234.27C250.03 234.27 250.03 234.27 250.04 234.26H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.25H250.03L250.04 234.26V234.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83 234.35C249.79 234.41 249.75 234.46 249.71 234.51C249.77 234.47 249.82 234.43 249.88 234.39C249.9 234.36 249.91 234.33 249.93 234.3C249.9 234.32 249.87 234.33 249.84 234.34L249.83 234.35Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.29C249.98 234.29 249.98 234.29 249.98 234.28C249.96 234.29 249.94 234.3 249.92 234.31C249.9 234.34 249.89 234.37 249.87 234.4C249.89 234.39 249.91 234.38 249.92 234.36C249.94 234.34 249.96 234.31 249.97 234.29H249.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.28C249.98 234.28 249.98 234.28 249.98 234.29C249.98 234.29 249.99 234.28 250 234.27C250 234.27 250 234.27 249.99 234.27L249.98 234.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83 234.33C249.83 234.33 249.87 234.29 249.89 234.28C249.89 234.28 249.89 234.27 249.9 234.26C249.81 234.33 249.72 234.39 249.62 234.46C249.66 234.44 249.69 234.42 249.73 234.41C249.76 234.39 249.8 234.36 249.83 234.34V234.33Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.02 196.59C329.69 194.82 332.55 193.45 334.52 192.5C335.48 192.05 336.22 191.71 336.74 191.46C337.24 191.23 337.51 191.12 337.51 191.14C337.51 191.16 337.27 191.3 336.78 191.55C336.26 191.82 335.54 192.19 334.6 192.67C332.64 193.65 329.81 195.07 326.17 196.89C318.79 200.52 308.16 205.74 295.03 212.19C284.47 217.32 272.3 223.22 258.93 229.72C256.13 231.11 253.38 232.49 250.66 233.84C250.63 233.86 250.61 233.88 250.58 233.9C250.74 233.85 250.9 233.8 251.06 233.75C268.6 225.21 287.9 215.81 308.17 205.94C348.36 186.4 384.73 168.66 410.97 155.66C424.09 149.16 434.69 143.85 441.99 140.13C445.64 138.27 448.46 136.8 450.36 135.79C452.26 134.77 453.24 134.2 453.2 134.13C453.16 134.06 452.11 134.49 450.14 135.38C448.17 136.27 445.29 137.61 441.59 139.37C434.19 142.89 423.52 148.06 410.37 154.5C384.06 167.39 347.84 185.4 307.86 205.35C292.12 213.19 276.96 220.74 262.77 227.81C274.57 221.95 285.36 216.59 294.85 211.88C307.98 205.44 318.61 200.22 326 196.6L326.02 196.59Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88 238.22C244.24 237.07 246.64 235.9 249.07 234.72C249.21 234.62 249.34 234.53 249.48 234.44C246.91 235.72 244.37 236.99 241.88 238.23V238.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.35 262.79C190.4 263.76 188.46 264.73 186.52 265.69C192.02 262.98 198.35 259.87 205.42 256.39C216.07 251.08 228.36 244.96 241.88 238.23C240.73 238.79 239.59 239.35 238.46 239.9C223.98 247.09 208.47 254.79 192.35 262.8V262.79Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88 234.28C249.88 234.28 249.84 234.32 249.82 234.33C249.83 234.33 249.84 234.31 249.85 234.31C249.85 234.3 249.86 234.29 249.87 234.28H249.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89 234.26C249.89 234.26 249.84 234.26 249.81 234.27C249.7 234.32 249.59 234.38 249.48 234.43C249.34 234.53 249.21 234.62 249.07 234.71C249.25 234.62 249.43 234.53 249.61 234.45C249.7 234.38 249.79 234.32 249.89 234.25V234.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46 239.89C226.22 245.85 215.05 251.29 205.26 256.06C192.14 262.53 181.52 267.77 174.14 271.4C170.5 273.23 167.67 274.65 165.71 275.63C164.77 276.11 164.05 276.49 163.53 276.76C163.04 277.02 162.8 277.16 162.8 277.17C162.8 277.19 163.07 277.08 163.57 276.85C164.1 276.6 164.84 276.26 165.79 275.81C167.76 274.86 170.62 273.48 174.29 271.71C177.7 270.03 181.8 268.01 186.52 265.69C188.45 264.73 190.4 263.76 192.35 262.79C208.47 254.78 223.97 247.09 238.46 239.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.05 212.2C308.18 205.75 318.81 200.52 326.19 196.9C329.83 195.08 332.67 193.66 334.62 192.68C335.56 192.2 336.28 191.82 336.8 191.56C337.29 191.3 337.53 191.16 337.53 191.15C337.53 191.13 337.26 191.24 336.76 191.47C336.23 191.72 335.49 192.06 334.54 192.51C332.57 193.46 329.71 194.84 326.04 196.6C318.66 200.22 308.03 205.44 294.89 211.88C285.4 216.59 274.61 221.95 262.81 227.81C261.52 228.45 260.23 229.09 258.96 229.73C272.33 223.24 284.5 217.33 295.06 212.2H295.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 234.03C250.45 234.03 250.47 234.03 250.48 234.03C250.5 234.02 250.52 234.01 250.54 234C250.54 234 250.54 234 250.53 234C250.5 234 250.48 234.02 250.45 234.02V234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.23C249.92 234.23 249.89 234.24 249.87 234.25C249.85 234.25 249.83 234.27 249.81 234.28C249.84 234.28 249.86 234.28 249.89 234.27C249.89 234.27 249.9 234.25 249.91 234.24L249.92 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87 234.24C249.87 234.24 249.9 234.23 249.92 234.22C249.92 234.22 249.92 234.22 249.93 234.21C249.91 234.22 249.89 234.23 249.87 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 234.05C250.45 234.05 250.47 234.04 250.48 234.03C250.48 234.03 250.46 234.03 250.45 234.03L250.39 234.05C250.39 234.05 250.43 234.05 250.45 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 234.1C250.35 234.1 250.38 234.09 250.39 234.08C250.37 234.08 250.35 234.09 250.33 234.1C250.33 234.1 250.34 234.1 250.35 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 234.1C250.35 234.1 250.37 234.09 250.39 234.08C250.4 234.08 250.41 234.07 250.42 234.06H250.35C250.35 234.06 250.32 234.08 250.31 234.09C250.31 234.09 250.31 234.09 250.32 234.09L250.33 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.1V234.11L250.31 234.1H250.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.12C250.27 234.12 250.27 234.12 250.27 234.13C250.27 234.13 250.29 234.13 250.29 234.12C250.29 234.12 250.28 234.12 250.27 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.13C250.26 234.13 250.26 234.13 250.26 234.14C250.26 234.14 250.26 234.14 250.27 234.14C250.27 234.14 250.27 234.14 250.27 234.13H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.13V234.14H250.27L250.26 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.15L250.26 234.14H250.25V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.14H250.26V234.13L250.25 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.15L250.24 234.14L250.25 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.14L250.25 234.15V234.14H250.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.15H250.25L250.24 234.14V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.16H250.23L250.24 234.15H250.23L250.22 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.16L250.21 234.17L250.22 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 234.26C249.9 234.26 249.9 234.27 249.89 234.28C249.89 234.28 249.9 234.27 249.91 234.26H249.9Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.31C249.86 234.31 249.89 234.28 249.91 234.26C249.91 234.26 249.9 234.27 249.89 234.28C249.89 234.28 249.88 234.3 249.87 234.31H249.86Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93 234.24C249.93 234.24 249.91 234.25 249.91 234.26C249.91 234.26 249.92 234.25 249.93 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93 234.24C249.93 234.24 249.92 234.25 249.91 234.26C249.92 234.25 249.94 234.23 249.95 234.22C249.95 234.22 249.93 234.23 249.92 234.24H249.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 234.22C249.94 234.22 249.93 234.22 249.92 234.22C249.92 234.22 249.91 234.24 249.9 234.25C249.9 234.25 249.92 234.24 249.92 234.23C249.92 234.23 249.93 234.22 249.94 234.21V234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 234.22C249.96 234.22 249.96 234.22 249.95 234.22C249.95 234.22 249.94 234.23 249.93 234.24C249.93 234.24 249.95 234.23 249.96 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.2C249.96 234.2 249.95 234.21 249.93 234.22C249.93 234.22 249.93 234.22 249.92 234.23C249.92 234.23 249.93 234.23 249.94 234.23C249.94 234.23 249.96 234.21 249.97 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.2C249.98 234.2 249.96 234.22 249.95 234.23C249.95 234.23 249.95 234.23 249.96 234.23C249.96 234.23 249.97 234.22 249.98 234.21V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.19H249.97V234.2H249.98V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.31C249.86 234.31 249.91 234.28 249.93 234.26H249.91C249.89 234.28 249.88 234.29 249.86 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.21C249.97 234.21 249.97 234.21 249.96 234.21C249.95 234.22 249.93 234.24 249.92 234.25H249.94C249.94 234.25 249.95 234.25 249.96 234.24C249.96 234.24 249.97 234.22 249.98 234.21H249.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 234.22C249.96 234.22 249.96 234.22 249.97 234.22C249.97 234.22 249.96 234.22 249.95 234.23L249.96 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.2C249.98 234.2 249.97 234.21 249.96 234.22C249.96 234.22 249.97 234.22 249.98 234.21V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.21C249.97 234.21 249.96 234.23 249.95 234.24C249.96 234.24 249.97 234.22 249.99 234.21C249.99 234.21 249.99 234.21 249.99 234.2H249.97V234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.2C250.01 234.2 250.01 234.2 250 234.2C250 234.2 250 234.2 250 234.21C250 234.21 250.01 234.21 250.02 234.2H250.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.2C249.98 234.2 249.98 234.2 249.99 234.2C249.99 234.2 249.99 234.2 249.99 234.19C249.99 234.19 249.99 234.19 249.98 234.19V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.19C250.02 234.19 250.02 234.18 250.02 234.17C250.02 234.17 250 234.18 250 234.19C250 234.19 250 234.19 250 234.2C250 234.2 250 234.2 250.01 234.2C250.01 234.2 250.01 234.2 250.02 234.2V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.17C250.02 234.17 250 234.17 250 234.18C250 234.18 250.02 234.17 250.02 234.16V234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.17C250.06 234.17 250.05 234.17 250.04 234.17C250.04 234.17 250.04 234.17 250.03 234.17C250.03 234.17 250.03 234.18 250.03 234.19C250.04 234.19 250.05 234.18 250.06 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.17L250.03 234.16L250.02 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.14L250.08 234.15H250.09V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.15H250.05V234.16H250.06V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.53 233.92C250.53 233.92 250.58 233.91 250.6 233.9C250.63 233.88 250.65 233.86 250.68 233.84C250.63 233.87 250.58 233.89 250.52 233.92H250.53Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73 234.4C249.73 234.4 249.77 234.38 249.78 234.37C249.8 234.35 249.81 234.34 249.83 234.32C249.8 234.34 249.76 234.37 249.73 234.39V234.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.31C249.86 234.31 249.84 234.33 249.83 234.33C249.81 234.35 249.8 234.36 249.78 234.38C249.78 234.38 249.79 234.38 249.8 234.37C249.82 234.35 249.84 234.33 249.86 234.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.1C250.3 234.1 250.3 234.1 250.31 234.1C250.3 234.1 250.29 234.1 250.27 234.1C250.27 234.1 250.28 234.1 250.29 234.11L250.3 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.09C250.26 234.09 250.28 234.09 250.29 234.1C250.29 234.1 250.28 234.1 250.27 234.09H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.08C250.3 234.08 250.31 234.08 250.32 234.09C250.33 234.09 250.35 234.07 250.36 234.06C250.36 234.06 250.32 234.07 250.31 234.08H250.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.09C250.28 234.09 250.3 234.09 250.32 234.09C250.32 234.09 250.31 234.09 250.3 234.08H250.28V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.09C250.26 234.09 250.26 234.09 250.26 234.1C250.26 234.1 250.27 234.1 250.28 234.1C250.28 234.1 250.28 234.1 250.29 234.1C250.29 234.1 250.29 234.1 250.3 234.1C250.29 234.1 250.28 234.1 250.27 234.09H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.12H250.27L250.26 234.11V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.12V234.13L250.27 234.12H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.12L250.25 234.13H250.26V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.14L250.26 234.13H250.25V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.25L250.06 234.24L250.05 234.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.1L250.26 234.11V234.1H250.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.1H250.26V234.09H250.25V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.11L250.25 234.1V234.11H250.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.09L250.24 234.1L250.25 234.11V234.1V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.11L250.24 234.1L250.25 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.1L250.25 234.09L250.24 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.13L250.26 234.12H250.25V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.18H250.2L250.19 234.17V234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.16C250.19 234.16 250.19 234.17 250.19 234.18C250.19 234.18 250.19 234.17 250.18 234.16H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.12C250.25 234.12 250.25 234.12 250.25 234.13C250.25 234.13 250.25 234.13 250.26 234.13L250.25 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.12C250.23 234.12 250.23 234.12 250.23 234.11C250.23 234.11 250.23 234.12 250.22 234.13L250.23 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.11C250.21 234.11 250.22 234.12 250.23 234.13C250.23 234.13 250.23 234.12 250.24 234.11C250.24 234.11 250.24 234.11 250.23 234.11H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.13C250.23 234.13 250.23 234.13 250.24 234.14C250.24 234.14 250.23 234.14 250.22 234.14L250.23 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.12V234.13L250.24 234.12H250.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.13V234.12L250.22 234.13H250.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.15L250.22 234.16V234.15H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.15H250.22V234.14H250.21V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.13C250.22 234.13 250.21 234.12 250.2 234.11C250.2 234.11 250.21 234.12 250.22 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.13L250.2 234.12V234.13H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.11C250.2 234.11 250.2 234.11 250.2 234.12C250.2 234.12 250.2 234.12 250.21 234.12C250.21 234.12 250.2 234.11 250.19 234.1L250.2 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.13C250.19 234.13 250.2 234.13 250.21 234.13C250.21 234.13 250.21 234.13 250.2 234.13C250.2 234.13 250.2 234.13 250.2 234.14L250.19 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.11C250.19 234.11 250.19 234.11 250.2 234.11C250.2 234.11 250.2 234.11 250.2 234.1L250.19 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.14H250.24L250.23 234.13V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.14V234.13L250.22 234.14H250.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.13V234.14L250.23 234.13H250.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.16V234.17L250.22 234.16H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.16H250.22L250.21 234.15V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.16L250.2 234.17H250.21V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.16C250.19 234.16 250.19 234.17 250.2 234.18C250.2 234.18 250.2 234.18 250.19 234.18V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.15V234.16H250.2L250.19 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.15V234.16H250.19L250.18 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.13V234.14H250.19V234.13H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.14L250.18 234.15H250.19V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.14V234.15L250.19 234.14H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.16V234.15H250.18L250.19 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.18V234.17H250.17L250.18 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.16V234.17H250.18V234.16H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.18L250.17 234.17L250.16 234.18L250.17 234.19L250.18 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.18V234.19H250.17L250.16 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.17H250.18V234.18H250.19V234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.17L250.18 234.16V234.17H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.15L250.17 234.16H250.18V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.23C250.06 234.23 250.07 234.23 250.08 234.22C250.08 234.22 250.08 234.22 250.07 234.22L250.06 234.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.22C250.08 234.22 250.07 234.23 250.06 234.24C250.06 234.24 250.06 234.24 250.07 234.24C250.07 234.24 250.07 234.24 250.07 234.23L250.08 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.21C250.09 234.21 250.09 234.21 250.09 234.22C250.09 234.22 250.09 234.22 250.1 234.22L250.09 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.2C250.11 234.2 250.11 234.2 250.11 234.21C250.11 234.21 250.11 234.21 250.1 234.21L250.11 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.19C250.11 234.19 250.11 234.19 250.12 234.19C250.12 234.19 250.11 234.19 250.1 234.18L250.11 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.18C250.14 234.18 250.14 234.19 250.14 234.2C250.14 234.2 250.15 234.2 250.16 234.2C250.16 234.2 250.16 234.2 250.15 234.19L250.14 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.17C250.14 234.17 250.14 234.17 250.15 234.18C250.15 234.18 250.15 234.18 250.14 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.19V234.17C250.14 234.17 250.13 234.18 250.12 234.19C250.12 234.19 250.13 234.19 250.14 234.2C250.14 234.2 250.14 234.2 250.14 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.16L250.13 234.17L250.14 234.18V234.17V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.15V234.16H250.16V234.15H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.16C250.15 234.16 250.15 234.16 250.15 234.17C250.15 234.17 250.15 234.17 250.16 234.18C250.16 234.18 250.16 234.18 250.16 234.17L250.15 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.16V234.17L250.15 234.16H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.14L250.15 234.15H250.16V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.15L250.14 234.16H250.15V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.14V234.13L250.16 234.14H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.21V234.22H250.1L250.09 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.22L250.09 234.21L250.1 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.2C250.11 234.2 250.11 234.2 250.1 234.21C250.1 234.21 250.1 234.21 250.11 234.21C250.11 234.21 250.11 234.2 250.11 234.19V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.2H250.11V234.19L250.1 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.13L250.19 234.12H250.18V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.13L250.18 234.14V234.13H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.15V234.16H250.17V234.15H250.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.16V234.17V234.18L250.17 234.17L250.16 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.16L250.17 234.17V234.16H250.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.15H250.17V234.14H250.16V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.13L250.18 234.14H250.17V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.16L250.18 234.15H250.17V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.14V234.15H250.18L250.17 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.14H250.17L250.18 234.15V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8 234.37C249.8 234.37 249.82 234.37 249.83 234.36C249.84 234.34 249.85 234.33 249.86 234.31C249.84 234.33 249.82 234.35 249.8 234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.24C250.06 234.24 250.06 234.24 250.05 234.25L250.06 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.24C250.06 234.24 250.06 234.24 250.06 234.25C250.06 234.25 250.06 234.25 250.07 234.24H250.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.21C250.06 234.21 250.06 234.23 250.05 234.24V234.22L250.06 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.2L250.06 234.21H250.07V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.22C250.08 234.22 250.07 234.23 250.06 234.24C250.06 234.24 250.07 234.23 250.08 234.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.19L250.07 234.2L250.08 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.21H250.09L250.08 234.2V234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.2L250.09 234.21L250.08 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.22C250.08 234.22 250.08 234.22 250.07 234.22V234.24C250.07 234.24 250.08 234.23 250.09 234.22H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.19C250.08 234.19 250.08 234.19 250.08 234.2C250.08 234.2 250.08 234.2 250.09 234.2C250.09 234.2 250.09 234.2 250.09 234.19H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.18H250.09V234.17L250.08 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.19C250.11 234.19 250.12 234.18 250.13 234.17C250.13 234.17 250.12 234.18 250.11 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.16V234.17L250.14 234.16H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.16C250.13 234.16 250.12 234.16 250.11 234.16C250.11 234.16 250.11 234.16 250.11 234.17C250.11 234.17 250.12 234.16 250.13 234.15V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.14H250.1V234.15H250.11V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.16C250.11 234.16 250.11 234.16 250.11 234.17C250.11 234.17 250.11 234.17 250.11 234.16C250.11 234.16 250.11 234.16 250.1 234.16H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.15H250.12L250.11 234.14V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.14H250.11L250.12 234.15V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.16C250.12 234.16 250.12 234.16 250.12 234.17C250.12 234.17 250.13 234.17 250.14 234.17L250.12 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.15V234.16H250.13L250.12 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.15L250.13 234.16V234.15H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.12L250.16 234.13V234.12H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.13L250.15 234.12L250.16 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.15L250.16 234.14H250.15V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.15L250.14 234.16L250.15 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.16H250.14L250.13 234.15V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.14V234.13L250.11 234.14H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.13V234.14H250.13V234.13H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.14L250.13 234.13V234.14H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.12L250.14 234.13L250.15 234.14H250.16V234.13L250.15 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.13V234.14H250.15L250.14 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.13L250.14 234.14V234.13H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.13V234.14H250.15H250.16V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.12V234.13H250.17L250.16 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.13H250.16V234.14L250.17 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.13V234.12H250.16L250.17 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.2C250.09 234.2 250.09 234.2 250.1 234.19L250.09 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.2L250.1 234.19L250.09 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.19H250.1V234.2L250.11 234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.19H250.1L250.09 234.18V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.18V234.19H250.11L250.1 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.16V234.17H250.1L250.09 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.18L250.11 234.19V234.17L250.1 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.16L250.1 234.17V234.16H250.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.15V234.14L250.09 234.16H250.1L250.11 234.15H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.16H250.11V234.15L250.1 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.11L250.19 234.12V234.11H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.13H250.18V234.12L250.17 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.12V234.13L250.18 234.12H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.24C250.02 234.24 250 234.26 250 234.27C250.01 234.27 250.02 234.26 250.03 234.25C250.03 234.25 250.03 234.24 250.03 234.23C250.03 234.23 250.03 234.23 250.02 234.23V234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.24C250.03 234.24 250.03 234.24 250.03 234.23C250.03 234.23 250.03 234.24 250.02 234.25C250.02 234.25 250.02 234.25 250.03 234.25V234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.24V234.25L250.04 234.24H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.23C250.03 234.23 250.03 234.23 250.03 234.24C250.03 234.24 250.03 234.22 250.03 234.21C250.03 234.21 250.03 234.22 250.02 234.23H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.21C250.06 234.21 250.05 234.21 250.04 234.21C250.04 234.21 250.04 234.23 250.04 234.24C250.04 234.24 250.05 234.22 250.06 234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.2C250.07 234.2 250.07 234.2 250.07 234.19C250.07 234.19 250.06 234.21 250.05 234.21C250.05 234.21 250.06 234.21 250.07 234.21C250.07 234.21 250.07 234.21 250.07 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.18V234.19H250.08L250.07 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.18L250.08 234.19V234.18H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.21C250.06 234.21 250.05 234.23 250.04 234.24C250.04 234.24 250.04 234.22 250.05 234.21H250.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.2L250.06 234.21L250.07 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.18L250.07 234.17V234.18H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.18L250.07 234.17L250.08 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.16H250.09V234.15L250.08 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.19V234.2L250.08 234.19H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.15L250.1 234.14H250.09V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.16L250.1 234.14L250.09 234.15V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.25C249.95 234.25 249.95 234.25 249.94 234.25C249.92 234.27 249.89 234.28 249.87 234.3C249.87 234.3 249.85 234.33 249.84 234.35C249.87 234.34 249.9 234.32 249.93 234.31C249.94 234.29 249.95 234.27 249.96 234.25H249.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 234.25C249.94 234.25 249.94 234.25 249.95 234.25C249.95 234.25 249.95 234.25 249.95 234.24C249.95 234.24 249.94 234.24 249.93 234.25H249.94Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.25C249.95 234.25 249.93 234.29 249.92 234.31C249.94 234.3 249.96 234.29 249.98 234.28C249.98 234.27 249.98 234.26 249.98 234.25C249.97 234.25 249.96 234.25 249.94 234.25H249.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.24C250.02 234.24 250 234.24 249.99 234.24C249.99 234.25 249.99 234.26 249.99 234.27C249.99 234.27 249.99 234.27 250 234.27C250 234.26 250.02 234.25 250.02 234.24Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.21C249.99 234.21 249.97 234.23 249.95 234.24C249.95 234.24 249.95 234.24 249.95 234.25C249.96 234.25 249.97 234.25 249.99 234.25C249.99 234.24 249.99 234.23 249.99 234.22V234.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.2C250.03 234.2 250.02 234.2 250.01 234.2C250.01 234.2 250 234.2 249.99 234.21C249.99 234.22 249.99 234.23 249.99 234.24C250 234.24 250.01 234.24 250.02 234.24C250.02 234.24 250.02 234.23 250.03 234.22C250.03 234.22 250.03 234.21 250.03 234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.2L250.03 234.19H250.02V234.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.21C250.04 234.21 250.03 234.21 250.02 234.21C250.02 234.21 250.02 234.22 250.02 234.23C250.02 234.23 250.02 234.22 250.03 234.21H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.19H250.03C250.03 234.19 250.04 234.19 250.05 234.19C250.05 234.19 250.05 234.18 250.05 234.17V234.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.19C250.05 234.19 250.05 234.2 250.05 234.21C250.05 234.21 250.06 234.19 250.07 234.19C250.07 234.19 250.07 234.19 250.06 234.19H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.19H250.04C250.04 234.19 250.04 234.18 250.04 234.17C250.03 234.17 250.02 234.18 250.01 234.19H250.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.18C250.07 234.18 250.07 234.19 250.07 234.2C250.07 234.2 250.07 234.2 250.08 234.2L250.07 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.16C250.08 234.16 250.08 234.16 250.07 234.16C250.07 234.16 250.07 234.16 250.07 234.15L250.08 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.15H250.08V234.16L250.09 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.05 234.39C248.49 234.57 247.94 234.74 247.39 234.92C247.99 234.74 248.58 234.55 249.17 234.37C249.13 234.37 249.09 234.38 249.05 234.39Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.72 231.45C273.26 226.85 286.48 222.67 297.93 219.06C311.94 214.71 323.29 211.18 331.16 208.73C335.07 207.55 338.12 206.62 340.22 205.99C341.24 205.69 342.02 205.47 342.58 205.3C343.11 205.15 343.39 205.08 343.4 205.1C343.4 205.12 343.14 205.22 342.62 205.4C342.07 205.58 341.29 205.84 340.29 206.18C338.2 206.85 335.17 207.82 331.28 209.06C324 211.33 313.77 214.52 301.2 218.43C304.77 217.33 308.38 216.22 312.01 215.1C354.86 201.95 393.65 189.99 421.67 181.16C435.68 176.75 447.01 173.13 454.81 170.57C458.71 169.29 461.74 168.27 463.78 167.56C465.82 166.85 466.88 166.43 466.86 166.36C466.83 166.28 465.73 166.55 463.64 167.12C461.55 167.7 458.49 168.58 454.55 169.76C446.67 172.1 435.3 175.57 421.27 179.93C393.21 188.63 354.51 200.88 311.81 214.48C290.25 221.32 269.73 227.84 251.09 233.76C251.01 233.8 250.94 233.83 250.86 233.87C253.52 233.05 256.15 232.25 258.74 231.46L258.72 231.45Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.77 234.16C249.71 234.18 249.65 234.2 249.6 234.22C249.65 234.22 249.69 234.21 249.74 234.2C249.76 234.19 249.78 234.18 249.8 234.17C249.8 234.17 249.78 234.17 249.77 234.17V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 233C264.95 229.57 276.75 225.94 289.02 222.17C279.79 225 269.63 228.11 258.73 231.45C257.11 231.96 255.46 232.48 253.8 233.01V233Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82 234.15C249.82 234.15 249.8 234.15 249.79 234.15C249.79 234.15 249.77 234.15 249.76 234.15C249.76 234.15 249.78 234.15 249.79 234.15C249.79 234.15 249.81 234.15 249.82 234.14V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82 234.17C249.82 234.17 249.8 234.17 249.79 234.17C249.77 234.18 249.75 234.19 249.73 234.2C249.73 234.2 249.74 234.2 249.75 234.2C249.78 234.2 249.8 234.18 249.83 234.18L249.82 234.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82 234.15C249.82 234.15 249.8 234.15 249.79 234.16C249.8 234.16 249.81 234.16 249.82 234.16C249.84 234.16 249.86 234.15 249.88 234.14C249.86 234.14 249.84 234.14 249.82 234.14V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 234.14L249.9 234.15L249.91 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.03 259.26C165.14 260.51 162.11 261.48 160.02 262.15C159.02 262.49 158.24 262.74 157.69 262.93C157.17 263.11 156.9 263.21 156.91 263.23C156.91 263.25 157.19 263.18 157.73 263.03C158.29 262.87 159.08 262.64 160.09 262.34C162.19 261.7 165.23 260.78 169.14 259.59C177.01 257.13 188.35 253.59 202.36 249.22C213.81 245.59 227.03 241.39 241.57 236.77C226.98 241.26 213.72 245.34 202.24 248.87C188.24 253.25 176.9 256.8 169.03 259.26Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85 233.86C250.85 233.86 250.82 233.87 250.81 233.88C250.91 233.86 251.01 233.85 251.11 233.83C252 233.56 252.9 233.28 253.8 233C255.46 232.48 257.1 231.96 258.73 231.44C256.15 232.23 253.52 233.04 250.85 233.85V233.86Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.29 206.17C341.3 205.84 342.07 205.58 342.62 205.39C343.14 205.21 343.41 205.11 343.4 205.09C343.4 205.07 343.12 205.14 342.58 205.29C342.02 205.45 341.23 205.68 340.22 205.98C338.12 206.62 335.07 207.54 331.16 208.72C323.28 211.17 311.94 214.69 297.93 219.05C286.48 222.67 273.26 226.85 258.72 231.44C269.62 228.1 279.78 224.99 289.01 222.16C293.02 220.93 297.09 219.68 301.19 218.41C313.75 214.5 323.99 211.31 331.27 209.04C335.16 207.8 338.19 206.83 340.28 206.16L340.29 206.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41 234.35C249.41 234.35 249.45 234.33 249.46 234.32C249.36 234.34 249.26 234.35 249.17 234.36C248.58 234.54 247.98 234.72 247.39 234.91C245.43 235.53 243.49 236.15 241.57 236.76C244.14 235.97 246.76 235.16 249.41 234.35Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82 234.17C249.82 234.17 249.77 234.19 249.74 234.19C249.78 234.19 249.81 234.18 249.85 234.17C249.84 234.17 249.83 234.17 249.81 234.17H249.82Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41 234.35C249.41 234.35 249.49 234.33 249.53 234.31C249.51 234.31 249.49 234.31 249.47 234.31C249.45 234.31 249.43 234.33 249.42 234.34L249.41 234.35Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89 234.15C249.89 234.15 249.89 234.15 249.88 234.15C249.86 234.15 249.84 234.16 249.82 234.17C249.83 234.17 249.84 234.17 249.86 234.17C249.87 234.17 249.88 234.15 249.89 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89 234.15C249.89 234.15 249.87 234.17 249.86 234.17C249.9 234.17 249.93 234.16 249.97 234.15C249.94 234.15 249.91 234.15 249.89 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.14C249.98 234.14 249.93 234.14 249.91 234.14C249.91 234.14 249.91 234.14 249.9 234.14C249.93 234.14 249.96 234.14 249.98 234.14C249.98 234.14 249.98 234.14 249.98 234.13V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.71 234.2C249.71 234.2 249.71 234.2 249.72 234.2C249.67 234.2 249.63 234.21 249.58 234.22C249.4 234.28 249.22 234.34 249.04 234.39C249.08 234.39 249.12 234.38 249.16 234.37C249.34 234.31 249.52 234.26 249.7 234.2H249.71Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.17 234.37C249.27 234.36 249.37 234.34 249.46 234.33C249.54 234.29 249.63 234.25 249.71 234.21C249.53 234.27 249.35 234.32 249.17 234.38V234.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.18C249.86 234.18 249.79 234.19 249.75 234.2H249.72C249.64 234.25 249.55 234.29 249.47 234.33C249.49 234.33 249.51 234.33 249.53 234.33C249.61 234.31 249.69 234.28 249.77 234.26C249.8 234.24 249.83 234.22 249.86 234.2V234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.18C249.86 234.18 249.8 234.22 249.77 234.24C249.83 234.22 249.89 234.2 249.95 234.19C249.93 234.19 249.9 234.19 249.88 234.18H249.86Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 234.18C249.96 234.18 249.96 234.17 249.97 234.16C249.93 234.16 249.9 234.17 249.86 234.18C249.88 234.18 249.91 234.18 249.93 234.19C249.93 234.19 249.94 234.19 249.95 234.19L249.96 234.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87 234.13C249.87 234.13 249.84 234.14 249.82 234.15H249.84C249.84 234.15 249.86 234.14 249.87 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 234.11C249.94 234.11 249.9 234.12 249.87 234.13C249.86 234.13 249.85 234.14 249.84 234.15C249.86 234.15 249.88 234.15 249.91 234.15C249.92 234.14 249.94 234.13 249.95 234.12C249.95 234.12 249.95 234.12 249.94 234.12V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.13H249.95C249.95 234.13 249.92 234.13 249.91 234.15C249.91 234.15 249.95 234.14 249.97 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.13C249.97 234.13 249.93 234.14 249.91 234.15C249.93 234.15 249.96 234.15 249.98 234.15C249.98 234.15 249.97 234.15 249.96 234.15L249.97 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.1C249.97 234.1 249.97 234.1 249.96 234.1C249.97 234.1 249.98 234.1 249.99 234.1C249.99 234.1 249.98 234.1 249.97 234.09V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.12C249.99 234.12 249.97 234.12 249.96 234.12C249.96 234.12 249.98 234.13 249.98 234.14C249.98 234.14 249.99 234.14 250 234.14L249.99 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.12C250 234.12 249.99 234.12 249.98 234.12C249.98 234.12 249.99 234.12 250 234.12C250 234.12 250 234.12 250 234.11V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.12C250 234.12 249.99 234.12 249.97 234.11C249.97 234.11 249.98 234.11 249.99 234.12C249.99 234.12 249.99 234.12 250 234.12H250.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.11C250.01 234.11 250.01 234.11 250 234.11C250 234.11 249.99 234.11 249.98 234.11C249.99 234.11 250 234.11 250.02 234.12L250.01 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.09V234.1H250.02L250.01 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.08V234.09L250.03 234.08H250.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.14H249.98C249.98 234.14 249.98 234.14 249.98 234.15H250V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.14V234.15L250.01 234.14H250Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.16C250 234.16 249.97 234.17 249.96 234.18C249.97 234.18 249.98 234.18 250 234.17C250 234.17 250 234.17 250 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.16C250 234.16 249.98 234.16 249.97 234.16C249.97 234.16 249.97 234.17 249.96 234.18C249.97 234.18 249.99 234.17 250 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.12C250 234.12 250 234.12 250 234.13C250 234.13 250 234.13 250.01 234.13C250.01 234.13 250.01 234.13 250.01 234.12H250Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.11V234.12H250H250.01V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.12H250L250.01 234.13V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.1V234.11H250.02L250.01 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.11L250.03 234.1H250.02H250.01L250.02 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.12V234.13L250.02 234.12H250.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.11H250.01V234.12H250.02V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.09V234.1H250.03L250.02 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.08C250.04 234.08 250.04 234.08 250.04 234.09C250.04 234.09 250.04 234.08 250.05 234.07L250.04 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.15L250 234.16H250.01V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.15H250.01V234.16H250.02V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.15H250V234.16L250.01 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.15L250.01 234.14L250 234.15H250.01H250.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.16V234.17L250.01 234.16H250Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.16C250.02 234.16 250.02 234.16 250.01 234.17C250.01 234.17 250.01 234.17 250.02 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.14L250.02 234.15V234.14H250.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.13H250.01V234.14H250.02V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.14L250.02 234.15L250.03 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.14H250.02V234.15L250.03 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.13V234.14H250.03L250.02 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.1L250.02 234.11H250.03V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.13L250.03 234.12H250.02L250.01 234.13H250.02L250.03 234.14L250.04 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.11V234.12H250.03L250.02 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.13L250.03 234.12L250.04 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.12L250.04 234.13V234.12H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.11C250.06 234.11 250.05 234.11 250.04 234.11C250.04 234.11 250.04 234.12 250.04 234.13C250.04 234.13 250.04 234.13 250.05 234.12L250.06 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.12H250.04V234.13L250.05 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.14V234.13L250.03 234.14H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.11C250.06 234.11 250.06 234.11 250.05 234.12C250.05 234.12 250.05 234.12 250.06 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.12L250.04 234.13H250.05V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.1C250.06 234.1 250.05 234.09 250.04 234.08C250.04 234.08 250.04 234.09 250.03 234.1C250.03 234.1 250.03 234.1 250.04 234.1C250.04 234.1 250.05 234.1 250.06 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.08C250.05 234.08 250.06 234.09 250.07 234.1C250.07 234.1 250.06 234.09 250.05 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.1L250.06 234.11L250.07 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.09C250.07 234.09 250.07 234.09 250.07 234.08C250.07 234.08 250.07 234.08 250.06 234.08C250.06 234.08 250.07 234.09 250.08 234.1L250.07 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.07L250.09 234.08V234.07H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.07C250.08 234.07 250.08 234.07 250.07 234.07C250.07 234.07 250.07 234.07 250.08 234.07C250.08 234.07 250.08 234.07 250.08 234.06V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.08V234.09H250.08H250.09V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.09C250.08 234.09 250.08 234.09 250.07 234.08C250.07 234.08 250.07 234.08 250.07 234.09H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.09H250.07V234.1L250.08 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.09L250.07 234.1H250.08V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.07H250.09V234.08L250.1 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.08V234.07L250.09 234.08H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.06H250.2H250.21H250.22V234.05H250.21V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.07L250.18 234.08V234.07H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.07H250.17V234.06H250.16V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.07H250.18V234.06H250.17V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.1L250.17 234.09V234.08H250.16V234.09V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.08H250.18L250.17 234.07V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.07L250.15 234.08H250.16V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.08L250.17 234.07H250.16V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.08V234.07L250.16 234.08H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.08L250.16 234.07H250.15V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.07V234.06H250.15L250.16 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.07H250.16L250.15 234.06V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.11V234.1L250.13 234.09L250.12 234.1L250.13 234.11H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.1V234.09H250.13L250.14 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.1L250.13 234.11L250.12 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.1V234.11H250.15V234.1H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.11L250.12 234.1L250.13 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.11H250.13L250.12 234.1V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.1H250.15L250.14 234.09V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.1L250.14 234.09L250.15 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.09V234.08L250.15 234.09H250.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.09V234.1H250.16V234.09H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.08C250.16 234.08 250.15 234.08 250.14 234.09C250.14 234.09 250.15 234.09 250.16 234.09V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.09C250.14 234.09 250.15 234.09 250.16 234.08C250.16 234.08 250.16 234.08 250.16 234.09H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.07H250.2V234.06L250.19 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.07L250.2 234.06H250.19V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.06L250.19 234.07V234.06H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.07V234.08H250.19V234.07H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.07L250.18 234.06V234.07H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.09L250.18 234.08H250.17V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.11L250.11 234.12L250.12 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.1H250.12L250.13 234.09V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.09L250.13 234.08V234.09H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.09L250.13 234.08L250.14 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.07V234.06H250.14V234.07H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.16C250.02 234.16 250.02 234.16 250.01 234.17C250.01 234.17 250.02 234.17 250.03 234.17L250.02 234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.16H250.05L250.04 234.15V234.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.15L250.07 234.14H250.06L250.05 234.15H250.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.15L250.07 234.14L250.06 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.14H250.04L250.05 234.15V234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.14V234.15L250.06 234.14H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.15H250.04L250.05 234.16V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.14L250.07 234.13V234.14H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.13H250.07L250.08 234.14V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.13V234.14H250.09L250.08 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.14V234.13H250.06L250.05 234.14H250.06H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.13V234.12H250.07V234.13H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.14L250.04 234.13V234.14H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.13H250.05H250.04L250.05 234.14L250.06 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.11C250.08 234.11 250.08 234.11 250.07 234.11C250.07 234.11 250.07 234.11 250.06 234.12C250.06 234.12 250.07 234.12 250.08 234.12V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.12V234.11L250.07 234.12H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.11L250.07 234.1L250.06 234.11H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.11V234.1H250.07L250.08 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.12L250.08 234.13H250.09V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.13L250.09 234.14V234.13H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.12V234.13L250.09 234.12H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.12L250.08 234.11V234.12H250.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.1H250.07H250.08V234.11V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.08L250.1 234.07V234.08H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.08L250.1 234.07L250.11 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.08V234.07H250.1L250.11 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.08H250.1V234.09L250.11 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.09V234.08H250.09L250.1 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.08L250.1 234.09H250.11V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.08L250.1 234.09L250.09 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.09V234.1L250.11 234.09H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.12H250.09V234.13L250.1 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.09L250.09 234.08V234.09H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.08H250.13L250.12 234.07H250.11V234.08H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.09L250.12 234.08L250.13 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.08L250.13 234.09V234.08H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.1C250.12 234.1 250.12 234.09 250.12 234.08C250.12 234.08 250.12 234.09 250.13 234.1H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.08C250.11 234.08 250.11 234.08 250.12 234.08C250.12 234.08 250.12 234.07 250.11 234.06V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.09L250.1 234.1H250.11V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.12V234.13H250.11V234.12H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.12V234.11L250.1 234.12H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.11V234.1L250.11 234.11V234.12L250.12 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.11H250.1V234.12L250.11 234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.1V234.11L250.12 234.1H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.1H250.1V234.11H250.11V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.08V234.07H250.12L250.13 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.07L250.13 234.08L250.14 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.06L250.13 234.07H250.14V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.13H250.1V234.12L250.09 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.06L250.25 234.05L250.24 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.06L250.25 234.05H250.24H250.23L250.24 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.05L250.23 234.06H250.24L250.23 234.05H250.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.06H250.23V234.07L250.24 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.06H250.23L250.22 234.05V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.07H250.23V234.06H250.22V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.06V234.07H250.21H250.22V234.06H250.21H250.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.08H250.21V234.07H250.2V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.1L250.17 234.09L250.16 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.08V234.09L250.2 234.08L250.19 234.07V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.07L250.2 234.08V234.07H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.08V234.09H250.19V234.08H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.08V234.09H250.19H250.18V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.09H250.18V234.08L250.17 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.57 233.91C250.63 233.91 250.69 233.89 250.75 233.88C250.78 233.88 250.81 233.86 250.84 233.85C250.92 233.81 250.99 233.78 251.07 233.74C250.91 233.79 250.75 233.84 250.59 233.89C250.59 233.89 250.58 233.89 250.57 233.9V233.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45 234.03C250.45 234.03 250.5 234.01 250.53 234.01C250.49 234.01 250.45 234.02 250.42 234.03C250.43 234.03 250.44 234.03 250.46 234.03H250.45Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85 233.86C250.85 233.86 250.79 233.88 250.76 233.89C250.78 233.89 250.79 233.89 250.81 233.89C250.82 233.89 250.84 233.88 250.85 233.87V233.86Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 234.05C250.37 234.05 250.37 234.05 250.38 234.05L250.44 234.03C250.44 234.03 250.42 234.03 250.4 234.03C250.39 234.03 250.38 234.05 250.36 234.06L250.37 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.12V234.13H250.12L250.11 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.11C250.13 234.11 250.12 234.11 250.11 234.11C250.11 234.11 250.12 234.11 250.13 234.1V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.13H250.1V234.14L250.11 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.13L250.09 234.14H250.1V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.15L250.09 234.14H250.08V234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.13H250.09V234.14L250.1 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.57 233.91C250.57 233.91 250.58 233.91 250.59 233.9C250.57 233.9 250.54 233.91 250.52 233.92C250.54 233.92 250.55 233.92 250.57 233.92V233.91Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37 234.05C250.37 234.05 250.39 234.03 250.41 234.02C250.37 234.02 250.34 234.03 250.3 234.04C250.33 234.04 250.36 234.04 250.38 234.04L250.37 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.06C250.28 234.06 250.33 234.06 250.35 234.06C250.35 234.06 250.35 234.06 250.36 234.06C250.33 234.06 250.3 234.06 250.28 234.06C250.28 234.06 250.28 234.06 250.28 234.07V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.08C250.3 234.08 250.34 234.07 250.35 234.06C250.33 234.06 250.3 234.06 250.28 234.06C250.28 234.06 250.29 234.06 250.3 234.06V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.08H250.29C250.29 234.08 250.28 234.08 250.27 234.08C250.27 234.08 250.27 234.08 250.27 234.09V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.09H250.28L250.27 234.08V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.06H250.29C250.29 234.06 250.29 234.06 250.29 234.05H250.27V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.08C250.27 234.08 250.27 234.08 250.27 234.07C250.27 234.07 250.27 234.07 250.26 234.07C250.26 234.07 250.26 234.07 250.26 234.08H250.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.09H250.27V234.08H250.26V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.09H250.26V234.08H250.25V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.08H250.24L250.25 234.09V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.05V234.06H250.26H250.27V234.05H250.26H250.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.07H250.26V234.06H250.25V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.08V234.07H250.25L250.26 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.05L250.24 234.06H250.25V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.07C250.23 234.07 250.23 234.07 250.23 234.08C250.23 234.08 250.23 234.08 250.24 234.08C250.24 234.08 250.24 234.08 250.23 234.08V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.09L250.24 234.08L250.25 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.08C250.23 234.08 250.23 234.08 250.24 234.08C250.24 234.08 250.24 234.08 250.24 234.07L250.23 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.08C250.23 234.08 250.23 234.09 250.23 234.1C250.23 234.1 250.23 234.1 250.22 234.1L250.23 234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.09C250.21 234.09 250.22 234.09 250.23 234.09C250.23 234.09 250.23 234.08 250.23 234.07C250.23 234.07 250.23 234.07 250.22 234.08L250.21 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.1V234.11H250.21L250.2 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.06L250.25 234.05L250.24 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.07L250.24 234.06L250.23 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.07L250.24 234.06L250.23 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234.08V234.07L250.22 234.08H250.23Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.07L250.22 234.08L250.23 234.07H250.22H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.09C250.21 234.09 250.21 234.09 250.22 234.08C250.22 234.08 250.22 234.08 250.21 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.1L250.21 234.09L250.2 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.09C250.2 234.09 250.2 234.09 250.21 234.09C250.21 234.09 250.21 234.09 250.22 234.08C250.22 234.08 250.22 234.08 250.21 234.08L250.2 234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.1H250.2L250.21 234.09H250.2L250.19 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.11L250.2 234.1H250.19V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.12V234.11H250.16L250.17 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.11H250.17L250.16 234.1V234.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.1L250.17 234.11V234.09L250.16 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.13L250.1 234.14H250.11V234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.13V234.14L250.12 234.13H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.12L250.14 234.11H250.13V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.12C250.13 234.12 250.12 234.12 250.11 234.13C250.11 234.13 250.11 234.13 250.11 234.12H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.12H250.14V234.11L250.13 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.12H250.14V234.13L250.15 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.13H250.14V234.12L250.13 234.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.11C250.15 234.11 250.15 234.12 250.15 234.13C250.15 234.13 250.15 234.12 250.14 234.11H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.12H250.17L250.16 234.11V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.12L250.16 234.11L250.17 234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.12C250.16 234.12 250.16 234.12 250.15 234.12C250.15 234.12 250.15 234.13 250.16 234.14V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.09V234.08L250.19 234.09H250.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.09V234.1L250.2 234.09H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.12H250.18V234.11H250.17V234.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.14L250.11 234.13L250.1 234.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.07 234.15C246.29 234.58 243.54 235 240.84 235.42C243.69 235.01 246.6 234.58 249.55 234.15C249.39 234.15 249.23 234.15 249.07 234.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.84 235.42C225.86 237.6 212.24 239.58 200.43 241.3C199.87 241.38 199.32 241.47 198.77 241.55C211.28 239.75 223.38 238 234.92 236.34C236.87 236.04 238.84 235.73 240.84 235.42Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.77 234.04C249.77 234.04 249.73 234.04 249.71 234.04C249.74 234.04 249.77 234.04 249.8 234.04C249.79 234.04 249.78 234.04 249.77 234.03V234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.27 231.14C281.01 229.49 290.91 227.98 299.79 226.62C314.33 224.46 326.11 222.72 334.28 221.5C338.33 220.93 341.49 220.48 343.67 220.18C344.72 220.04 345.53 219.94 346.12 219.86C346.67 219.79 346.96 219.77 346.96 219.79C346.96 219.81 346.68 219.87 346.14 219.96C345.56 220.06 344.76 220.19 343.71 220.37C341.54 220.71 338.4 221.2 334.37 221.83C370.79 216.54 403.44 211.75 428.09 207.99C442.64 205.78 454.41 203.93 462.54 202.6C466.6 201.93 469.75 201.39 471.88 201C474.01 200.61 475.13 200.36 475.11 200.28C475.1 200.2 473.96 200.29 471.81 200.54C469.65 200.79 466.48 201.2 462.4 201.75C454.24 202.86 442.45 204.55 427.88 206.7C398.76 211 358.56 217.18 314.19 224.07C291.85 227.52 270.58 230.81 251.24 233.8C251.06 233.86 250.87 233.92 250.69 233.98C257.02 233.06 263.56 232.11 270.27 231.13V231.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.81 234.05C249.81 234.05 249.79 234.05 249.78 234.04C249.78 234.04 249.77 234.04 249.76 234.04C249.77 234.04 249.78 234.04 249.79 234.05C249.79 234.05 249.79 234.05 249.8 234.05H249.81Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 233.97C250.34 233.97 250.36 233.96 250.37 233.95C250.37 233.95 250.36 233.96 250.35 233.97H250.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55 234C250.55 234 250.55 234 250.54 234C250.59 234 250.64 233.99 250.69 233.98C250.87 233.92 251.06 233.86 251.24 233.8C251.19 233.8 251.15 233.81 251.1 233.82C250.92 233.88 250.74 233.93 250.55 233.99V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.13 219.96C346.68 219.86 346.96 219.8 346.95 219.79C346.95 219.77 346.66 219.79 346.11 219.86C345.53 219.94 344.72 220.04 343.66 220.18C341.48 220.49 338.33 220.93 334.27 221.5C326.09 222.71 314.32 224.46 299.78 226.62C290.9 227.98 281 229.5 270.26 231.14C284.25 229.11 299.02 226.96 314.28 224.74C321.08 223.76 327.77 222.79 334.35 221.83C338.38 221.2 341.52 220.71 343.69 220.37C344.74 220.19 345.54 220.06 346.12 219.96H346.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58 247.96C155.53 248.14 154.73 248.27 154.15 248.37C153.6 248.47 153.32 248.53 153.33 248.54C153.33 248.56 153.62 248.54 154.17 248.47C154.75 248.39 155.56 248.29 156.62 248.15C158.8 247.84 161.95 247.39 166.01 246.81C174.18 245.59 185.95 243.83 200.49 241.65C210.7 240.07 222.28 238.28 234.92 236.33C223.38 237.99 211.28 239.74 198.77 241.54C185 243.61 173.8 245.29 165.95 246.48C161.91 247.12 158.76 247.61 156.59 247.96H156.58Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84 234.06C249.83 234.06 249.82 234.06 249.81 234.05C249.78 234.05 249.75 234.05 249.72 234.05C249.69 234.05 249.66 234.05 249.64 234.06C249.64 234.06 249.64 234.06 249.65 234.06C249.72 234.06 249.79 234.06 249.85 234.06H249.84Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38 234.1C249.28 234.12 249.18 234.13 249.08 234.15C249.25 234.15 249.42 234.15 249.6 234.15C249.61 234.15 249.62 234.15 249.63 234.15C249.55 234.14 249.46 234.12 249.38 234.11V234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84 234.06C249.77 234.06 249.7 234.06 249.64 234.06C249.72 234.07 249.81 234.09 249.89 234.1C249.89 234.1 249.9 234.1 249.91 234.1C249.89 234.09 249.86 234.08 249.84 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89 234.1C249.81 234.09 249.72 234.07 249.64 234.06C249.64 234.06 249.62 234.06 249.61 234.06C249.53 234.07 249.45 234.08 249.37 234.1C249.45 234.11 249.54 234.13 249.62 234.14C249.71 234.13 249.8 234.11 249.89 234.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8 234.05C249.8 234.05 249.82 234.05 249.83 234.06C249.83 234.06 249.82 234.06 249.81 234.05C249.81 234.05 249.81 234.05 249.8 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.81 234.03C249.81 234.03 249.8 234.03 249.79 234.03C249.79 234.03 249.81 234.03 249.82 234.04C249.84 234.04 249.85 234.04 249.87 234.04C249.85 234.04 249.83 234.03 249.82 234.02L249.81 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94 234.09C249.91 234.08 249.88 234.07 249.84 234.06C249.84 234.06 249.89 234.08 249.91 234.1C249.91 234.1 249.93 234.1 249.94 234.1V234.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 234.06C249.91 234.06 249.88 234.06 249.87 234.05C249.85 234.05 249.84 234.05 249.82 234.05C249.82 234.05 249.83 234.05 249.84 234.06C249.84 234.06 249.84 234.06 249.85 234.06C249.87 234.06 249.89 234.06 249.91 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.07C249.92 234.07 249.92 234.07 249.91 234.07C249.89 234.07 249.87 234.07 249.85 234.07C249.88 234.08 249.91 234.09 249.95 234.1C249.94 234.1 249.93 234.08 249.92 234.08V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86 234.05C249.86 234.05 249.88 234.05 249.89 234.05C249.88 234.05 249.87 234.03 249.86 234.03C249.84 234.03 249.83 234.03 249.81 234.03C249.83 234.03 249.85 234.04 249.86 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89 234.05C249.89 234.05 249.87 234.05 249.86 234.05C249.87 234.05 249.89 234.05 249.9 234.06C249.9 234.06 249.89 234.06 249.88 234.05H249.89Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 234.06L249.92 234.07L249.91 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.95 234.01C249.95 234.01 249.95 234.01 249.94 234.01C249.94 234.01 249.96 234.01 249.96 234.02C249.96 234.02 249.96 234.02 249.96 234.01H249.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.02C249.99 234.02 249.98 234.01 249.97 234H249.95C249.96 234 249.98 234 249.99 234.01V234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.05C250 234.05 250 234.04 249.99 234.03C249.98 234.03 249.96 234.03 249.95 234.02C249.95 234.02 249.95 234.02 249.95 234.03C249.96 234.03 249.98 234.04 249.99 234.05H250Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.01C249.98 234.01 249.99 234.02 250 234.03L249.98 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.02C249.99 234.02 249.99 234.03 250 234.04V234.02H249.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.03L249.99 234.02L250 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.03L249.99 234.02L250 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 234.07C249.92 234.07 249.94 234.09 249.95 234.09C249.95 234.09 249.96 234.09 249.97 234.09C249.95 234.09 249.94 234.08 249.92 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.04C249.97 234.04 249.9 234.03 249.86 234.02C249.87 234.02 249.88 234.04 249.89 234.04C249.92 234.04 249.94 234.04 249.97 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.06C249.98 234.06 249.98 234.06 249.98 234.05C249.95 234.05 249.93 234.05 249.9 234.05C249.9 234.05 249.91 234.05 249.92 234.06H249.99H249.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.07H249.92C249.94 234.07 249.95 234.08 249.97 234.09C249.97 234.09 249.98 234.09 249.99 234.08V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.05C250 234.05 249.98 234.05 249.97 234.05C249.97 234.05 249.97 234.05 249.97 234.06H249.99C249.99 234.06 249.99 234.06 249.99 234.05H250Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234.07C249.99 234.07 249.98 234.07 249.97 234.08C249.97 234.08 249.98 234.08 249.99 234.08V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.07C250.01 234.07 250.01 234.07 250.01 234.06C250.01 234.06 250.01 234.06 250 234.06L250.01 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.07L250 234.08V234.09L250.01 234.08V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.97 234.04C249.97 234.04 249.97 234.03 249.96 234.02C249.96 234.02 249.94 234.02 249.94 234.01C249.92 234.01 249.89 234.01 249.87 234.02C249.91 234.02 249.94 234.03 249.98 234.04H249.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 234.02C249.96 234.02 249.96 234.03 249.97 234.04C249.98 234.04 249.99 234.04 250 234.04C249.99 234.04 249.97 234.03 249.96 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99 234L250 234.01L249.99 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.01L249.99 234.02L249.98 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 234.01V234L249.97 234.01H249.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.06L250.02 234.05V234.06H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.05L249.99 234.03V234.04C249.99 234.04 249.99 234.04 250 234.04L250.01 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.03L250.02 234.05C250.02 234.05 250.01 234.04 250 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.06C250.02 234.06 250.02 234.06 250.01 234.06C250.01 234.06 250.01 234.06 250.01 234.07C250.01 234.07 250.01 234.07 250.02 234.07V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.07V234.06H250L250.01 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.06H250.01V234.07H250.02V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234.08L250.02 234.07H250.01V234.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.07L250.01 234.08H250.02V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.06L250.04 234.07L250.03 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.01 234C250.01 234 250.01 234 250 234C250 234 250.02 234 250.03 234C250.03 234 250.03 234 250.02 233.99L250.01 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.01V233.99C250.03 233.99 250.02 233.99 250.01 233.99C250.01 233.99 250.01 233.99 250.02 234L250.03 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.02V234C250.05 234 250.04 234 250.03 234V234.02C250.03 234.02 250.04 234.02 250.05 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.01C250.03 234.01 250.01 234.01 250 234.01C250 234.01 250.02 234.03 250.03 234.04C250.03 234.04 250.03 234.03 250.03 234.02V234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.04L250.04 234.05V234.04H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.04C250.03 234.04 250.03 234.04 250.04 234.04C250.04 234.04 250.02 234.03 250.01 234.02C250.01 234.02 250.01 234.03 250.01 234.04H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.02C250.05 234.02 250.04 234.02 250.03 234.02C250.03 234.02 250.05 234.03 250.06 234.04L250.05 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.05L250.04 234.04V234.05H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.05V234.04H250.04L250.05 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.04L250.06 234.05L250.05 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.05L250.05 234.04V234.05H250.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.05H250.02L250.03 234.06L250.04 234.05H250.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.03C250.02 234.03 250 234.03 249.99 234.02H250.01L250.02 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.05C250.02 234.05 250.02 234.05 250.02 234.04H250C250 234.04 250.01 234.05 250.02 234.06V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.03C250.02 234.03 250 234.02 249.99 234.01C249.99 234.01 250.01 234.01 250.02 234.02V234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.04L250.02 234.03L250.03 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.05C250.03 234.05 250.03 234.05 250.02 234.05C250.02 234.05 250.02 234.05 250.02 234.06C250.02 234.06 250.02 234.06 250.03 234.06V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.02 234.03L250.03 234.04L250.02 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 234.06L250.04 234.07L250.03 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.03C250.07 234.03 250.07 234.02 250.07 234.01C250.07 234.01 250.07 234.01 250.06 234C250.06 234 250.05 234 250.04 234C250.04 234.01 250.05 234.02 250.06 234.03H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234V234.02C250.04 234.02 250.06 234.02 250.07 234.02C250.07 234.01 250.06 234 250.05 233.99L250.04 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.03V234.04H250.06L250.05 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.04C250.06 234.04 250.05 234.04 250.04 234.04V234.06L250.06 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.05V234.04H250.05L250.06 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.01V233.99C250.08 233.99 250.08 233.99 250.07 233.99C250.07 233.99 250.07 233.99 250.07 234L250.08 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 233.99C250.07 233.99 250.07 233.99 250.08 234C250.08 234 250.08 234 250.08 233.99H250.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234V233.99H250.08L250.09 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234L250.08 233.99V234V234.01L250.09 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.03H250.06V234.04L250.07 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 233.99H250.09V234L250.1 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.07L250.03 234.08L250.04 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.07V234.06L250.04 234.07H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.99V233.98L250.18 233.99H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.99C250.19 233.99 250.2 233.98 250.21 233.97C250.21 233.97 250.21 233.97 250.2 233.97C250.2 233.97 250.2 233.97 250.2 233.98L250.19 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.97C250.21 233.97 250.2 233.98 250.19 233.99C250.19 233.99 250.2 233.98 250.21 233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.05L250.06 234.06V234.05H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.02L250.07 234.03L250.08 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.03V234.02L250.07 234.03H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.03V234.02H250.08L250.09 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.03L250.08 234.02V234.03H250.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.03C250.08 234.03 250.08 234.04 250.09 234.05C250.09 234.05 250.09 234.04 250.09 234.03H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.05C250.07 234.05 250.07 234.04 250.06 234.03C250.06 234.03 250.06 234.03 250.07 234.03V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06 234.05L250.07 234.06L250.06 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.05H250.08L250.09 234.06V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.05V234.06H250.09L250.08 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.06L250.08 234.05L250.09 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.06L250.08 234.05L250.09 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07 234.06H250.06V234.07H250.07V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 233.99L250.14 233.98H250.13V233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 233.99V233.98H250.12L250.13 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 233.98L250.13 233.99H250.14V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 233.99L250.14 234V233.99H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234L250.13 233.99V234H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.03L250.1 234.04L250.09 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.05L250.1 234.04V234.05H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.06L250.1 234.05H250.09V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.06L250.11 234.05H250.1V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.05L250.09 234.06H250.1V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.02V234.01L250.09 234.02H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.04L250.11 234.03L250.1 234.02H250.09V234.03L250.1 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.04V234.03L250.1 234.04H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.05H250.12L250.11 234.04V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.05V234.04H250.1L250.11 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.99L250.11 234H250.12V233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.98H250.11L250.12 233.99V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.01L250.11 234L250.12 233.99L250.11 233.98L250.1 233.99L250.09 234L250.1 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 233.99H250.13L250.12 233.98V233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.01V234L250.1 234.01H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234C250.11 234 250.11 234 250.11 234.01C250.11 234.01 250.12 234.01 250.13 234.01L250.11 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.03C250.13 234.03 250.13 234.02 250.13 234.01C250.13 234.01 250.12 234.01 250.11 234.01C250.11 234.01 250.11 234.01 250.12 234.02L250.13 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.01L250.09 234L250.1 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.01L250.09 234L250.1 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.02L250.11 234.01H250.1V234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.03V234.02V234.01L250.1 234.02L250.11 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.03C250.13 234.03 250.13 234.03 250.12 234.02C250.12 234.02 250.12 234.02 250.13 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.04C250.12 234.04 250.12 234.04 250.11 234.03C250.11 234.03 250.11 234.03 250.11 234.04H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.05V234.04H250.11L250.12 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.98L250.19 233.97H250.18V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.98V233.97H250.17L250.18 233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.99L250.19 233.98V233.97L250.18 233.98V233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 233.98H250.18L250.17 233.97L250.16 233.98H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.99V233.98H250.17V233.99H250.18Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 233.99H250.17L250.18 234V233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 233.98L250.16 233.99L250.17 233.98H250.16H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 233.99L250.15 233.98V233.99H250.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 233.99V233.98L250.16 233.99H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 233.99H250.14V234L250.15 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 233.99C250.16 233.99 250.16 233.99 250.17 233.99C250.17 233.99 250.17 233.99 250.17 233.98L250.16 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.01C250.16 234.01 250.16 234.01 250.15 234.01C250.15 234.01 250.16 234.01 250.17 234.02L250.16 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.03L250.16 234.01C250.16 234.01 250.15 234.01 250.14 234C250.14 234 250.14 234 250.14 234.01C250.14 234.01 250.14 234.02 250.14 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.01C250.16 234.01 250.16 234.01 250.17 234C250.17 234 250.17 234 250.17 233.99C250.17 233.99 250.17 234 250.17 234.01H250.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.02L250.14 234.04C250.14 234.04 250.15 234.03 250.16 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234L250.17 234.01L250.18 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.02L250.17 234.01H250.16V234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.04H250.14L250.13 234.03V234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.05V234.04V234.03L250.12 234.04L250.13 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.05H250.13L250.12 234.04V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 233.97C250.34 233.97 250.35 233.96 250.36 233.95C250.35 233.96 250.33 233.98 250.32 233.99C250.32 233.99 250.34 233.98 250.35 233.97H250.34Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 233.99C250.3 233.99 250.3 233.99 250.31 233.99C250.32 233.98 250.34 233.96 250.35 233.95H250.33C250.33 233.95 250.32 233.95 250.31 233.96C250.31 233.97 250.3 233.98 250.29 233.99H250.3Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 233.99C250.3 233.99 250.31 233.97 250.32 233.96C250.31 233.96 250.29 233.98 250.28 233.99C250.28 233.99 250.28 233.99 250.28 234H250.3V233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 233.95C250.33 233.95 250.33 233.95 250.32 233.95C250.32 233.95 250.33 233.95 250.34 233.94L250.33 233.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 233.99C250.28 233.99 250.31 233.97 250.32 233.96C250.31 233.96 250.29 233.96 250.28 233.96C250.28 233.97 250.28 233.98 250.28 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234C250.27 234 250.27 234 250.28 234C250.28 234 250.28 234 250.28 233.99C250.28 233.99 250.27 233.99 250.26 234H250.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.97C250.24 233.97 250.24 233.97 250.24 233.98C250.24 233.98 250.24 233.98 250.25 233.97C250.25 233.97 250.25 233.97 250.24 233.97Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 233.98C250.24 233.98 250.24 233.98 250.24 233.97C250.24 233.97 250.24 233.99 250.24 234C250.24 234 250.24 234 250.25 233.99L250.24 233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234C250.24 234 250.25 234 250.26 234C250.26 234 250.27 234 250.28 233.99C250.28 233.98 250.28 233.97 250.28 233.96C250.27 233.96 250.26 233.96 250.25 233.96C250.25 233.96 250.25 233.96 250.24 233.97C250.24 233.97 250.24 233.98 250.24 233.99V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234C250.23 234 250.24 234 250.25 234C250.25 234 250.25 233.99 250.25 233.98C250.25 233.98 250.25 233.98 250.24 233.99L250.23 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.01C250.25 234.01 250.24 234.01 250.23 234.01C250.23 234.01 250.23 234.01 250.23 234.02L250.25 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.02H250.24C250.24 234.02 250.24 234.02 250.24 234.01C250.24 234.01 250.23 234.01 250.22 234.01C250.22 234.01 250.22 234.02 250.22 234.03V234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23 234C250.23 234 250.23 233.98 250.23 233.97C250.23 233.97 250.22 233.99 250.21 234C250.21 234 250.22 234 250.23 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234L250.19 234.01L250.2 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234C250.2 234 250.2 234 250.2 234.01C250.2 234.01 250.21 233.99 250.22 233.98C250.22 233.98 250.21 233.98 250.2 233.98V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.02C250.22 234.02 250.22 234.01 250.22 234C250.22 234 250.21 234.02 250.2 234.03C250.2 234.03 250.2 234.03 250.21 234.03L250.22 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.02H250.2L250.19 234.01V234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.03L250.2 234.02H250.19V234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234V233.99H250.18L250.19 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234L250.18 233.99V234L250.19 234.01V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.01L250.18 234.02L250.17 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.99C250.21 233.99 250.21 233.97 250.22 233.96V233.98L250.21 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 233.99C250.19 233.99 250.19 233.99 250.2 233.99V233.97C250.2 233.97 250.19 233.98 250.18 233.99H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.99C250.21 233.99 250.22 233.97 250.23 233.96C250.23 233.96 250.23 233.98 250.22 233.99H250.21Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234L250.21 233.99H250.2V234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 233.99L250.2 234L250.21 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.04C250.14 234.04 250.14 234.04 250.15 234.04C250.15 234.04 250.15 234.04 250.15 234.03C250.15 234.03 250.14 234.04 250.13 234.05L250.14 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234L250.17 234.01L250.18 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.02V234.01L250.16 234.02V234.03L250.17 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.04V234.05L250.14 234.04H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.51 233.93H250.45C250.45 233.93 250.41 233.96 250.39 233.97C250.43 233.96 250.46 233.95 250.5 233.94L250.51 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35 233.98L250.4 233.96L250.46 233.93C250.46 233.93 250.4 233.93 250.37 233.94C250.37 233.95 250.35 233.96 250.35 233.97V233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 233.99H250.34C250.34 233.98 250.36 233.97 250.36 233.96C250.36 233.96 250.34 233.97 250.33 233.98C250.33 233.98 250.32 233.99 250.31 234L250.32 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 233.99C250.31 233.99 250.32 233.98 250.33 233.97C250.33 233.97 250.31 233.98 250.3 233.99H250.31Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 233.98L250.31 233.99L250.32 233.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.1 233.83C251 233.85 250.9 233.86 250.8 233.88C250.72 233.92 250.63 233.96 250.55 234C250.73 233.94 250.91 233.89 251.1 233.83Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.04 234.08V234.07L250.03 234.08H250.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.08L250.04 234.07V234.08H250.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 234.07H250.04L250.05 234.08H250.06L250.05 234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.06L250.07 234.07H250.08V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 234.07L250.08 234.06V234.07H250.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 234.06L250.09 234.07V234.06H250.08Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.06H250.1L250.11 234.07V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.06V234.07H250.11L250.1 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.06H250.09L250.1 234.07V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.07L250.09 234.06V234.07H250.1Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.06V234.05L250.1 234.06H250.11Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 234.06L250.11 234.05L250.1 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.05H250.11V234.06L250.12 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.06V234.05L250.11 234.06H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.05V234.06L250.13 234.05H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.01C250.29 234.01 250.29 234.01 250.28 234.01C250.28 234.01 250.28 234.01 250.28 234.02C250.28 234.02 250.28 234.02 250.29 234.02V234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24 234.04H250.23V234.05L250.24 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.05H250.23V234.04L250.22 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.01C250.25 234.01 250.25 234.02 250.25 234.03C250.25 234.03 250.27 234.02 250.27 234.01C250.27 234.01 250.27 234.01 250.27 234C250.27 234 250.27 234 250.26 234L250.25 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.04C250.21 234.04 250.22 234.04 250.23 234.04C250.23 234.04 250.23 234.04 250.24 234.04C250.24 234.04 250.24 234.03 250.24 234.02C250.23 234.02 250.22 234.03 250.21 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.05L250.21 234.04L250.22 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.01H250.23C250.23 234.01 250.23 234.02 250.23 234.03C250.24 234.03 250.25 234.02 250.26 234.01H250.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22 234.05L250.21 234.04V234.05H250.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.05C250.18 234.05 250.18 234.05 250.18 234.06C250.18 234.06 250.18 234.06 250.19 234.06L250.18 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.06L250.16 234.05V234.06H250.17Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.05H250.16L250.17 234.06L250.18 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 234.06H250.18V234.05L250.17 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.02H250.2V234.03L250.21 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.03C250.2 234.03 250.2 234.02 250.2 234.01C250.2 234.01 250.2 234.01 250.19 234.01L250.2 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.04L250.2 234.03L250.21 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.04L250.2 234.03L250.21 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.05C250.21 234.05 250.2 234.05 250.19 234.06C250.19 234.06 250.2 234.06 250.21 234.06V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.03V234.02L250.19 234.03H250.2Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.04C250.19 234.04 250.19 234.04 250.2 234.03C250.2 234.03 250.2 234.03 250.2 234.04H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 234.03L250.21 234.04L250.2 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.05C250.19 234.05 250.2 234.05 250.21 234.04C250.21 234.04 250.21 234.04 250.2 234.05H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21 234.05L250.2 234.06H250.21V234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.03H250.18V234.04L250.19 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 234.06V234.05L250.18 234.06H250.19Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.06L250.19 234.05H250.18V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18 234.03H250.17V234.04L250.18 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16 234.06L250.15 234.05L250.16 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.06H250.16L250.15 234.05V234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11 234.07L250.12 234.06H250.11V234.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.05C250.15 234.05 250.15 234.05 250.15 234.04C250.15 234.04 250.15 234.04 250.14 234.04L250.15 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12 234.07V234.06L250.11 234.07H250.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13 234.07V234.06H250.12V234.07H250.13Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.05H250.14V234.04V234.05H250.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.14 234.05V234.04L250.13 234.05H250.14Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15 234.06V234.05H250.14L250.15 234.06Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 234.01C250.32 234.01 250.32 234.01 250.33 234.01C250.39 233.98 250.45 233.95 250.51 233.92C250.47 233.93 250.44 233.94 250.4 233.95C250.38 233.96 250.36 233.97 250.34 233.98C250.34 233.98 250.34 233.99 250.33 234L250.32 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 233.99C250.34 233.99 250.32 234 250.31 234.01C250.31 234.01 250.32 234.01 250.33 234.01C250.33 234.01 250.33 234 250.34 233.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.4 233.96L250.35 233.98C250.35 233.98 250.35 233.99 250.34 234C250.36 233.99 250.38 233.98 250.4 233.97V233.96Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234.01C250.31 234.01 250.32 234 250.33 233.99C250.33 233.99 250.33 233.99 250.34 233.97H250.32L250.3 233.99V234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 234.02H250.33V234.01H250.32V234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.02C250.29 234.02 250.3 234.02 250.32 234.01C250.32 234.01 250.31 234.01 250.3 234.01L250.28 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.03C250.28 234.03 250.28 234.03 250.27 234.04L250.28 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.04C250.27 234.04 250.3 234.03 250.31 234.02C250.3 234.02 250.29 234.02 250.27 234.03C250.27 234.03 250.27 234.03 250.27 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.05C250.27 234.05 250.27 234.05 250.26 234.06L250.27 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.01L250.31 233.99C250.31 233.99 250.3 234 250.29 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.01C250.29 234.01 250.3 234 250.31 233.99C250.31 233.99 250.31 233.99 250.3 233.99L250.29 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 234L250.29 234.01L250.3 234Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.01V234.02H250.28L250.29 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.03C250.27 234.03 250.27 234.03 250.28 234.02L250.27 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28 234.02H250.27V234.03L250.28 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.01V234.02V234.01H250.3H250.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.02V234.01L250.28 234.02H250.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29 234.01C250.29 234.01 250.29 234.01 250.28 234.01C250.28 234.01 250.28 234.01 250.29 234V234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.03L250.26 234.04L250.27 234.03Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.04C250.25 234.04 250.25 234.04 250.26 234.04C250.26 234.04 250.24 234.04 250.24 234.05L250.25 234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.04C250.25 234.04 250.27 234.04 250.27 234.03C250.27 234.03 250.25 234.04 250.25 234.05V234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25 234.05C250.25 234.05 250.25 234.05 250.26 234.04C250.26 234.04 250.26 234.04 250.25 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 234.04C250.26 234.04 250.26 234.04 250.25 234.04C250.25 234.04 250.25 234.04 250.26 234.03V234.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.76 233.88C250.7 233.88 250.64 233.9 250.58 233.91C250.56 233.93 250.53 233.94 250.51 233.96C250.6 233.93 250.68 233.91 250.77 233.88H250.76Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.03C250.41 234.03 250.49 234.02 250.52 234.01C250.52 234.01 250.54 234.01 250.55 234.01C250.63 233.97 250.72 233.93 250.8 233.89C250.78 233.89 250.77 233.89 250.75 233.89C250.66 233.92 250.58 233.94 250.49 233.97C250.46 233.99 250.43 234.01 250.4 234.03H250.41Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.51 233.93C250.45 233.96 250.39 233.99 250.33 234.02C250.39 234 250.44 233.99 250.5 233.97C250.52 233.95 250.55 233.94 250.57 233.92C250.55 233.92 250.54 233.92 250.52 233.92C250.52 233.92 250.51 233.92 250.5 233.92L250.51 233.93Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 234.03C250.41 234.03 250.47 233.99 250.5 233.97C250.44 233.99 250.39 234 250.33 234.02C250.35 234.02 250.38 234.02 250.4 234.03H250.41Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 234.01H250.33V234.02L250.34 234.01Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 234.02C250.31 234.02 250.31 234.03 250.3 234.04C250.34 234.04 250.37 234.03 250.41 234.02C250.39 234.02 250.36 234.02 250.34 234.01C250.34 234.01 250.34 234.01 250.33 234.01L250.31 234.02Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 234.05C250.27 234.05 250.29 234.05 250.3 234.05C250.3 234.05 250.3 234.04 250.31 234.03C250.3 234.03 250.28 234.04 250.27 234.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55 303.02C355.85 301.63 358.29 300.58 360.81 299.86L362.31 292.67L374.45 292.46L376.2 299.59C378.74 300.22 381.22 301.18 383.57 302.49L389.71 298.47L398.45 306.91L394.65 313.18C396.04 315.48 397.09 317.92 397.81 320.44L405 321.94L405.21 334.08L398.08 335.83C397.45 338.37 396.49 340.85 395.18 343.2L399.2 349.34L390.76 358.08L384.49 354.28C382.19 355.67 379.75 356.72 377.23 357.44L375.73 364.63L363.59 364.84L361.84 357.71C359.3 357.08 356.82 356.12 354.47 354.81L348.33 358.83L339.59 350.39L343.39 344.12C342 341.82 340.95 339.38 340.23 336.86L333.04 335.36L332.83 323.22L339.96 321.47C340.59 318.93 341.55 316.45 342.86 314.1L338.84 307.96L347.28 299.22L353.56 303.02H353.55ZM360.02 319.2C355.02 324.38 355.17 332.63 360.34 337.62C365.52 342.62 373.77 342.47 378.76 337.3C383.76 332.12 383.61 323.87 378.44 318.88C373.26 313.88 365.01 314.03 360.02 319.2Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.21 201.33C276.78 200.38 278.46 199.66 280.19 199.17L281.22 194.24L289.55 194.09L290.75 198.98C292.49 199.41 294.19 200.07 295.8 200.97L300.01 198.21L306 203.99L303.39 208.29C304.34 209.86 305.06 211.54 305.55 213.27L310.48 214.3L310.63 222.63L305.74 223.83C305.31 225.57 304.65 227.27 303.75 228.88L306.51 233.09L300.73 239.08L296.43 236.47C294.86 237.42 293.18 238.14 291.45 238.63L290.42 243.56L282.09 243.71L280.89 238.82C279.15 238.39 277.45 237.73 275.84 236.83L271.63 239.59L265.64 233.81L268.25 229.51C267.3 227.94 266.58 226.26 266.09 224.53L261.16 223.5L261.01 215.17L265.9 213.97C266.33 212.23 266.99 210.53 267.89 208.92L265.13 204.71L270.91 198.72L275.21 201.33ZM279.65 212.42C276.22 215.97 276.32 221.62 279.87 225.05C283.42 228.48 289.07 228.38 292.5 224.83C295.93 221.28 295.83 215.63 292.28 212.2C288.73 208.77 283.08 208.87 279.65 212.42Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7303 202.27C62.6403 201.72 63.6003 201.31 64.6003 201.02L65.1903 198.18L69.9903 198.1L70.6803 200.92C71.6803 201.17 72.6603 201.55 73.5903 202.06L76.0103 200.47L79.4603 203.8L77.9603 206.28C78.5103 207.19 78.9203 208.15 79.2103 209.15L82.0503 209.74L82.1303 214.54L79.3103 215.23C79.0603 216.24 78.6803 217.21 78.1703 218.14L79.7603 220.56L76.4303 224.01L73.9503 222.51C73.0403 223.06 72.0803 223.47 71.0803 223.76L70.4903 226.6L65.6903 226.68L65.0003 223.86C63.9903 223.61 63.0203 223.23 62.0903 222.71L59.6703 224.3L56.2203 220.97L57.7203 218.49C57.1703 217.58 56.7603 216.62 56.4703 215.62L53.6303 215.03L53.5503 210.23L56.3703 209.54C56.6203 208.53 57.0003 207.56 57.5103 206.63L55.9203 204.21L59.2503 200.76L61.7303 202.26V202.27ZM64.2903 208.66C62.3203 210.7 62.3703 213.96 64.4203 215.94C66.4603 217.91 69.7203 217.86 71.7003 215.81C73.6703 213.77 73.6203 210.51 71.5703 208.53C69.5303 206.56 66.2703 206.61 64.2903 208.66Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.8 161.36C425.71 160.81 426.67 160.4 427.67 160.11L428.26 157.27L433.06 157.19L433.75 160.01C434.76 160.26 435.73 160.64 436.66 161.15L439.08 159.56L442.53 162.89L441.03 165.37C441.58 166.28 441.99 167.24 442.28 168.24L445.12 168.83L445.2 173.63L442.38 174.32C442.13 175.33 441.75 176.3 441.24 177.23L442.83 179.65L439.5 183.1L437.02 181.6C436.11 182.15 435.15 182.56 434.15 182.85L433.56 185.69L428.76 185.77L428.07 182.95C427.06 182.7 426.09 182.32 425.16 181.8L422.74 183.39L419.29 180.06L420.79 177.58C420.24 176.67 419.83 175.71 419.54 174.71L416.7 174.12L416.62 169.32L419.44 168.63C419.69 167.62 420.07 166.65 420.58 165.72L418.99 163.3L422.32 159.85L424.8 161.35V161.36ZM427.36 167.74C425.39 169.78 425.44 173.04 427.49 175.02C429.53 176.99 432.79 176.94 434.77 174.89C436.74 172.85 436.69 169.59 434.64 167.61C432.6 165.64 429.34 165.69 427.36 167.74Z",
    fill: "#7B6AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.32 390.3C366.31 389.7 367.37 389.25 368.46 388.94L369.11 385.83L374.36 385.74L375.12 388.82C376.22 389.09 377.29 389.51 378.31 390.07L380.96 388.33L384.74 391.98L383.1 394.69C383.7 395.68 384.15 396.74 384.46 397.83L387.57 398.48L387.66 403.73L384.58 404.49C384.31 405.59 383.89 406.66 383.33 407.67L385.07 410.32L381.42 414.1L378.71 412.46C377.72 413.06 376.66 413.51 375.57 413.82L374.92 416.93L369.67 417.02L368.91 413.94C367.81 413.67 366.74 413.25 365.72 412.69L363.07 414.43L359.29 410.78L360.93 408.07C360.33 407.08 359.88 406.02 359.57 404.93L356.46 404.28L356.37 399.03L359.45 398.27C359.72 397.17 360.14 396.1 360.7 395.09L358.96 392.44L362.61 388.66L365.32 390.3ZM368.12 397.29C365.96 399.53 366.02 403.09 368.26 405.25C370.5 407.41 374.06 407.35 376.22 405.11C378.38 402.87 378.32 399.31 376.08 397.15C373.84 394.99 370.28 395.05 368.12 397.29Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3 370.45C104.26 369.27 106.34 368.37 108.49 367.76L109.77 361.63L120.13 361.45L121.62 367.53C123.79 368.06 125.91 368.89 127.9 370L133.13 366.57L140.58 373.77L137.34 379.12C138.52 381.08 139.42 383.16 140.03 385.31L146.16 386.59L146.34 396.95L140.26 398.44C139.73 400.61 138.9 402.72 137.79 404.72L141.22 409.95L134.03 417.4L128.68 414.16C126.72 415.34 124.64 416.24 122.49 416.85L121.21 422.98L110.85 423.16L109.36 417.08C107.19 416.55 105.08 415.72 103.08 414.61L97.8501 418.04L90.4001 410.85L93.6401 405.5C92.4601 403.54 91.5601 401.46 90.9501 399.31L84.8201 398.03L84.6401 387.67L90.7201 386.18C91.2501 384.01 92.0801 381.9 93.1901 379.9L89.7601 374.67L96.9501 367.22L102.3 370.46V370.45ZM107.82 384.24C103.56 388.66 103.68 395.69 108.1 399.95C112.51 404.21 119.55 404.09 123.81 399.67C128.07 395.25 127.95 388.22 123.53 383.96C119.11 379.7 112.08 379.82 107.82 384.24Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78 117.94C168.35 116.99 170.03 116.27 171.76 115.78L172.79 110.85L181.12 110.7L182.32 115.59C184.06 116.02 185.76 116.68 187.37 117.58L191.58 114.82L197.57 120.6L194.96 124.9C195.91 126.47 196.63 128.15 197.12 129.88L202.05 130.91L202.2 139.24L197.31 140.44C196.88 142.18 196.22 143.88 195.32 145.49L198.08 149.7L192.3 155.69L188 153.08C186.43 154.03 184.75 154.75 183.02 155.24L181.99 160.17L173.66 160.32L172.46 155.43C170.72 155 169.02 154.34 167.41 153.44L163.2 156.2L157.21 150.42L159.82 146.12C158.87 144.55 158.15 142.87 157.66 141.14L152.73 140.11L152.58 131.78L157.47 130.58C157.9 128.84 158.56 127.14 159.46 125.53L156.7 121.32L162.48 115.33L166.78 117.94ZM171.22 129.03C167.79 132.58 167.89 138.23 171.44 141.66C174.99 145.09 180.64 144.99 184.07 141.44C187.5 137.89 187.4 132.24 183.85 128.81C180.3 125.38 174.65 125.48 171.22 129.03Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39 286.19C300.39 289.14 298 291.53 295.05 291.53C292.1 291.53 289.71 289.14 289.71 286.19C289.71 283.24 292.1 280.85 295.05 280.85C298 280.85 300.39 283.24 300.39 286.19Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.434 92.5933L419.758 140.889C419.504 142.729 418.357 144.003 417.091 143.959L412.815 143.814C413.046 143.814 413.275 143.77 413.495 143.685C413.604 143.643 413.71 143.591 413.813 143.53L413.918 143.467C413.986 143.422 414.052 143.373 414.116 143.32L414.214 143.238C414.278 143.181 414.339 143.12 414.398 143.055C414.427 143.025 414.458 142.992 414.486 142.958C414.697 142.713 414.876 142.432 415.019 142.123C415.062 142.032 415.102 141.939 415.138 141.843C415.195 141.697 415.244 141.547 415.286 141.394C415.313 141.29 415.34 141.183 415.361 141.074C415.382 140.964 415.402 140.855 415.418 140.742L422.073 92.5893L422.091 92.4521L425.712 92.5754L426.434 92.5933Z",
    fill: "#C4C5CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.147 92.4459L422.129 92.583L415.474 140.736C415.458 140.849 415.44 140.96 415.417 141.067C415.394 141.175 415.369 141.284 415.341 141.387C415.3 141.541 415.25 141.691 415.194 141.837C415.158 141.932 415.118 142.026 415.074 142.117C414.93 142.424 414.751 142.705 414.542 142.952C414.514 142.985 414.483 143.019 414.453 143.049C414.395 143.114 414.334 143.175 414.27 143.232L414.171 143.313C414.108 143.366 414.041 143.416 413.973 143.46L413.868 143.524C413.766 143.585 413.66 143.637 413.551 143.679C413.331 143.764 413.101 143.807 412.871 143.808H412.807C412.663 143.803 412.52 143.782 412.379 143.745L358.979 129.327C357.552 128.942 356.625 126.972 356.906 124.927L364.77 68.0854L363.591 76.6316C363.582 76.6727 363.586 76.7165 363.603 76.7536C363.62 76.7908 363.649 76.8183 363.683 76.8303L422.011 92.5791C422.022 92.581 422.033 92.581 422.044 92.5791C422.063 92.5762 422.081 92.5665 422.096 92.5512L422.111 92.5353C422.12 92.5247 422.127 92.5119 422.132 92.4975C422.139 92.4812 422.144 92.4638 422.147 92.4459Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.082 65.629L367.92 64.2378L372.262 64.3869L373.071 64.6055C373.064 64.9493 373.069 65.2912 373.082 65.629Z",
    fill: "#CC2944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.244 74.8528L383.459 68.4313L382.853 68.2683L381.462 67.8926L374.499 66.0105C374.478 65.6726 374.467 65.3288 374.464 64.979L381.796 66.9565L383.169 67.3282L407.243 73.8272C407.23 74.175 407.233 74.5149 407.244 74.8528Z",
    fill: "#CC2944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66 78.7997L421.318 78.6527L417.037 77.4959L415.65 77.1223L411.801 76.0829L408.659 75.2342C408.636 74.8963 408.626 74.5505 408.626 74.2007L415.974 76.1882L417.345 76.5598L425.66 78.7997Z",
    fill: "#CC2944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73 83.2008L426.433 92.5936L425.712 92.5698L422.091 92.4465L422.206 91.6217L423.391 83.0518L427.73 83.2008Z",
    fill: "#CC2944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73 83.2001L423.39 83.0511C423.672 81.008 422.745 79.0384 421.318 78.6528L425.659 78.7999C427.09 79.1855 428.014 81.155 427.73 83.2001Z",
    fill: "#DD3A51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.146 92.0465C421.124 98.5336 419.927 103.733 419.148 107.151C417.018 116.548 415.482 120.44 414.058 128.594C413.403 132.331 413.008 135.63 412.759 138.249C412.72 138.659 412.61 139.054 412.437 139.409C412.264 139.764 412.031 140.071 411.754 140.31C411.477 140.549 411.162 140.714 410.828 140.796C410.495 140.878 410.151 140.873 409.82 140.783L356.378 126.394C355.791 126.236 355.273 125.819 354.924 125.223C354.575 124.628 354.421 123.898 354.491 123.172C354.679 121.211 354.955 118.8 355.356 116.091C356.678 107.169 358.305 102.254 360.222 93.8094C361.161 89.6835 362.475 83.6733 363.59 76.1587C374.136 78.8219 384.7 81.5467 422.146 92.0465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.391 83.051L422.207 91.621L422.092 92.4458C422.089 92.4644 422.084 92.4825 422.077 92.4995C422.072 92.5138 422.065 92.5267 422.056 92.5372L422.041 92.5531C422.026 92.5684 422.008 92.5781 421.989 92.581C421.978 92.583 421.967 92.583 421.956 92.581L406.939 88.5245L380.711 81.4432L363.619 76.8283C363.586 76.8163 363.557 76.7887 363.54 76.7516C363.523 76.7144 363.518 76.6706 363.528 76.6295L364.707 68.0834L364.825 67.2308C365.081 65.3924 366.228 64.1204 367.492 64.1621C367.523 64.1601 367.555 64.1601 367.586 64.1621H367.619C367.649 64.164 367.679 64.168 367.709 64.174C367.739 64.1774 367.77 64.1827 367.8 64.1899L367.923 64.2177L373.086 65.609C373.123 66.9756 373.345 68.3257 373.741 69.6058C374.269 71.2415 375.052 72.428 376.02 73.06C375.961 73.9464 376.348 74.7255 376.931 74.8587C377.514 74.9918 378.135 74.4075 378.328 73.5251C378.34 73.4694 378.35 73.4118 378.36 73.3522C378.404 73.0948 378.406 72.8293 378.365 72.571C378.324 72.3128 378.242 72.0669 378.122 71.8477C378.047 71.7121 377.95 71.5959 377.838 71.5058C377.725 71.4158 377.599 71.3536 377.467 71.323C377.326 71.2946 377.183 71.3013 377.045 71.3427C376.907 71.384 376.777 71.4592 376.664 71.5635C375.997 71.1183 375.43 70.2338 375.025 68.9897C374.726 68.0271 374.543 67.0169 374.482 65.9906L381.449 67.8727L382.84 68.2483L383.447 68.4113L407.232 74.8329C407.268 76.2187 407.492 77.5879 407.896 78.8853C408.423 80.523 409.206 81.7075 410.175 82.3395C410.114 83.224 410.502 84.007 411.087 84.1402C411.672 84.2733 412.29 83.689 412.483 82.8066C412.496 82.7509 412.506 82.6933 412.516 82.6337C412.56 82.3763 412.562 82.1108 412.521 81.8525C412.48 81.5943 412.398 81.3484 412.278 81.1292C412.032 81.187 411.779 81.1924 411.531 81.1451C411.283 81.0956 411.043 80.994 410.823 80.845C410.157 80.3978 409.591 79.5134 409.185 78.2712C408.88 77.2905 408.695 76.2605 408.638 75.2144L411.78 76.0631L415.629 77.1025L417.016 77.4762L421.297 78.6329C422.746 79.0383 423.673 81.0079 423.391 83.051Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.529 82.6539C412.519 82.7135 412.51 82.7711 412.497 82.8268C412.303 83.7092 411.7 84.2975 411.101 84.1604C410.501 84.0232 410.127 83.2441 410.188 82.3597C409.225 81.7277 408.437 80.5432 407.909 78.9055C407.506 77.6081 407.282 76.2389 407.246 74.853L408.659 75.2347C408.717 76.2807 408.901 77.3107 409.207 78.2914C409.606 79.5335 410.172 80.418 410.845 80.8651C411.065 81.0142 411.304 81.1157 411.553 81.1652C411.801 81.2126 412.054 81.2072 412.3 81.1494C412.418 81.3693 412.499 81.6155 412.539 81.8738C412.578 82.132 412.575 82.3971 412.529 82.6539Z",
    fill: "#7B6AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.124 71.8676C377.878 71.9264 377.626 71.9318 377.378 71.8835C377.13 71.8343 376.891 71.7328 376.672 71.5834C376.786 71.4791 376.915 71.4039 377.053 71.3626C377.191 71.3212 377.335 71.3146 377.475 71.3429C377.74 71.4068 377.973 71.5954 378.124 71.8676Z",
    fill: "#7B6AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.33 73.5452C378.136 74.4276 377.533 75.0159 376.932 74.8788C376.331 74.7416 375.962 73.9665 376.021 73.0801C376.374 73.3159 376.759 73.476 377.157 73.5531C377.344 73.5888 377.534 73.6067 377.724 73.6067C377.927 73.606 378.129 73.5854 378.33 73.5452Z",
    fill: "#7B6AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.971 73.5968C417.838 74.6046 417.628 75.5952 417.345 76.5562L415.974 76.1845C416.259 75.2601 416.467 74.3033 416.595 73.3285C417.217 68.6639 415.954 64.3849 413.839 63.9596C413.727 63.9382 413.614 63.9275 413.501 63.9278C411.483 63.9278 409.378 67.38 408.788 71.7962C408.681 72.5913 408.626 73.3954 408.624 74.201C408.624 74.5508 408.634 74.8967 408.657 75.2345C408.714 76.2805 408.899 77.3105 409.204 78.2912C409.604 79.5334 410.169 80.4178 410.842 80.865C411.062 81.014 411.302 81.1156 411.55 81.1651C411.798 81.2124 412.051 81.2071 412.297 81.1492C412.417 81.3685 412.499 81.6144 412.54 81.8726C412.581 82.1309 412.579 82.3963 412.535 82.6537C412.525 82.7133 412.515 82.771 412.502 82.8267C412.302 82.8669 412.099 82.8875 411.896 82.8883C411.706 82.8885 411.516 82.8699 411.329 82.8326C410.931 82.7555 410.547 82.5954 410.194 82.3596C409.23 81.7276 408.442 80.5431 407.915 78.9054C407.511 77.608 407.287 76.2388 407.251 74.8529C407.24 74.515 407.236 74.1732 407.251 73.8274C407.266 73.0569 407.324 72.2885 407.426 71.5279C408.193 65.7642 411.114 61.7117 414.073 62.2921C417.032 62.8724 418.734 67.8391 417.971 73.5968Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.495 82.8265C412.302 83.7089 411.699 84.2972 411.099 84.16C410.5 84.0229 410.126 83.2438 410.187 82.3594C410.54 82.5952 410.924 82.7553 411.322 82.8324C411.509 82.8697 411.699 82.8883 411.889 82.8881C412.092 82.8873 412.295 82.8667 412.495 82.8265Z",
    fill: "#BA203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.545 81.1653C411.297 81.1158 411.057 81.0143 410.837 80.8652C410.951 80.7602 411.081 80.6845 411.22 80.6428C411.358 80.6011 411.503 80.5942 411.643 80.6228C411.911 80.6862 412.146 80.8756 412.299 81.1495C412.05 81.2083 411.795 81.2136 411.545 81.1653Z",
    fill: "#BA203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.804 64.3175C383.669 65.3432 383.454 66.3513 383.164 67.3286L381.791 66.9569C382.084 66.0158 382.298 65.0409 382.428 64.0473C383.049 59.3847 381.788 55.0937 379.671 54.6803C379.56 54.6581 379.447 54.6468 379.335 54.6465C377.316 54.6465 375.21 58.1008 374.621 62.5169C374.511 63.3309 374.456 64.1545 374.458 64.9794C374.458 65.3292 374.469 65.673 374.492 66.0109C374.553 67.0372 374.736 68.0474 375.036 69.01C375.437 70.2541 376.004 71.1386 376.674 71.5838C376.893 71.7331 377.132 71.8347 377.38 71.8839C377.628 71.9321 377.88 71.9268 378.126 71.8679C378.245 72.0872 378.328 72.3331 378.369 72.5914C378.41 72.8496 378.408 73.1151 378.363 73.3725C378.354 73.4321 378.344 73.4898 378.332 73.5454C378.132 73.5857 377.929 73.6062 377.726 73.607C377.536 73.607 377.347 73.5891 377.159 73.5534C376.761 73.4762 376.377 73.3162 376.024 73.0803C375.06 72.4483 374.272 71.2618 373.745 69.6261C373.349 68.346 373.127 66.996 373.09 65.6293C373.076 65.2914 373.072 64.9496 373.078 64.6038C373.091 63.814 373.151 63.0263 373.255 62.2466C374.022 56.4829 376.943 52.4305 379.902 53.0108C382.861 53.5912 384.571 58.5578 383.804 64.3175Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.124 71.8676C377.878 71.9264 377.626 71.9318 377.378 71.8835C377.13 71.8343 376.891 71.7328 376.672 71.5834C376.786 71.4791 376.915 71.4039 377.053 71.3626C377.191 71.3212 377.335 71.3146 377.475 71.3429C377.74 71.4068 377.973 71.5954 378.124 71.8676Z",
    fill: "#BA203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.33 73.5452C378.136 74.4276 377.533 75.0159 376.932 74.8788C376.331 74.7416 375.962 73.9665 376.021 73.0801C376.374 73.3159 376.759 73.476 377.157 73.5531C377.344 73.5888 377.534 73.6067 377.724 73.6067C377.927 73.606 378.129 73.5854 378.33 73.5452Z",
    fill: "#BA203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.638 102.815H409.618C409.562 102.815 409.51 102.793 409.454 102.779L409.638 102.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.559 95.2803C409.492 95.3081 409.426 95.3359 409.359 95.3677L409.423 95.3359L409.559 95.2803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.249 95.0654C410.205 95.0654 410.164 95.0853 410.123 95.0992C410.11 95.0964 410.097 95.0964 410.085 95.0992C410.139 95.0913 410.191 95.0793 410.249 95.0654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.447 100.706L408.545 101.771L406.813 95.9814L405 99.2171C404.929 99.3454 404.884 99.4921 404.869 99.6453C404.854 99.7985 404.869 99.954 404.912 100.099C404.956 100.244 405.027 100.374 405.12 100.48C405.213 100.585 405.325 100.663 405.447 100.706Z",
    fill: "#2C8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.496 92.1635L411.87 101.618C411.107 101.962 410.29 102.094 409.479 102.003C407.841 101.805 406.583 100.749 406.226 99.4198C405.744 97.6151 406.999 95.574 407.181 95.2858C407.227 95.2142 407.272 95.1467 407.318 95.087C407.863 94.3209 408.564 93.7418 409.352 93.4076L431.644 83.669C433.552 82.8343 435.359 84.142 435.663 86.5727L435.781 87.5148C436.027 89.4069 434.995 91.5076 433.496 92.1635Z",
    fill: "#FFC192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.21 83.4126L409.935 93.1516C408.057 93.9726 407.083 96.4849 407.76 98.7628C408.437 101.041 410.508 102.222 412.386 101.401L434.66 91.6619C436.538 90.8409 437.512 88.3287 436.835 86.0507C436.158 83.7727 434.087 82.5916 432.21 83.4126Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.202 87.8469C435.563 87.6878 435.726 87.1213 435.564 86.5817C435.403 86.042 434.979 85.7335 434.617 85.8926C434.256 86.0517 434.094 86.6181 434.255 87.1578C434.416 87.6974 434.84 88.006 435.202 87.8469Z",
    fill: "#2C8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7303 108.09C72.0303 107.16 72.4503 105.43 72.5903 104.31C72.6803 103.61 73.0703 102.98 73.6503 102.56C74.8103 101.73 76.5103 101.73 77.3403 102.89L86.6403 115.4L98.4803 106.6C99.4003 105.73 99.3603 104.2 98.6103 103.12C98.2003 102.54 97.5703 102.15 96.8703 102.05C95.7603 101.9 94.0203 101.47 93.1003 100.16C91.6803 98.1398 92.3003 95.5898 94.5903 93.9798C96.8803 92.3698 99.4903 92.6398 100.91 94.6598C101.83 95.9598 101.65 97.7398 101.42 98.8398C101.27 99.5298 101.42 100.26 101.84 100.84C102.62 101.95 104.1 102.24 105.25 101.57L117.52 92.4498L107.66 79.4498C106.83 78.2898 107.1 76.6798 108.26 75.8598C108.84 75.4498 109.56 75.2798 110.25 75.4298C111.35 75.6598 113.13 75.8198 114.43 74.8998C116.44 73.4598 116.7 70.8498 115.07 68.5698C113.44 66.2898 110.89 65.6798 108.88 67.1198C107.58 68.0498 107.16 69.7798 107.02 70.8998C106.93 71.5998 106.54 72.2298 105.96 72.6498C104.8 73.4798 103.19 73.2098 102.37 72.0498L92.2303 57.8198L61.0503 80.9898L71.9503 95.7598C72.7803 96.9198 72.5103 98.5298 71.3503 99.3498C70.7703 99.7598 70.0503 99.9298 69.3603 99.7798C68.2603 99.5498 66.4803 99.3898 65.1803 100.31C63.1703 101.75 62.9103 104.36 64.5403 106.64C66.1703 108.92 68.7203 109.53 70.7303 108.09Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6303 115.44V115.42L77.3203 102.91C76.6503 101.97 75.0703 101.58 73.6703 102.58C73.0903 102.99 72.7103 103.62 72.6303 104.31C72.4803 105.54 72.0303 107.2 70.7603 108.11C68.7403 109.56 66.1703 108.95 64.5303 106.65C62.8903 104.35 63.1603 101.73 65.1803 100.29C66.4503 99.38 68.1603 99.5 69.3803 99.75C70.0503 99.89 70.7803 99.74 71.3503 99.32C72.4903 98.5 72.7603 96.91 71.9503 95.76L61.0303 80.97H61.0503L92.2503 57.77L92.2703 57.79L102.41 72.02C102.81 72.57 103.39 72.94 104.07 73.05C104.74 73.16 105.42 73.01 105.97 72.61C106.55 72.2 106.93 71.57 107.02 70.88C107.17 69.65 107.62 67.99 108.89 67.08C110.92 65.64 113.48 66.24 115.12 68.54C116.76 70.84 116.49 73.46 114.47 74.9C113.2 75.81 111.49 75.69 110.27 75.44C109.59 75.3 108.87 75.45 108.3 75.87C107.75 76.27 107.38 76.85 107.27 77.52C107.16 78.19 107.31 78.87 107.71 79.42L117.58 92.44L117.56 92.46L105.29 101.58C104.13 102.27 102.62 101.94 101.85 100.85C101.43 100.26 101.28 99.52 101.43 98.83C101.69 97.63 101.82 95.93 100.93 94.67C100.25 93.7 99.2503 93.1 98.1103 92.98C97.9703 92.96 97.8203 92.96 97.6703 92.96C96.6603 92.96 95.6003 93.32 94.6403 94C93.5403 94.78 92.7803 95.82 92.5103 96.92C92.2403 98.03 92.4703 99.17 93.1503 100.15C94.0403 101.41 95.6803 101.87 96.9003 102.03C97.6003 102.12 98.2403 102.51 98.6603 103.11C99.4603 104.25 99.4003 105.79 98.5303 106.62L86.6703 115.44H86.6303ZM75.4503 101.96C75.5103 101.96 75.5703 101.96 75.6203 101.96C76.3503 102 76.9703 102.33 77.3603 102.88L86.6403 115.37L98.4603 106.59C99.3103 105.78 99.3703 104.26 98.5803 103.15C98.1703 102.57 97.5403 102.18 96.8603 102.09C95.6303 101.93 93.9803 101.47 93.0803 100.19C92.3903 99.21 92.1603 98.05 92.4303 96.92C92.7003 95.8 93.4603 94.75 94.5803 93.97C95.6903 93.19 96.9403 92.82 98.0803 92.94C99.2303 93.06 100.24 93.67 100.93 94.66C101.83 95.94 101.7 97.65 101.44 98.86C101.29 99.54 101.44 100.26 101.85 100.84C102.61 101.91 104.09 102.23 105.22 101.56L117.47 92.46L107.63 79.48C106.8 78.31 107.07 76.69 108.24 75.85C108.83 75.43 109.57 75.27 110.25 75.42C111.45 75.67 113.15 75.79 114.41 74.89C116.41 73.46 116.67 70.87 115.05 68.6C113.42 66.32 110.89 65.73 108.89 67.15C107.63 68.05 107.19 69.69 107.04 70.91C106.95 71.61 106.56 72.25 105.97 72.67C105.4 73.07 104.72 73.23 104.03 73.12C103.35 73.01 102.75 72.63 102.34 72.07L92.2203 57.86L61.0803 81L71.9703 95.75C72.8003 96.92 72.5303 98.54 71.3603 99.38C70.7703 99.8 70.0403 99.96 69.3503 99.81C68.1403 99.56 66.4503 99.44 65.1903 100.34C63.1903 101.77 62.9303 104.35 64.5503 106.63C66.1803 108.91 68.7103 109.5 70.7103 108.08C71.9703 107.18 72.4103 105.54 72.5603 104.32C72.6503 103.62 73.0403 102.98 73.6303 102.56C74.1603 102.18 74.8103 101.97 75.4403 101.97L75.4503 101.96Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.67 345.99C475.67 346.13 374.63 346.25 250.01 346.25C125.39 346.25 24.3301 346.13 24.3301 345.99C24.3301 345.85 125.35 345.73 250.01 345.73C374.67 345.73 475.67 345.85 475.67 345.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5 104.35C169.43 104.48 162.22 100.68 153.39 95.87C144.56 91.06 137.46 87.06 137.53 86.93C137.6 86.8 144.81 90.6 153.64 95.41C162.47 100.22 169.57 104.22 169.5 104.35Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.19 19.7798C248.33 19.7798 248.45 28.9798 248.45 40.3298C248.45 51.6798 248.33 60.8798 248.19 60.8798C248.05 60.8798 247.93 51.6798 247.93 40.3298C247.93 28.9798 248.05 19.7798 248.19 19.7798Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09 69.2099C202.97 69.2899 200.02 65.4299 196.48 60.5899C192.95 55.7399 190.18 51.7399 190.3 51.6599C190.42 51.5799 193.37 55.4399 196.91 60.2799C200.44 65.1299 203.21 69.1299 203.09 69.2099Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.36 115.15C327.29 115.02 334.39 111.02 343.22 106.21C352.05 101.4 359.26 97.5998 359.33 97.7298C359.4 97.8598 352.3 101.86 343.47 106.67C334.64 111.48 327.43 115.28 327.36 115.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.11 73.6096C298.99 73.5296 301.76 69.5296 305.29 64.6796C308.82 59.8296 311.78 55.9696 311.9 56.0596C312.02 56.1396 309.25 60.1396 305.71 64.9896C302.18 69.8396 299.22 73.6996 299.1 73.6096H299.11Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.95 219.88C148.82 219.95 148.45 219.52 148.12 218.91C147.79 218.31 147.62 217.76 147.75 217.69C147.88 217.62 148.25 218.05 148.58 218.66C148.91 219.26 149.08 219.81 148.95 219.88Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.76 228.65C153.63 228.72 152.99 227.8 152.33 226.59C151.66 225.38 151.23 224.34 151.35 224.27C151.48 224.2 152.12 225.13 152.78 226.34C153.45 227.55 153.88 228.59 153.76 228.66V228.65Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.73 237.32C158.61 237.39 157.94 236.49 157.25 235.29C156.55 234.1 156.09 233.07 156.22 233C156.34 232.93 157.01 233.84 157.7 235.03C158.39 236.22 158.86 237.25 158.73 237.32Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06 245.79C163.94 245.87 163.23 244.99 162.48 243.83C161.73 242.67 161.21 241.67 161.34 241.59C161.46 241.51 162.17 242.39 162.92 243.55C163.67 244.71 164.18 245.71 164.06 245.79Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.03 253.82C169.92 253.91 169.14 253.1 168.28 252.01C167.42 250.92 166.82 249.96 166.94 249.88C167.06 249.8 167.84 250.6 168.69 251.69C169.54 252.77 170.14 253.73 170.03 253.82Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.15 260.82C177.06 260.93 176.15 260.28 175.11 259.36C174.07 258.44 173.31 257.61 173.41 257.51C173.51 257.41 174.43 258.06 175.45 258.98C176.48 259.89 177.24 260.72 177.15 260.83V260.82Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3 266.61C185.22 266.73 184.23 266.21 183.07 265.44C181.92 264.67 181.05 263.96 181.13 263.84C181.21 263.72 182.21 264.25 183.36 265.01C184.51 265.77 185.37 266.49 185.3 266.61Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08 271.39C194.02 271.52 192.97 271.12 191.73 270.5C190.49 269.87 189.55 269.27 189.62 269.14C189.69 269.01 190.74 269.41 191.97 270.03C193.2 270.65 194.14 271.26 194.08 271.39Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.49 274.75C203.46 274.89 202.33 274.76 201 274.36C199.67 273.96 198.65 273.45 198.7 273.32C198.75 273.18 199.83 273.47 201.15 273.86C202.46 274.26 203.52 274.61 203.49 274.75Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.43 274.94C213.46 275.08 212.36 275.39 210.97 275.5C209.58 275.61 208.45 275.46 208.45 275.32C208.45 275.17 209.57 275.09 210.93 274.98C212.29 274.87 213.41 274.79 213.43 274.94Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.99 272.07C223.05 272.2 222.03 272.7 220.73 273.17C219.42 273.65 218.33 273.92 218.29 273.78C218.25 273.64 219.26 273.15 220.55 272.68C221.84 272.21 222.93 271.94 222.99 272.07Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.97 267.68C232.04 267.81 231.1 268.43 229.87 269.07C228.64 269.71 227.6 270.12 227.53 269.99C227.47 269.86 228.41 269.24 229.63 268.6C230.85 267.96 231.9 267.55 231.97 267.68Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74 262.86C240.81 262.99 239.88 263.63 238.67 264.29C237.46 264.95 236.42 265.39 236.35 265.26C236.28 265.13 237.21 264.49 238.42 263.83C239.63 263.17 240.67 262.73 240.74 262.86Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76 258.55C249.82 258.68 248.85 259.25 247.59 259.82C246.33 260.39 245.27 260.75 245.21 260.62C245.15 260.49 246.12 259.92 247.38 259.35C248.64 258.78 249.71 258.42 249.76 258.55Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.06 254.88C259.11 255.02 258.1 255.52 256.81 256C255.52 256.48 254.43 256.77 254.38 256.63C254.33 256.5 255.33 255.99 256.63 255.51C257.93 255.02 259.01 254.74 259.06 254.88Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.63 251.98C268.66 252.12 267.62 252.53 266.29 252.9C264.96 253.27 263.85 253.45 263.81 253.32C263.77 253.19 264.82 252.77 266.15 252.4C267.48 252.03 268.59 251.84 268.63 251.98Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.45 250.12C278.47 250.26 277.38 250.55 276.02 250.77C274.66 250.99 273.54 251.05 273.51 250.91C273.48 250.77 274.57 250.48 275.94 250.26C277.31 250.04 278.43 249.98 278.45 250.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.43 249.56C288.43 249.7 287.31 249.84 285.94 249.87C284.57 249.9 283.44 249.8 283.44 249.66C283.44 249.52 284.55 249.38 285.93 249.35C287.32 249.32 288.44 249.42 288.43 249.56Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.37 250.55C298.34 250.69 297.22 250.65 295.86 250.46C294.5 250.27 293.41 250 293.42 249.85C293.43 249.71 294.56 249.75 295.93 249.94C297.3 250.13 298.4 250.41 298.37 250.55Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.99 253.24C307.94 253.37 306.84 253.13 305.53 252.7C304.23 252.27 303.2 251.81 303.24 251.67C303.28 251.53 304.38 251.77 305.7 252.21C307.02 252.64 308.05 253.11 307.99 253.24Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.97 257.63C316.89 257.75 315.86 257.32 314.65 256.66C313.44 256 312.52 255.36 312.58 255.23C312.64 255.1 313.68 255.53 314.9 256.2C316.12 256.87 317.05 257.5 316.97 257.63Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.02 263.56C324.92 263.67 323.98 263.05 322.91 262.19C321.84 261.33 321.05 260.53 321.13 260.41C321.21 260.29 322.16 260.91 323.24 261.78C324.32 262.65 325.12 263.45 325.02 263.56Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.79 270.91C331.67 270.99 330.87 270.21 329.99 269.15C329.11 268.09 328.49 267.16 328.59 267.06C328.69 266.96 329.5 267.75 330.39 268.82C331.28 269.89 331.9 270.83 331.79 270.91Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.75 279.57C336.68 279.6 336.51 279.37 336.29 278.97C336.08 278.57 335.79 278.02 335.46 277.42C334.83 276.2 334.42 275.16 334.54 275.08C334.66 275.01 335.28 275.95 335.92 277.19C336.25 277.8 336.49 278.38 336.62 278.82C336.76 279.26 336.81 279.54 336.75 279.56V279.57Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.3 289.22C339.15 289.24 338.92 288.14 338.65 286.8C338.39 285.45 338.21 284.35 338.35 284.31C338.49 284.27 338.9 285.33 339.16 286.7C339.43 288.07 339.44 289.2 339.3 289.22Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13 299.19C338.99 299.17 339.06 298.05 339.18 296.69C339.3 295.33 339.42 294.22 339.57 294.22C339.71 294.22 339.82 295.35 339.7 296.74C339.58 298.13 339.28 299.22 339.14 299.2L339.13 299.19Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 308.72C336.07 308.66 336.45 307.61 336.94 306.33C337.44 305.05 337.86 304.02 338 304.06C338.14 304.1 337.93 305.22 337.42 306.52C336.92 307.82 336.32 308.79 336.19 308.73L336.2 308.72Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.33 315.12C332.22 315.03 332.44 314.51 332.84 313.95C333.23 313.39 333.65 313 333.77 313.08C333.89 313.16 333.66 313.68 333.26 314.25C332.86 314.82 332.44 315.21 332.33 315.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.061 224.768C141.655 225.023 141.349 225.406 141.192 225.853C141.035 226.3 141.036 226.785 141.196 227.227C141.299 227.499 141.43 227.759 141.587 228.004C142.644 229.678 144.746 233.138 145.158 233.816C145.206 233.895 145.251 233.975 145.308 234.047C145.601 234.416 146.774 235.489 149.926 234.289C152.755 233.212 157.351 230.581 159.952 228.374C161.105 227.395 161.361 225.647 160.572 224.208C159.242 221.783 157.144 218.706 156.787 218.185C156.751 218.133 156.718 218.083 156.68 218.032C156.464 217.739 155.611 216.727 154.406 217.143C153.202 217.562 144.487 223.193 142.061 224.768Z",
    fill: "url(#paint0_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.127 209.409C130.833 213.234 132.244 215.83 137.453 220.034C137.764 220.284 140.364 223.698 141.709 225.475C141.945 225.788 142.278 226.017 142.659 226.129C143.04 226.241 143.448 226.23 143.825 226.098C147.312 224.87 152.444 222.518 154.912 218.957C155.019 218.804 155.085 218.628 155.105 218.444C155.126 218.26 155.098 218.075 155.027 217.905C154.927 217.667 154.808 217.395 154.685 217.115C154.078 215.735 153.662 214.279 153.448 212.786C153.035 209.9 152.246 204.928 151.325 202.084C150.115 198.335 149.396 198.175 146.495 191.788C143.849 185.967 141.094 178.732 140.147 176.203C140.105 176.089 140.038 175.985 139.951 175.899C139.863 175.814 139.758 175.748 139.642 175.706C139.526 175.664 139.402 175.648 139.278 175.658C139.154 175.668 139.034 175.704 138.925 175.764L138.189 176.165C137.825 176.363 137.541 176.679 137.386 177.059C137.231 177.438 137.215 177.857 137.34 178.244L140.987 189.55",
    fill: "#FF8666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.554 200.022C147.568 200.058 147.569 200.098 147.555 200.134C147.542 200.17 147.515 200.201 147.48 200.219C147.446 200.237 147.406 200.242 147.368 200.232C147.33 200.223 147.297 200.2 147.276 200.168C146.455 199.027 145.345 198.311 144.486 198.055C144.297 197.998 144.103 197.957 143.907 197.932C143.878 197.929 143.851 197.918 143.829 197.9C143.806 197.883 143.789 197.859 143.78 197.832L142.612 194.543C142.6 194.513 142.599 194.479 142.608 194.448C142.617 194.416 142.636 194.388 142.663 194.368C142.689 194.348 142.721 194.336 142.754 194.334C142.787 194.333 142.82 194.341 142.847 194.359C144.209 195.221 145.379 196.343 146.291 197.659C146.801 198.397 147.224 199.19 147.554 200.022Z",
    fill: "#DB543A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.653 216.654C139.5 215.27 137.927 210.323 137.445 208.274C137.322 207.753 137.621 207.242 138.123 207.052C138.777 206.806 139.498 207.201 139.599 207.893C139.652 208.254 139.696 208.617 139.73 208.981C139.889 211.974 141.513 214.453 143.955 216.036C144.027 216.081 144.079 216.15 144.102 216.23C144.125 216.311 144.117 216.397 144.08 216.473C144.043 216.549 143.979 216.609 143.901 216.643C143.822 216.676 143.734 216.68 143.653 216.654Z",
    fill: "#DB543A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.922 164.626L114.529 169.268C112.515 169.918 111.399 172.044 112.035 174.018L122.928 207.787C123.565 209.761 125.713 210.834 127.727 210.185L142.12 205.542C144.133 204.892 145.249 202.766 144.613 200.792L133.72 167.023C133.083 165.05 130.935 163.976 128.922 164.626Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.309 206.127L127.916 210.77C126.79 211.132 125.569 211.041 124.522 210.518C123.475 209.994 122.686 209.081 122.329 207.979L111.436 174.21C111.082 173.107 111.189 171.905 111.733 170.869C112.277 169.832 113.214 169.045 114.339 168.681L128.732 164.038C129.858 163.676 131.078 163.767 132.125 164.291C133.173 164.814 133.962 165.727 134.319 166.829L145.21 200.594C145.566 201.698 145.46 202.9 144.916 203.938C144.372 204.975 143.434 205.763 142.309 206.127ZM114.718 169.855C114.318 169.984 113.946 170.189 113.625 170.459C113.303 170.728 113.038 171.056 112.845 171.425C112.651 171.794 112.533 172.196 112.497 172.607C112.461 173.019 112.507 173.433 112.634 173.825L123.524 207.589C123.78 208.381 124.346 209.038 125.099 209.414C125.851 209.789 126.728 209.854 127.536 209.593L141.929 204.951C142.737 204.69 143.411 204.125 143.802 203.38C144.193 202.636 144.269 201.772 144.013 200.98L133.121 167.212C132.865 166.42 132.299 165.763 131.547 165.387C130.794 165.012 129.918 164.947 129.109 165.208L114.718 169.855Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.565 205.448C136.741 204.746 137.947 202.448 137.259 200.315C136.571 198.182 134.249 197.022 132.073 197.724C129.897 198.426 128.691 200.724 129.379 202.857C130.067 204.99 132.389 206.15 134.565 205.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.153 204.171C135.609 203.701 136.417 202.163 135.956 200.735C135.496 199.307 133.941 198.531 132.485 199.001C131.028 199.471 130.221 201.009 130.681 202.437C131.142 203.865 132.696 204.641 134.153 204.171Z",
    fill: "#7B6AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.321 203.452C149.804 204.446 149.875 205.584 149.605 206.656L148.43 211.324C147.622 214.535 143.91 216.099 142.014 213.384C141.22 212.248 140.487 210.845 139.963 209.132C139.731 208.343 139.545 207.541 139.404 206.731C139.33 206.289 139.262 205.888 139.212 205.629C139.196 205.533 139.156 205.443 139.096 205.366C139.035 205.289 138.956 205.229 138.865 205.191C137.911 204.82 134.809 203.413 133.492 200.387C132.477 198.042 134.183 195.119 135.114 195.32C135.985 195.508 140.27 198.582 142.857 197.856C143.132 197.779 143.904 197.751 144.503 197.741C144.781 197.743 145.054 197.801 145.306 197.913C145.559 198.025 145.784 198.187 145.968 198.39C146.733 199.186 148.023 200.776 149.321 203.452Z",
    fill: "#FF8666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.419 175.456L118.243 179.706C118.063 179.764 117.963 179.954 118.02 180.13L123.605 197.446C123.662 197.622 123.854 197.718 124.034 197.66L137.211 193.41C137.391 193.352 137.49 193.162 137.433 192.986L131.848 175.67C131.791 175.494 131.599 175.398 131.419 175.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.412 181.238C117.368 181.252 117.32 181.248 117.278 181.228C117.237 181.207 117.206 181.172 117.192 181.128L116.712 179.643C116.63 179.386 116.655 179.107 116.781 178.866C116.908 178.625 117.126 178.442 117.387 178.357L118.903 177.868C118.948 177.854 118.995 177.858 119.037 177.879C119.078 177.899 119.109 177.935 119.123 177.979C119.137 178.022 119.133 178.069 119.111 178.11C119.09 178.151 119.053 178.182 119.009 178.197L117.493 178.686C117.321 178.741 117.177 178.862 117.093 179.021C117.009 179.181 116.993 179.365 117.048 179.535L117.527 181.02C117.541 181.064 117.536 181.111 117.515 181.152C117.493 181.192 117.456 181.223 117.412 181.238Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.576 176.024C133.532 176.038 133.484 176.035 133.442 176.014C133.401 175.994 133.37 175.958 133.356 175.915L132.876 174.429C132.822 174.26 132.701 174.119 132.54 174.039C132.379 173.958 132.192 173.945 132.019 174L130.503 174.489C130.459 174.503 130.411 174.499 130.37 174.479C130.328 174.458 130.297 174.422 130.283 174.379C130.269 174.335 130.274 174.288 130.295 174.247C130.316 174.206 130.353 174.175 130.397 174.161L131.913 173.672C132.174 173.588 132.458 173.609 132.702 173.73C132.945 173.852 133.129 174.064 133.212 174.321L133.691 175.807C133.705 175.85 133.7 175.897 133.679 175.938C133.657 175.979 133.62 176.009 133.576 176.024Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.549 194.244L137.033 194.733C136.988 194.746 136.941 194.743 136.899 194.722C136.858 194.701 136.827 194.665 136.813 194.622C136.799 194.579 136.803 194.531 136.825 194.49C136.846 194.45 136.883 194.418 136.927 194.404L138.443 193.915C138.615 193.859 138.76 193.738 138.843 193.579C138.927 193.42 138.943 193.235 138.888 193.066L138.409 191.581C138.395 191.538 138.4 191.49 138.421 191.449C138.443 191.408 138.48 191.377 138.524 191.363C138.569 191.349 138.617 191.352 138.658 191.373C138.699 191.394 138.731 191.43 138.745 191.473L139.224 192.958C139.306 193.214 139.281 193.494 139.155 193.735C139.028 193.976 138.81 194.159 138.549 194.244Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.539 198.44L124.023 198.929C123.762 199.013 123.478 198.992 123.234 198.87C122.991 198.748 122.807 198.536 122.724 198.28L122.245 196.795C122.231 196.752 122.236 196.704 122.257 196.663C122.279 196.622 122.316 196.591 122.36 196.577C122.404 196.562 122.453 196.566 122.494 196.587C122.535 196.607 122.567 196.643 122.581 196.687L123.06 198.172C123.114 198.341 123.235 198.481 123.396 198.562C123.557 198.642 123.745 198.656 123.917 198.6L125.433 198.111C125.477 198.097 125.525 198.101 125.567 198.122C125.608 198.142 125.639 198.178 125.653 198.222C125.667 198.265 125.662 198.312 125.641 198.353C125.62 198.394 125.583 198.425 125.539 198.44Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.894 199.271C135.324 199.027 135.581 198.636 136.16 198.859C136.875 199.134 137.605 199.307 138.261 199.192C138.422 199.163 138.538 199.336 138.391 199.408C137.625 199.757 136.726 199.628 135.894 199.271Z",
    fill: "#DB543A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.618 188.911C124.787 189.179 124.097 188.784 123.805 187.877C123.513 186.971 123.839 186.239 124.67 185.971C125.497 185.704 126.193 186.107 126.486 187.013C126.778 187.919 126.445 188.644 125.618 188.911ZM125.512 188.581C126.105 188.39 126.321 187.845 126.093 187.139C125.864 186.429 125.369 186.11 124.776 186.301C124.183 186.492 123.968 187.041 124.197 187.751C124.425 188.457 124.919 188.772 125.512 188.581ZM129.176 185.476L128.775 185.606C128.559 185.293 128.2 185.196 127.837 185.314C127.282 185.493 127.092 186.033 127.321 186.743C127.55 187.453 128.013 187.774 128.573 187.594C128.923 187.48 129.149 187.209 129.16 186.828L129.565 186.697C129.58 187.287 129.218 187.75 128.675 187.925C127.881 188.181 127.222 187.78 126.928 186.87C126.636 185.964 126.941 185.238 127.743 184.98C128.29 184.803 128.855 184.953 129.176 185.476ZM130.332 187.335L129.416 184.496L130.439 184.166C131.036 183.973 131.516 184.159 131.674 184.652C131.78 184.978 131.695 185.259 131.467 185.466C131.677 185.49 131.823 185.614 131.985 185.871L132.47 186.645L132.065 186.776L131.637 186.066C131.439 185.738 131.276 185.717 130.933 185.827L130.332 186.021L130.716 187.211L130.332 187.335ZM130.531 184.481L129.901 184.685L130.231 185.708L130.853 185.507C131.229 185.386 131.386 185.114 131.285 184.801C131.183 184.488 130.899 184.363 130.531 184.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2715 323.994L124.418 288.214L166.884 313.476L106.737 349.255L64.2715 323.994Z",
    fill: "#2B34A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 282.083L122.147 246.304V284.307L62 320.086V282.083Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.5157,
    height: 35.8626,
    transform: "matrix(0.859433 0.511248 0 1 122.146 246.303)",
    fill: "url(#paint1_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.028 248.143L142.57 254.414L144.485 255.553L153.111 260.685V300.205L132.028 287.664V248.143Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.853 243.254L132.484 257.312L136.777 259.866L156.115 271.37V310.89L108.853 282.775V243.254Z",
    fill: "#F2B710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.939 241L125.571 255.058L129.864 257.611L149.202 269.115V308.636L101.939 280.521V241Z",
    fill: "url(#paint2_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3075 251.103L118.939 265.161L123.232 267.715L142.57 279.219L139.15 318.739L91.8867 290.624L95.3075 251.103Z",
    fill: "#4853DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7202 254.359L114.352 268.417L118.645 270.97L137.983 282.474V321.995L90.7202 293.88V254.359Z",
    fill: "#FFF3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4258 256.424L109.057 270.482L113.35 265.204L132.689 276.708L137.003 324.06L89.7404 295.945L85.4258 256.424Z",
    fill: "url(#paint3_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1654 262.165L99.7969 276.223L104.09 278.777L123.428 290.281L120.008 329.801L72.7446 301.686L76.1654 262.165Z",
    fill: "#BF2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5791 265.42L95.2106 279.478L99.5036 282.031L118.842 293.535V333.056L71.5791 304.941V265.42Z",
    fill: "#FFF3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2852 267.485L89.9166 281.543L94.2097 276.265L113.548 287.769L117.863 335.121L70.5998 307.006L66.2852 267.485Z",
    fill: "url(#paint4_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.902 310.519L169 274.174V311.492C169 312.596 168.23 313.949 167.281 314.514L107.902 349.836V310.519Z",
    fill: "url(#paint5_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 282.083L108.853 309.954V349C108.853 350.105 108.083 350.542 107.134 349.977L63.7189 324.151C62.7696 323.587 62 322.234 62 321.129V282.083Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.2852,
    height: 7.90089,
    rx: 3.95044,
    transform: "matrix(0.859433 0.511248 0 1 72.7437 298.478)",
    fill: "url(#paint6_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.466 207.819L397.229 250.608L366.231 252.086L327.468 209.298L344.32 205.3L358.466 207.819Z",
    fill: "url(#paint7_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.476 207.793L397.24 250.582L383.289 247.594L366.242 252.061L327.478 209.272L344.33 205.275L358.476 207.793Z",
    fill: "url(#paint8_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.419 164.797L403.195 207.6L397.233 250.58L359.139 208.566L364.419 164.797Z",
    fill: "url(#paint9_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.387 164.785L403.163 207.587L366.232 252.128L327.456 209.326L364.387 164.785Z",
    fill: "url(#paint10_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.367 164.705L403.444 207.368L376.065 240.483L336.381 198.444L364.367 164.705Z",
    fill: "#7F0505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.406 163.891L401.484 206.554L374.104 239.67L334.421 197.63L362.406 163.891Z",
    fill: "url(#paint11_linear_938_723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.392 164.719L362.431 163.905L364.006 165.65L364.392 164.719Z",
    fill: "#7F0505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.055 240.469L374.101 239.658L374.665 238.976L376.055 240.469Z",
    fill: "#7F0505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.34 197.581C390.897 196.241 391.917 195.02 393.091 194.13C394.263 193.241 395.555 192.703 396.713 192.647C397.871 192.592 398.759 193.026 399.226 193.838C399.692 194.649 399.72 195.82 399.164 197.16C398.686 198.31 397.866 199.373 396.902 200.214L397.469 200.845C398.723 199.81 399.756 198.498 400.334 197.104C400.967 195.581 400.952 194.212 400.39 193.233C399.827 192.254 398.699 191.647 397.097 191.723C395.495 191.8 393.806 192.542 392.391 193.615C390.977 194.688 389.803 196.113 389.17 197.637C388.537 199.161 388.552 200.529 389.115 201.508C389.677 202.487 390.806 203.094 392.407 203.018C392.535 203.012 392.664 203.002 392.793 202.987C393.116 202.578 392.971 202.267 392.711 202.097C391.592 202.129 390.734 201.696 390.278 200.904C389.812 200.092 389.784 198.921 390.34 197.581Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.707 193.613C387.263 192.273 388.284 191.052 389.457 190.162C390.63 189.273 391.921 188.735 393.079 188.68C394.237 188.624 395.125 189.058 395.592 189.87C396.059 190.682 396.086 191.852 395.53 193.192C395.052 194.343 394.233 195.405 393.268 196.246L393.835 196.877C395.089 195.842 396.122 194.531 396.701 193.137C397.333 191.613 397.319 190.244 396.756 189.266C396.193 188.287 395.065 187.679 393.463 187.755C391.861 187.832 390.173 188.574 388.758 189.647C387.343 190.72 386.169 192.145 385.536 193.669C384.903 195.193 384.918 196.561 385.481 197.54C386.044 198.519 387.172 199.127 388.774 199.05C388.902 199.044 389.03 199.034 389.159 199.019C389.482 198.611 389.337 198.299 389.077 198.129C387.958 198.161 387.1 197.728 386.645 196.936C386.178 196.124 386.15 194.953 386.707 193.613Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.189 174.575C369.745 173.235 370.766 172.014 371.939 171.124C373.112 170.234 374.404 169.696 375.562 169.641C376.72 169.586 377.608 170.02 378.074 170.831C378.541 171.643 378.569 172.814 378.012 174.154C377.535 175.304 376.715 176.367 375.75 177.207L376.317 177.838C377.572 176.804 378.604 175.492 379.183 174.098C379.816 172.574 379.801 171.206 379.238 170.227C378.675 169.248 377.547 168.64 375.945 168.717C374.344 168.793 372.655 169.535 371.24 170.609C369.826 171.682 368.651 173.107 368.019 174.631C367.386 176.154 367.401 177.523 367.963 178.501C368.526 179.48 369.654 180.088 371.256 180.012C371.384 180.006 371.513 179.995 371.642 179.981C371.965 179.572 371.819 179.261 371.559 179.09C370.441 179.122 369.583 178.69 369.127 177.897C368.66 177.085 368.633 175.915 369.189 174.575Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.554 170.607C366.111 169.267 367.131 168.047 368.304 167.157C369.477 166.267 370.769 165.729 371.927 165.674C373.085 165.619 373.973 166.053 374.44 166.864C374.906 167.676 374.934 168.847 374.378 170.187C373.9 171.337 373.08 172.399 372.116 173.24L372.682 173.871C373.937 172.836 374.969 171.525 375.548 170.131C376.181 168.607 376.166 167.238 375.604 166.26C375.041 165.281 373.912 164.673 372.311 164.75C370.709 164.826 369.02 165.568 367.605 166.641C366.191 167.714 365.016 169.139 364.384 170.663C363.751 172.187 363.766 173.555 364.328 174.534C364.891 175.513 366.02 176.121 367.621 176.044C367.749 176.038 367.878 176.028 368.007 176.013C368.33 175.605 368.185 175.293 367.925 175.123C366.806 175.155 365.948 174.722 365.492 173.93C365.026 173.118 364.998 171.947 365.554 170.607Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_938_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.343 212.279C366.355 212.849 368.427 213.178 370.516 213.262C369.687 210.925 369.757 208.364 370.711 206.076L371.031 205.304C371.711 203.666 371.713 201.825 371.036 200.186C370.358 198.547 369.058 197.244 367.42 196.564C365.782 195.884 363.941 195.883 362.302 196.56C360.663 197.237 359.36 198.538 358.68 200.176L358.359 200.948C357.412 203.239 355.647 205.096 353.406 206.158C354.917 207.558 356.607 208.796 358.461 209.838M364.343 212.279C362.293 211.7 360.319 210.88 358.461 209.838M364.343 212.279C364.299 212.804 364.131 213.311 363.855 213.759C363.578 214.206 363.199 214.583 362.749 214.856C362.3 215.13 361.792 215.294 361.267 215.334C360.742 215.374 360.215 215.29 359.729 215.088C359.243 214.887 358.811 214.573 358.469 214.172C358.127 213.772 357.884 213.297 357.761 212.785C357.637 212.273 357.636 211.74 357.758 211.228C357.88 210.715 358.121 210.239 358.461 209.838",
    stroke: "#FF4A4A",
    strokeWidth: 1.21578,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.54 320.37V435.99L247.52 482.39V361.44L134.54 320.37Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.99 323.19L360.66 436.34L247.52 482.39V361.44L359.99 323.19Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.66 386.65L280.9 417.82L247.52 361.44L360.42 357.15L360.66 386.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.54 320.37L247.52 281.71L359.99 323.19L247.52 361.44L134.54 320.37Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.97 320.44L247.47 284.34L352.56 323.1L247.53 358.82L141.97 320.44Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.54 320.37V435.99L247.52 482.39V361.44L134.54 320.37Z",
    fill: "#FF4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.54 399.3L212.27 429.52L247.52 361.44C247.52 361.44 133.96 377.14 134.46 377.14C134.96 377.14 134.54 399.3 134.54 399.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.13 412.41L99.5498 369.81L134.54 320.37L247.52 361.44L212.13 412.41Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.13 412.41L99.5498 369.81L134.54 320.37L247.52 361.44L212.13 412.41Z",
    fill: "#FF4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.16 410.03L247.52 361.44L359.99 323.19L393.94 370.36L283.16 410.03Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.16 410.03L247.52 361.44L359.99 323.19L393.94 370.36L283.16 410.03Z",
    fill: "#FF4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.36 324.44C325.96 320.66 321.71 317.47 318.23 318.98C320.7 314.85 320.62 309.33 318.03 305.28C315.44 301.23 310.46 298.84 305.68 299.34C300.9 299.85 296.54 303.23 294.85 307.74C287.68 305.81 279.54 308.06 274.39 313.4L277.75 322.33C280.11 328.1 285.49 332.25 291.37 334.31C297.25 336.37 303.63 336.55 309.85 336.2C313.64 335.99 317.55 335.54 320.86 333.68C324.17 331.82 326.77 328.21 326.36 324.44Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.82 317.5C317.62 318.2 310.87 322.61 307.34 328.93C304.16 322.37 294.33 320.32 288.8 325.06C291.65 317.77 288.49 308.36 281.37 305.08C276.4 302.79 270.12 304.31 266.32 308.06C262.25 301.54 257.98 292.5 256.52 281.7C253.44 259.02 253.84 248.55 253.84 248.55L239.73 250.27C239.73 250.27 239.66 281.7 235.75 295.33C235.26 297.02 234.67 298.67 234 300.26C229.23 297.12 223.32 295.7 217.72 296.9C207.21 299.15 199.42 310.26 200.89 320.92C197.5 318.11 192.66 317.15 188.46 318.47C184.26 319.79 180.83 323.33 179.64 327.57C171.52 320.92 159.7 319.15 149.98 323.12L247.7 358.81L344.4 325.87C339.72 320.35 332.04 316.8 324.83 317.5H324.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.82 317.5C324.82 317.5 325.3 317.45 326.25 317.39C327.2 317.39 328.63 317.39 330.47 317.73C332.3 318.07 334.56 318.72 337.01 319.97C339.44 321.23 342.12 323.07 344.46 325.81L344.56 325.92L344.42 325.97C324.48 332.79 290.59 344.38 247.76 359.02L247.69 359.04L247.62 359.01C218.99 348.56 185.71 336.42 149.89 323.35L149.27 323.12L149.89 322.87C154.58 320.96 159.92 320.32 165.17 321.06C170.41 321.79 175.59 323.9 179.81 327.35L179.39 327.48C180.46 323.58 183.59 319.97 187.71 318.43C192.18 316.76 197.43 317.7 201.05 320.69L200.63 320.93C200.37 318.81 200.44 316.67 200.8 314.58C201.16 312.49 201.9 310.49 202.81 308.61C203.72 306.71 204.95 305 206.32 303.43C207.69 301.85 209.3 300.51 211.04 299.39C211.9 298.8 212.84 298.37 213.76 297.9C214.72 297.53 215.67 297.11 216.68 296.88C218.66 296.3 220.73 296.12 222.77 296.22C226.85 296.43 230.79 297.83 234.14 300.02L233.77 300.13C235.51 296.1 236.42 291.83 237.08 287.59C237.73 283.34 238.16 279.1 238.49 274.9C239.12 266.5 239.42 258.26 239.49 250.25V250.04L239.7 250.01C244.49 249.43 249.19 248.86 253.81 248.29L254.07 248.26V248.53C254 254.18 254.4 259.73 254.86 265.12C255.34 270.51 255.94 275.77 256.62 280.86C257.88 291.07 261.69 300.25 266.48 307.93L266.19 307.9C268.94 305.23 272.65 303.82 276.23 303.8C278.02 303.78 279.79 304.17 281.37 304.87C282.94 305.6 284.33 306.63 285.49 307.83C287.83 310.24 289.15 313.32 289.72 316.33C289.97 317.85 290.03 319.37 289.91 320.85C289.77 322.33 289.41 323.74 288.92 325.07L288.7 324.91C290.35 323.53 292.33 322.75 294.27 322.46C296.22 322.17 298.14 322.34 299.88 322.83C303.37 323.8 306.1 326.12 307.43 328.84H307.25C308.98 325.77 311.24 323.52 313.38 321.9C315.55 320.29 317.63 319.3 319.35 318.66C321.08 318.03 322.47 317.78 323.4 317.61C324.33 317.49 324.81 317.45 324.81 317.45C324.81 317.45 324.33 317.53 323.4 317.66C322.48 317.84 321.1 318.11 319.38 318.75C317.67 319.39 315.61 320.4 313.46 322.01C311.34 323.63 309.12 325.88 307.41 328.92L307.32 329.09L307.23 328.92C305.92 326.26 303.23 324 299.8 323.05C298.09 322.57 296.21 322.41 294.3 322.7C292.4 322.99 290.47 323.76 288.87 325.11L288.47 325.45L288.65 324.95C289.13 323.64 289.47 322.25 289.61 320.8C289.72 319.35 289.66 317.86 289.41 316.36C288.84 313.4 287.54 310.38 285.25 308.03C284.12 306.86 282.76 305.86 281.23 305.15C279.69 304.47 277.97 304.1 276.23 304.12C272.74 304.14 269.12 305.53 266.45 308.13L266.28 308.29L266.16 308.09C261.34 300.38 257.49 291.15 256.2 280.88C255.51 275.78 254.9 270.52 254.41 265.12C253.94 259.72 253.53 254.18 253.59 248.48L253.85 248.72C249.23 249.29 244.52 249.86 239.74 250.45L239.95 250.22C239.88 258.25 239.59 266.49 238.97 274.91C238.64 279.12 238.22 283.37 237.56 287.64C236.9 291.9 235.98 296.23 234.22 300.3L234.1 300.58L233.85 300.42C230.57 298.28 226.72 296.91 222.73 296.71C220.74 296.62 218.73 296.79 216.8 297.36C215.82 297.58 214.9 297.99 213.96 298.35C213.06 298.81 212.14 299.23 211.31 299.81C209.61 300.9 208.03 302.21 206.7 303.76C205.36 305.29 204.15 306.97 203.27 308.82C202.38 310.66 201.66 312.61 201.3 314.65C200.95 316.68 200.88 318.77 201.13 320.83L201.21 321.48L200.71 321.06C197.24 318.19 192.17 317.27 187.88 318.88C183.93 320.35 180.91 323.84 179.88 327.58L179.77 327.96L179.46 327.71C175.32 324.32 170.23 322.25 165.07 321.53C159.91 320.8 154.66 321.43 150.06 323.3V322.82C185.86 335.91 219.13 348.08 247.75 358.55H247.61C290.47 344 324.39 332.49 344.34 325.72L344.3 325.88C341.99 323.15 339.34 321.31 336.93 320.05C334.5 318.8 332.26 318.13 330.44 317.78C328.61 317.43 327.19 317.4 326.24 317.39C325.29 317.43 324.81 317.44 324.81 317.44L324.82 317.5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.23 326.45C247.2 324.99 241.81 325.39 236.69 326.49C233.93 327.08 231.38 328.5 228.97 330C226.55 331.5 224.33 334.22 223.5 337.01C228.71 332.14 237.54 328.88 244.57 328.88C251.6 328.88 258.6 331.65 263.81 336.51C261.91 331.48 257.26 327.92 252.22 326.46L252.23 326.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.5 337C223.5 337 223.58 336.87 223.77 336.67C223.97 336.47 224.24 336.16 224.64 335.81C225.41 335.08 226.6 334.1 228.19 333.07C231.34 330.99 236.32 328.81 242.16 328.47C248 328.13 253.2 329.71 256.57 331.42C258.27 332.27 259.57 333.1 260.42 333.73C260.85 334.03 261.16 334.31 261.38 334.48C261.59 334.66 261.7 334.76 261.69 334.77C261.66 334.8 261.19 334.47 260.31 333.89C259.43 333.31 258.12 332.54 256.42 331.74C253.05 330.14 247.93 328.65 242.2 328.98C236.47 329.31 231.56 331.39 228.4 333.37C226.8 334.36 225.59 335.28 224.78 335.95C223.97 336.62 223.54 337.01 223.51 336.98L223.5 337Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.91 307.6C193.89 306.92 192.62 306.26 191.07 307.1C189.81 307.85 188.83 309.14 189.07 310.58C189.19 311.3 189.63 311.94 190.18 312.41C191.11 313.2 192.42 313.56 193.61 313.26C194.8 312.97 195.82 312.01 196.12 310.82C196.42 309.63 195.93 308.27 194.91 307.59V307.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47 271.2C268.45 270.52 267.18 269.86 265.63 270.7C264.37 271.45 263.39 272.74 263.63 274.18C263.75 274.9 264.19 275.54 264.74 276.01C265.67 276.8 266.98 277.15 268.17 276.86C269.36 276.57 270.38 275.61 270.68 274.42C270.98 273.23 270.49 271.87 269.47 271.19V271.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47 271.2C269.47 271.2 269.79 271.29 270.17 271.71C270.54 272.12 270.98 272.9 270.94 273.94C270.91 274.98 270.22 276.19 268.98 276.82C267.75 277.47 266.02 277.31 264.76 276.35C264.13 275.87 263.63 275.22 263.44 274.47C263.25 273.72 263.39 272.94 263.72 272.33C264.05 271.72 264.5 271.25 264.98 270.89C265.45 270.53 265.98 270.27 266.49 270.18C267.54 269.99 268.34 270.4 268.8 270.67C269.27 270.96 269.5 271.17 269.48 271.2C269.46 271.23 269.2 271.08 268.71 270.85C268.23 270.64 267.47 270.33 266.57 270.54C265.7 270.75 264.71 271.49 264.15 272.55C263.88 273.08 263.77 273.73 263.94 274.34C264.1 274.95 264.53 275.52 265.08 275.94C266.19 276.79 267.71 276.94 268.78 276.39C269.87 275.86 270.52 274.82 270.59 273.91C270.67 272.99 270.33 272.25 270.03 271.83C269.72 271.4 269.46 271.23 269.49 271.19L269.47 271.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.579 298.45C176.329 296.96 173.529 295.5 170.119 297.35C167.349 299 165.179 301.83 165.699 305.02C165.959 306.6 166.919 308.01 168.149 309.05C170.209 310.79 173.099 311.57 175.719 310.93C178.339 310.29 180.589 308.18 181.239 305.56C181.889 302.94 180.829 299.94 178.579 298.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.58 298.45C178.58 298.45 178.73 298.52 179 298.69C179.25 298.88 179.63 299.17 180.02 299.65C180.8 300.56 181.71 302.25 181.59 304.48C181.5 306.69 180 309.26 177.36 310.58C174.74 311.95 171.07 311.61 168.37 309.56C167.03 308.54 165.97 307.16 165.56 305.58C165.15 304.01 165.44 302.37 166.13 301.08C166.82 299.78 167.79 298.76 168.81 297.98C169.82 297.19 170.94 296.64 172.03 296.44C173.12 296.23 174.14 296.31 174.98 296.55C175.82 296.78 176.49 297.11 177.02 297.4C177.55 297.69 177.94 297.96 178.2 298.14C178.46 298.33 178.59 298.43 178.58 298.45C178.55 298.49 178 298.11 176.93 297.58C175.89 297.08 174.19 296.34 172.11 296.8C171.09 297.02 170.05 297.54 169.08 298.32C168.11 299.08 167.19 300.08 166.56 301.3C165.93 302.51 165.67 304.02 166.05 305.45C166.43 306.88 167.41 308.18 168.68 309.14C171.22 311.07 174.68 311.41 177.14 310.15C179.64 308.93 181.09 306.53 181.22 304.45C181.38 302.34 180.56 300.69 179.86 299.77C179.14 298.82 178.54 298.49 178.58 298.44V298.45Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52 482.39C247.52 482.39 247.5 482.28 247.49 482.08C247.49 481.84 247.48 481.54 247.47 481.16C247.46 480.32 247.44 479.14 247.43 477.64C247.43 474.54 247.41 470.12 247.4 464.68C247.42 453.74 247.54 438.62 247.72 421.92C247.9 405.23 248.07 390.13 248.19 379.16C248.25 373.72 248.29 369.3 248.33 366.2C248.35 364.7 248.37 363.52 248.38 362.68C248.39 362.3 248.4 362 248.41 361.76C248.41 361.55 248.43 361.45 248.44 361.45C248.45 361.45 248.46 361.56 248.47 361.76C248.47 361.99 248.48 362.3 248.49 362.68C248.5 363.52 248.52 364.7 248.53 366.2C248.53 369.3 248.55 373.72 248.56 379.16C248.54 390.1 248.42 405.22 248.24 421.93C248.06 438.61 247.89 453.71 247.77 464.69C247.71 470.13 247.67 474.55 247.63 477.65C247.61 479.15 247.59 480.33 247.58 481.17C247.57 481.55 247.56 481.85 247.55 482.09C247.55 482.3 247.53 482.4 247.52 482.4V482.39Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.56 142.12C318.92 102.6 287.62 71.0698 248.63 71.7098C209.65 72.3498 177.75 104.91 177.38 144.43C177.12 173.05 193.46 197.46 217.29 208.52C217.21 217 217.12 226.57 217.12 226.57L278.99 225.56C278.99 225.56 279.46 215.42 279.68 206.37C302.52 194.11 318.3 169.84 318.55 142.12H318.56Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.16 146.94C301.67 145.18 302.01 140.9 301.9 138.58C301.79 136.26 301.11 134.96 301.11 134.96C301.11 134.96 301.45 128.27 298.52 127.34L297.28 126.88C297.28 126.88 298.52 126.04 297.17 124C295.82 121.96 296.04 119.45 294.8 117.78C293.59 116.15 292.36 113.29 289.67 113.42C289.73 113.42 289.77 113.42 289.77 113.42C289.77 113.42 289.73 113.42 289.65 113.41C289.64 113.41 289.62 113.41 289.6 113.41C289.57 113.41 289.54 113.41 289.51 113.41C289.62 113.29 290.96 111.8 288.36 108.33C285.65 104.71 285.77 103.32 282.15 102.2C278.54 101.09 277.75 100.34 275.27 98.7597C272.79 97.1797 267.49 91.6997 259.14 93.3697C250.79 95.0397 252.65 101.17 252.4 104.33C252.15 107.49 252.99 112.78 252.4 115.57C251.81 118.36 251.75 122.35 252.4 124.02C253.05 125.69 252.4 134.7 252.4 134.7V160.7C252.4 160.7 251.25 184.38 254.07 186.98C256.89 189.58 262.66 192.74 270.95 190.42C279.23 188.1 281.94 186.15 283.86 184.38C283.86 184.38 290.08 182.15 289.96 176.11C289.96 176.11 292.55 174.81 294.13 172.21C295.71 169.61 297.74 167.85 298.19 165.34C298.64 162.83 297.51 162.18 297.51 162.18C297.51 162.18 298.86 161.81 299.43 158.47C299.99 155.13 301.46 153.27 301.12 151.78C300.78 150.29 299.54 149.18 299.54 149.18C299.54 149.18 300.66 148.72 301.17 146.95L301.16 146.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.86 150.97V134.86C246.86 134.86 246.21 125.85 246.86 124.18C247.51 122.51 247.45 118.52 246.86 115.73C246.27 112.94 247.11 107.65 246.86 104.49C246.61 101.33 248.46 95.1999 240.12 93.5299C231.78 91.8599 226.47 97.3399 223.99 98.9199C221.51 100.5 220.72 101.24 217.11 102.36C213.5 103.47 213.61 104.87 210.9 108.49C208.3 111.96 209.64 113.46 209.75 113.57C209.72 113.57 209.69 113.57 209.66 113.57C209.65 113.57 209.63 113.57 209.61 113.57C209.53 113.57 209.49 113.57 209.49 113.58C209.49 113.58 209.53 113.58 209.59 113.58C206.9 113.45 205.68 116.3 204.46 117.94C203.22 119.61 203.44 122.12 202.09 124.16C200.74 126.2 201.98 127.04 201.98 127.04L200.74 127.5C197.81 128.43 198.15 135.12 198.15 135.12C198.15 135.12 197.47 136.42 197.36 138.74C197.25 141.06 197.59 145.33 198.1 147.1C198.61 148.86 199.73 149.33 199.73 149.33C199.73 149.33 198.49 150.44 198.15 151.93C197.81 153.42 199.28 155.27 199.84 158.62C200.4 161.96 201.76 162.33 201.76 162.33C201.76 162.33 200.63 162.98 201.08 165.49C201.53 168 203.56 169.76 205.14 172.36C206.72 174.96 209.31 176.26 209.31 176.26C209.19 182.3 215.41 184.53 215.41 184.53C217.33 186.29 220.04 188.24 228.32 190.57C236.6 192.89 242.37 189.73 245.2 187.13C248.02 184.53 246.87 160.85 246.87 160.85V150.96L246.86 150.97Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.84 225.34C240.69 202.13 242.08 178.89 241.51 155.69C241.4 151 241.21 146.31 240.71 141.66C240.08 135.82 238.8 129.34 233.44 126.17C231.11 124.79 228.2 124.29 225.59 125.35C223.04 126.38 221.2 128.61 219.97 131.03C217.31 136.22 216.73 142.57 217.51 148.21C219.11 159.74 226.53 169.69 237.44 173.5C248.33 177.3 261.24 174.87 269.85 166.6C278.3 158.49 282.92 144.58 278.93 133.41C277.21 128.59 273.08 123.23 267.37 123.95C261.83 124.65 259.11 130.27 257.88 135.17C256.45 140.85 256.15 146.9 255.69 152.7C255.15 159.47 254.79 166.24 254.51 173.02C253.92 186.97 253.67 200.93 253.08 214.88C252.95 217.96 252.8 221.04 252.62 224.12C252.56 225.16 254.15 225.07 254.21 224.03C255.65 199.34 255.32 174.59 257.51 149.92C257.99 144.48 258.29 138.72 260.02 133.48C260.86 130.93 262.2 128.22 264.49 126.69C266.92 125.07 269.87 125.2 272.23 126.74C277.15 129.96 278.69 136.64 278.67 142.27C278.66 148.09 276.95 153.91 273.93 158.94C267.8 169.15 256.42 174.64 244.92 173.48C233.62 172.35 224.29 164.93 220.56 154.13C218.77 148.96 218.28 143.28 219.37 137.83C220.45 132.4 223.89 124.72 230.63 126.71C237.09 128.61 238.51 136.1 239.14 142.01C239.57 146.11 239.76 150.24 239.88 154.37C240.51 175.86 239.42 197.41 239.25 218.92C239.23 221.1 239.23 223.27 239.25 225.45C239.25 226.49 240.85 226.41 240.84 225.36V225.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.29 257.28C233.29 257.28 235.81 258.9 237.3 260.84C238.07 261.85 239.3 262.39 240.57 262.37L253.02 262.16C254.42 262.14 255.73 261.42 256.52 260.23C257.44 258.84 259.09 257.19 260.8 256.8L233.28 257.27L233.29 257.28Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.11 222.37C220.11 222.62 222.83 242.29 223.87 249.81C224.3 252.9 226.16 255.62 228.96 256.86C229.98 257.32 231.16 257.61 232.5 257.59C237.84 257.5 259.73 257.12 259.73 257.12C259.73 257.12 266.85 257 268.51 251.25C270.26 245.2 273.67 221.45 273.67 221.45L220.11 222.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.86 247.45L222.41 248.48C221.66 248.5 221.06 247.9 221.07 247.14V246.99C221.07 246.23 221.68 245.61 222.43 245.59L271.88 244.56C272.62 244.54 273.23 245.14 273.22 245.9V246.05C273.22 246.81 272.61 247.43 271.86 247.45Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.55 241.23L221.82 242.28C221.07 242.3 220.47 241.7 220.48 240.94V240.79C220.48 240.03 221.09 239.41 221.84 239.39L272.57 238.34C273.32 238.32 273.92 238.92 273.91 239.68V239.83C273.91 240.59 273.3 241.21 272.55 241.23Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64 234.999L220.85 236.099C220.1 236.119 219.5 235.519 219.51 234.759V234.609C219.51 233.849 220.12 233.229 220.87 233.209L273.66 232.109C274.41 232.089 275.01 232.689 275 233.449V233.599C275 234.359 274.39 234.979 273.64 234.999Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64 234.999C273.64 234.999 274.12 235.06 274.63 234.47C274.88 234.18 275 233.7 274.9 233.16C274.79 232.64 274.26 232.129 273.55 232.199C270.63 232.279 266.45 232.389 261.3 232.529C250.93 232.759 236.65 233.08 220.87 233.44C220.46 233.44 220.06 233.7 219.87 234.07C219.69 234.43 219.69 234.939 219.87 235.279C220.06 235.639 220.45 235.86 220.86 235.85C221.34 235.84 221.83 235.83 222.31 235.82C224.23 235.78 226.13 235.74 227.99 235.71C231.71 235.64 235.3 235.569 238.72 235.499C245.56 235.379 251.71 235.269 256.89 235.169C262.04 235.089 266.22 235.03 269.14 234.99C270.56 234.98 271.68 234.97 272.47 234.96C272.83 234.96 273.12 234.96 273.34 234.96C273.53 234.96 273.64 234.959 273.64 234.979C273.64 234.979 273.54 234.999 273.34 235.009C273.12 235.019 272.83 235.03 272.47 235.05C271.68 235.08 270.56 235.11 269.14 235.16C266.22 235.24 262.04 235.35 256.89 235.49C251.71 235.61 245.55 235.759 238.72 235.919C235.3 235.999 231.71 236.07 227.99 236.16C226.13 236.2 224.23 236.239 222.31 236.279C221.83 236.289 221.35 236.299 220.86 236.309C220.3 236.329 219.73 236.009 219.47 235.499C219.34 235.249 219.27 234.949 219.28 234.679C219.28 234.419 219.33 234.1 219.46 233.85C219.72 233.32 220.29 232.96 220.87 232.96C236.64 232.66 250.92 232.39 261.3 232.19C266.45 232.11 270.63 232.049 273.55 232.009C274.33 231.939 274.94 232.539 275.03 233.119C275.13 233.689 274.98 234.22 274.7 234.52C274.43 234.83 274.13 234.93 273.94 234.97C273.74 235.01 273.64 234.99 273.64 234.99V234.999Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.94 210.57C213.94 211.08 214.96 223.14 215.48 229.33C215.67 231.6 216.88 233.63 218.77 234.84L221.53 236.61L274.18 235.71L276.93 233.87C278.86 232.58 280.11 230.48 280.32 228.17L282.04 209.41L213.93 210.58L213.94 210.57Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.3 248.31C228.76 249.38 234.21 249.38 240.21 249.26C245.06 249.16 249.81 249.2 255.07 249.01C258.92 248.87 262.47 248.63 266.32 248.4C268.27 248.29 270.4 247.79 270.79 247.41L223.3 248.31Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.35 242.14C228.81 243.21 234.26 243.21 240.26 243.09C245.1 242.99 249.86 243.03 255.12 242.84C258.97 242.7 262.52 242.46 266.37 242.23C268.32 242.12 270.45 241.62 270.84 241.24L223.35 242.14Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.01 230.75C279.01 230.88 264.93 231.22 247.56 231.52C230.19 231.82 216.11 231.96 216.11 231.83C216.11 231.7 230.19 231.36 247.57 231.06C264.94 230.76 279.02 230.62 279.02 230.75H279.01Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.67 209.05C281.67 209.19 266.38 209.63 247.51 210.03C228.64 210.43 213.34 210.64 213.34 210.5C213.34 210.36 228.63 209.92 247.5 209.52C266.37 209.12 281.67 208.91 281.67 209.05Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.06 92.6599C233.99 89.6199 235.99 86.4599 238.88 83.8899C243.01 80.2199 248.45 78.5099 253.86 78.7699C269.78 79.5299 280.73 84.3299 291.66 96.8399C295.36 101.08 299.71 108.91 299.41 114.92C299.26 117.94 298.04 120.87 295.75 122.87C289.81 128.06 281.49 123.97 276.61 118.63C272.06 113.65 268.43 107.32 262.23 104.69C257.12 102.52 251.25 103.33 245.73 102.58C240.21 101.83 234.18 98.3299 234.05 92.6699L234.06 92.6599Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.38 137.92C292.95 133.21 298.6 130.14 302.4 130.95C305.53 131.71 308.28 133.95 309.52 136.95C311.01 140.57 310.08 145.15 307.2 147.9C304.32 150.64 299.67 151.27 296.35 149.27C293.04 147.27 290.13 141.71 291.39 137.94L291.38 137.92Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_938_723",
    x1: 148.742,
    y1: 218.97,
    x2: 153.334,
    y2: 233.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_938_723",
    x1: 27.2578,
    y1: 0,
    x2: 27.2578,
    y2: 35.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_938_723",
    x1: 125.571,
    y1: 255.058,
    x2: 108.206,
    y2: 284.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#988F60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_938_723",
    x1: 111.215,
    y1: 263.934,
    x2: 82.7874,
    y2: 355.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#3A44B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_938_723",
    x1: 92.0739,
    y1: 274.995,
    x2: 71.2972,
    y2: 339.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_938_723",
    x1: 138.451,
    y1: 292.347,
    x2: 155.726,
    y2: 321.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#340000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_938_723",
    x1: 12.1426,
    y1: 0,
    x2: 12.1426,
    y2: 7.90089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_938_723",
    x1: 385.752,
    y1: 173.584,
    x2: 365.613,
    y2: 293.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_938_723",
    x1: 385.752,
    y1: 173.584,
    x2: 355.066,
    y2: 247.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.574056,
    stopColor: "#8F7D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6544"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_938_723",
    x1: 385.752,
    y1: 173.584,
    x2: 355.066,
    y2: 247.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D341A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_938_723",
    x1: 385.752,
    y1: 173.584,
    x2: 355.066,
    y2: 247.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_938_723",
    x1: 377.22,
    y1: 179.771,
    x2: 344.826,
    y2: 209.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB4949"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_938_723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7472,
    height: 26.7472,
    fill: "white",
    transform: "translate(356.35 188.348) rotate(22.5472)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS1P2New);
export default __webpack_public_path__ + "static/media/HomeS1P2New.eeb22664126bc0fe1b48ea3964e6dca4.svg";
export { ForwardRef as ReactComponent };